<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{
                $t("inicio")
              }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'configuracion' }">{{
                $t("configuracion")
              }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{
                name: 'productos',
                query: { filtro: filtro },
                params: { idBusiness: idBusiness },
              }">
                {{ $t("productos") }}
              </router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ action }} {{ $t("producto") }}
            </li>
          </ol>
        </nav>
        <div class="card">
          <div class="row">
            <div class="col-md-12">
              <h2 class="tituloNumier">
                <i class="fa fa-building"></i> {{ nombreNegocio }}
              </h2>
            </div>
          </div>
          <vue-tabs @tab-change="handleTabChange" v-model="tabs">
            <v-tab :key="'basico'" title="Básico">
              <div class="row">
                <div style="margin-top: 10px" class="col-md-6">
                  <div class="row">
                    <div class="col-md-12">


                      <!--CODIGO BUSINESSCENTRAL-->
                      <div v-if="businessCentral" class="form-group">
                        <label><strong>{{ $t("businessCentralCode") }}</strong></label>
                        <el-input v-model="producto.PLU1" disabled>
                        </el-input>
                      </div>

                      <!-- SUPRACATEGORIA -->
                      <div class="form-group" v-if="mostrarSupraCategorias">
                        <label><strong>SupraCategoría
                            <span v-if="supraCategoriaObligatoria" style="color: red">*</span>
                          </strong></label>
                        <el-select class="select-default" size="large" id="listSupraCategories"
                          v-model="producto.idSupraCategory" filterable placeholder="Ninguna">
                          <el-option class="select-primary" :value="0" label="Ninguna" />
                          <el-option v-for="sc in listSupraCategories" class="select-primary" :value="sc.id"
                            :label="sc.name" :key="sc.id" />
                        </el-select>
                      </div>

                      <!-- CATEGORÍA PRINCIPAL -->
                      <div class="form-group">
                        <label><strong>{{ $t("category") }}</strong></label>

                        <el-select class="select-default" size="large" id="listCategories" v-model="producto.idCategory"
                          filterable
                          :placeholder="loadingCategories ? 'Cargando categorías...' : $t('seleccionaCategoria')">
                          <el-option
                            v-for="category in listCategory.filter(c => (!categoriasSeleccionadas.includes(c.id) || c.id === producto.idCategory) && c.id !== producto.grupoEnlazado)"
                            class="select-primary" :value="category.id" :label="category.name" :key="category.id" />
                        </el-select>
                      </div>

                      <!-- CATEGORÍA ENLAZADA SI ES BUSINESS CENTRAL -->
                      <div v-if="businessCentral" class="form-group">
                        <label><strong>{{ $t("categoriaEnlazada") }}</strong></label>

                        <el-select class="select-default" size="large" id="listCategoriesLinked"
                          v-model="producto.grupoEnlazado" filterable placeholder="Sin categoría enlazada">
                          <!-- OPCIÓN SIN CATEGORÍA ENLAZADA -->
                          <el-option :value="''" label="Sin categoría enlazada" class="select-primary" />
                          <!-- EXCLUIR CATEGORIA PRINCIPAL -->
                          <el-option v-for="category in listCategory.filter(c => c.id !== producto.idCategory)"
                            class="select-primary" :value="category.id" :label="category.name" :key="category.id" />
                        </el-select>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="nameProducto"><strong>{{ $t("nombreProducto") }}
                            <span style="color: red">*</span>
                          </strong></label>
                        <input type="text" class="form-control" :disabled="restriccionBusinessCentral" :class="{
                          'is-valid':
                            producto.nombreProducto.length > 0 &&
                            producto.nombreProducto.length <= maxNameProducts,
                          'is-invalid':
                            producto.nombreProducto.length > maxNameProducts,
                        }" id="nameProducto" v-bind:placeholder="$t('introduzcaNombre')"
                          v-model="producto.nombreProducto" ref="name" />
                        <input type="hidden" v-model="producto.xname" />
                        <small class="form-text text-muted">
                          {{ producto.nombreProducto.length }}/{{ maxNameProducts }}
                        </small>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="descripcionProducto"><strong>{{ $t("descripcion") }}</strong></label>
                        <input type="text" class="form-control" id="descripcionProducto"
                          v-bind:placeholder="$t('introduzcaDescripcion')" v-model="producto.descripcion" />
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="barcodeProducto"><strong>{{ $t("codigoDeBarra") }}</strong></label>
                        <input type="text" class="form-control" id="barcodeProducto"
                          v-bind:placeholder="$t('introduzcaCodigoDeBarras')" v-model="producto.codigoBarras" />

                        <!--<div class="row" style="margin-top:5px"
                              v-if="producto.codigoBarras!==''">
                              <div class="col-md-2">
                                  <input style="width: 100%" v-model="numEtiquetas" type="number"
                                          class="form-control"></input>
                                  <small>Nº etiquetas</small>
                              </div>
                              <div class="col-md-3">
                                  <button @click="descargarCodigos"  class="btn btn-primary">Descargar
                                      códigos
                                  </button>
                              </div>
                          </div>-->
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label><strong>{{ $t("colorBoton") }}</strong></label>
                    </div>

                    <div class=" col-md-2 col-4">
                      <div class="radio">
                        <label>
                          <input v-model="producto.color" type="radio" name="colors" value="amarillo" />
                          <div class="colorWrap" style="background-color: #ffec9f"></div>
                        </label>
                      </div>
                    </div>

                    <div class=" col-md-2 col-4">
                      <div class="radio">
                        <label>
                          <input v-model="producto.color" type="radio" name="colors" value="rojo" />
                          <div class="colorWrap" style="background-color: #ffbbbb"></div>
                        </label>
                      </div>
                    </div>

                    <div class=" col-md-2 col-4">
                      <div class="radio">
                        <label>
                          <input v-model="producto.color" type="radio" name="colors" value="verde" />
                          <div class="colorWrap" style="background-color: #c1ffc1"></div>
                        </label>
                      </div>
                    </div>

                    <div class=" col-md-2 col-4">
                      <div class="radio">
                        <label>
                          <input v-model="producto.color" type="radio" name="colors" value="morado" />
                          <div class="colorWrap" style="background-color: #ffbfff"></div>
                        </label>
                      </div>
                    </div>

                    <div class=" col-md-2 col-4">
                      <div class="radio">
                        <label>
                          <input v-model="producto.color" type="radio" name="colors" value="blanco" />
                          <div class="colorWrap" style="background-color: #FFFFFF"></div>
                        </label>
                      </div>
                    </div>

                    <div class=" col-md-2 col-4">

                      <div class="radio">
                        <label>
                          <input v-model="producto.color" type="radio" name="colors" value="azul" />
                          <div class="colorWrap" style="background-color: #cad3ff"></div>
                        </label>
                      </div>
                    </div>

                    <div class=" col-md-2 col-4">
                      <div class="radio">
                        <label>
                          <input v-model="producto.color" type="radio" name="colors" value="naranja" />
                          <div class="colorWrap" style="background-color: #ffa54a"></div>
                        </label>
                      </div>
                    </div>

                    <div class=" col-md-2 col-4">
                      <div class="radio">
                        <label>
                          <input v-model="producto.color" type="radio" name="colors" value="gris" />
                          <div class="colorWrap" style="background-color: #bbbbbb"></div>
                        </label>
                      </div>
                    </div>

                    <div class=" col-md-2 col-4">
                      <div class="radio">
                        <label>
                          <input v-model="producto.color" type="radio" name="colors" value="negro" />
                          <div class="colorWrap" style="background-color: #000000"></div>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-3">
                      <div class="form-group">
                        <label for="orden"><strong>{{ $t("orden") }}</strong></label>
                        <input type="text" class="form-control" id="orden" v-bind:placeholder="'Orden'"
                          v-model="producto.orden" />
                      </div>
                    </div>

                    <div class="col-md-12" style="margin-top: 20px">
                      <div class="form-group">
                        <label>
                          <strong>{{ $t("baja") }}</strong>
                        </label>
                        <sup>
                          <i v-tooltip.top-center="$i18n.t(
                            'alDarUnProductoDeBajaDesapareceEnElTPVParaSuVentaPeroSigueApareciendoEnLosInformesDeVenta'
                          )
                            " class="fa fa-question-circle"></i>
                        </sup>
                        <el-switch v-model="producto.baja" active-color="#13ce66" inactive-color="#bcbcbc">
                        </el-switch>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group">
                        <label>
                          <strong>{{ $t("descuento") }}</strong>
                        </label>
                        <sup>
                          <i v-tooltip.top-center="$i18n.t(
                            'cuandoUnProductoEsDeTipoDescuentoSuPrecioSeDescuentaDelTotalDeLaCuenta'
                          )
                            " class="fa fa-question-circle"></i>
                        </sup>
                        <el-switch v-model="producto.descuento" active-color="#13ce66" inactive-color="#bcbcbc">
                        </el-switch>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-group">
                        <label>
                          <strong>{{ $t("menu") }}</strong>
                        </label>
                        <sup v-if="producto.id != 0">
                          <i v-tooltip.top-center="$i18n.t(
                            'cuandoUnProductoEsDeTipoMenuSeCreaUnProductoMenuEnElTPV'
                          )
                            " class="fa fa-question-circle"></i>
                        </sup>
                        <sup v-else>
                          <i v-tooltip.top-center="$i18n.t('paraConfigurarUnProductoComoTipoMenu')
                            " class="fa fa-question-circle"></i>
                        </sup>
                        <el-switch v-model="producto.isMenu" active-color="#13ce66" inactive-color="#bcbcbc"
                          :disabled="producto.id == 0" @change="enableMenu()">
                        </el-switch>

                        <!-- <b-form-checkbox v-model="producto.isMenu" name="check-button" switch inline size="lg" @change="enableMenu()">
                            </b-form-checkbox> -->
                      </div>
                    </div>
                    <div class="col-md-3" v-if="producto.isMenu">
                      <div class="form-group">
                        <label>
                          <strong>{{ $t("cerrado") }}</strong>
                        </label>
                        <sup>
                          <i v-tooltip.top-center="'Los menús cerrados no pedirán plato en el TPV. Funcionan como un paquete cerrado de productos.'
                            " class="fa fa-question-circle"></i>
                        </sup>
                        <el-switch v-model="isClosed" active-color="#13ce66" inactive-color="#bcbcbc"
                          @change="cambiarTipoMenu()">
                        </el-switch>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="margin-top: 10px" class="col-md-6">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label><strong>{{ $t("tipoIva") }}</strong></label>
                        <el-select v-if="!listIva" class="select-default" size="large" id="listIVA"
                          v-model="producto.tipoIva" :placeholder="$t('seleccionaIVA')">
                          <el-option v-for="iva in listaTipoIva" class="select-primary" :value="iva" :label="iva"
                            :key="iva + '- tipoIva'">
                          </el-option>
                        </el-select>

                        <el-select v-else class="select-default" size="large" id="listIVA" v-model="producto.tipoIva"
                          :placeholder="$t('seleccionaIVA')">
                          <el-option v-for="i in listIva" class="select-primary" :value="i" :label="i" :key="i + '-i'">
                          </el-option>
                        </el-select>
                        <br><br>
                        <!-- <div class="updateAlert">
                          <strong style="padding:2%"> El cálculo de precios de coste se ha trasladado a la nueva pestaña
                            "Precios de coste"</strong>
                        </div> -->
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-12">
                          <label for="namePrice1"><strong>{{ $t("tarifa1") }}</strong></label>
                        </div>
                        <div class="col-md-1 col-1">
                          <input type="checkbox" :disabled="restriccionBusinessCentral" name="selPrice1" id="selPrice1"
                            style="margin-top:15px; margin-left:10px;" v-model="producto.selPrice1" />
                        </div>
                        <div class="col-md-7 col-10">
                          <div class="form-group">
                            <input type="text" :disabled="restriccionBusinessCentral" class="form-control"
                              id="namePrice1" v-bind:placeholder="$t('tarifa1')" v-model="producto.namePrice1" />
                          </div>
                        </div>

                        <div class="col-md-4 col-12">
                          <div class="form-group">
                            <vue-numeric currency="€" inputmode="decimal" type="text" class="form-control"
                              currency-symbol-position="suffix" :precision="2" v-model="producto.price1"
                              @keydown.native="$methods.evitarComasDecimales"></vue-numeric>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- btn tarifa2-->

                    <!-- fin btn tarifa2-->
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-12">
                          <label for="namePrice2"><strong>{{ $t("tarifa2") }}</strong></label>
                        </div>
                        <div class="col-md-1 col-1">
                          <input type="checkbox" :disabled="restriccionBusinessCentral" name="selPrice2" id="selPrice2"
                            style="margin-top:15px; margin-left:10px;" v-model="producto.selPrice2" />
                        </div>
                        <div class="col-md-7 col-10">
                          <div class="form-group">
                            <input type="text" :disabled="restriccionBusinessCentral" class="form-control"
                              id="namePrice2" v-bind:placeholder="$t('tarifa2')" v-model="producto.namePrice2" />
                          </div>
                        </div>

                        <div class="col-md-4 col-12">
                          <div class="form-group">
                            <vue-numeric currency="€" inputmode="decimal" type="text" class="form-control"
                              currency-symbol-position="suffix" :precision="2" v-model="producto.price2"
                              @keydown.native="$methods.evitarComasDecimales"></vue-numeric>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- btn tarifa3-->

                    <!--fin btn tarifa3-->
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-12">
                          <label for="namePrice3"><strong>{{ $t("tarifa3") }}</strong></label>
                        </div>
                        <div class="col-md-1 col-1">
                          <input type="checkbox" :disabled="restriccionBusinessCentral" name="selPrice3" id="selPrice3"
                            style="margin-top:15px; margin-left:10px;" v-model="producto.selPrice3" />
                        </div>
                        <div class="col-md-7 col-10">
                          <div class="form-group">
                            <input type="text" :disabled="restriccionBusinessCentral" class="form-control"
                              id="namePrice3" v-bind:placeholder="$t('tarifa3')" v-model="producto.namePrice3" />
                          </div>
                        </div>

                        <div class="col-md-4 col-12">
                          <div class="form-group">
                            <vue-numeric currency="€" inputmode="decimal" type="text" class="form-control"
                              currency-symbol-position="suffix" :precision="2" v-model="producto.price3"
                              @keydown.native="$methods.evitarComasDecimales"></vue-numeric>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- btn tarifa4-->

                    <!-- fin btn tarifa4-->
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-12">
                          <label for="namePrice4"><strong>{{ $t("tarifa4") }}</strong></label>
                        </div>
                        <div class="col-md-1 col-1">
                          <input type="checkbox" :disabled="restriccionBusinessCentral" name="selPrice4" id="selPrice4"
                            style="margin-top:15px; margin-left:10px;" v-model="producto.selPrice4" />
                        </div>
                        <div class="col-md-7 col-10">
                          <div class="form-group">
                            <input type="text" :disabled="restriccionBusinessCentral" class="form-control"
                              id="namePrice4" v-bind:placeholder="$t('tarifa4')" v-model="producto.namePrice4" />
                          </div>
                        </div>

                        <div class="col-md-4 col-12">
                          <div class="form-group">
                            <vue-numeric currency="€" inputmode="decimal" type="text" class="form-control"
                              currency-symbol-position="suffix" :precision="2" v-model="producto.price4"
                              @keydown.native="$methods.evitarComasDecimales"></vue-numeric>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-tab>
            <v-tab :key="'avanzado'" title="Avanzado">
              <div class="row">
                <div style="margin-top: 10px" class="col-md-6">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="opcion1"><strong>{{
                          $t("opcionesAlSeleccionarElArticulo")
                        }}</strong></label>
                        <input type="text" class="form-control" id="opcion1" v-bind:placeholder="$t('opcion1')"
                          v-model="producto.opcion1" />
                        <input style="margin-top: 10px" type="text" class="form-control" id="opcion2"
                          v-bind:placeholder="$t('opcion2')" v-model="producto.opcion2" />
                        <input style="margin-top: 10px" type="text" class="form-control" id="opcion3"
                          v-bind:placeholder="$t('opcion3')" v-model="producto.opcion3" />
                        <input style="margin-top: 10px" type="text" class="form-control" id="opcion4"
                          v-bind:placeholder="$t('opcion4')" v-model="producto.opcion4" />
                        <input style="margin-top: 10px" type="text" class="form-control" id="opcion5"
                          v-bind:placeholder="$t('opcion5')" v-model="producto.opcion5" />
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group">
                        <label>
                          <strong>{{ $t("seleccionIngredientes") }}</strong>
                        </label>
                        <sup>
                          <i v-tooltip.top-center="$i18n.t(
                            'alActivarEstaOpcionApareceLosIngredientesDelProductoParaSeleccionarlo'
                          )
                            " class="fa fa-question-circle"></i>
                        </sup>
                        <!-- <el-switch :disabled="businessCentral" v-model="producto.seleccionarIngredientes" active-color="#13ce66"
                          inactive-color="#bcbcbc">
                        </el-switch> -->
                        <el-switch v-model="producto.seleccionarIngredientes" active-color="#13ce66"
                          inactive-color="#bcbcbc">
                        </el-switch>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div v-if="businessCentral" class="form-group">
                        <label>
                          <strong>{{ $t("invertirSeleccionIngredientes") }}</strong>
                        </label>
                        <sup>
                          <i v-tooltip.top-center="$i18n.t(
                            'alActivarEstaOpcionSeInvierteLaSeleccionDeIngredientes'
                          )
                            " class="fa fa-question-circle"></i>
                        </sup>
                        <!-- <el-switch :disabled="businessCentral" v-model="producto.seleccionarIngredientes" active-color="#13ce66"
                          inactive-color="#bcbcbc">
                        </el-switch> -->
                        <el-switch v-model="producto.invertIngredientsSelection" active-color="#13ce66"
                          inactive-color="#bcbcbc">
                        </el-switch>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="numberSubs"><strong>{{
                          $t("numeroDeOpcionales")
                        }}</strong></label>
                        <!-- <input :disabled="businessCentral" type="number" class="form-control" id="numberSubs" max="5"
                          v-bind:placeholder="$t('numOpcionales')" v-model="producto.numOpcionales" /> -->
                        <input type="number" class="form-control" id="numberSubs" max="5"
                          v-bind:placeholder="$t('numOpcionales')" v-model="producto.numOpcionales" />
                      </div>
                    </div>
                  </div>
                </div>

                <div style="margin-top: 30px" class="col-md-6">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <el-switch v-model="producto.precio" active-color="#13ce66" inactive-color="#bcbcbc">
                        </el-switch>

                        <label>
                          <strong>{{ $t("pedirPrecio") }}</strong>
                        </label>
                        <sup>
                          <i v-tooltip.top-center="$i18n.t(
                            'alActivarEstaOpcionPuedeSeleccionarElPrecioDelProductoAlMarcarlo'
                          )
                            " class="fa fa-question-circle"></i>
                        </sup>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group">
                        <el-switch v-model="producto.peso" active-color="#13ce66" inactive-color="#bcbcbc">
                        </el-switch>
                        <label>
                          <strong>{{ $t("pedirPeso") }}</strong>
                        </label>
                        <sup>
                          <i v-tooltip.top-center="$i18n.t(
                            'alActivarEstaOpcionPuedeSeleccionarElPesoDelProductoAlMarcarlo'
                          )
                            " class="fa fa-question-circle"></i>
                        </sup>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group">
                        <el-switch v-model="producto.importe" active-color="#13ce66" inactive-color="#bcbcbc">
                        </el-switch>
                        <label>
                          <strong>{{ $t("pedirImporte") }}</strong>
                        </label>
                        <sup>
                          <i v-tooltip.top-center="$i18n.t(
                            'alActivarEstaOpcionPuedeSeleccionarElImporteDelProductoAlMarcarlo'
                          )
                            " class="fa fa-question-circle"></i>
                        </sup>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group">
                        <el-switch v-model="producto.promocionable" active-color="#13ce66" inactive-color="#bcbcbc">
                        </el-switch>
                        <label>
                          <strong>{{ $t("promocionable") }}</strong>
                        </label>
                        <sup>
                          <i v-tooltip.top-center="''" class="fa fa-question-circle"></i>
                        </sup>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group">
                        <el-switch v-model="producto.mostrarPC" active-color="#13ce66" inactive-color="#bcbcbc">
                        </el-switch>
                        <label>
                          <strong>{{ $t("mostrarPC") }}</strong>
                        </label>
                        <sup>
                          <i v-tooltip.top-center="$i18n.t(
                            'alActivarEstaOpcionElProductoNoApareceraEnNumierTPV'
                          )
                            " class="fa fa-question-circle"></i>
                        </sup>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group">
                        <el-switch v-model="producto.mostrarPDA" active-color="#13ce66" inactive-color="#bcbcbc">
                        </el-switch>
                        <label>
                          <strong>{{ $t("mostrarPDA") }}</strong>
                        </label>
                        <sup>
                          <i v-tooltip.top-center="$i18n.t(
                            'alActivarEstaOpcionElProductoNoApareceraEnLaPda'
                          )
                            " class="fa fa-question-circle"></i>
                        </sup>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group">
                        <el-switch v-model="producto.noImprimir" active-color="#13ce66" inactive-color="#bcbcbc">
                        </el-switch>
                        <label>
                          <strong>{{ $t("noImprimir") }}</strong>
                        </label>
                        <sup>
                          <i v-tooltip.top-center="$i18n.t(
                            'alActivarEstaOpcionElProductoNoSeImprimiraEnElPendienteDeCobroNiEnLaFacturaSimplificada'
                          )
                            " class="fa fa-question-circle"></i>
                        </sup>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="numberPlato"><strong>{{ $t("numeroPlato") }}</strong></label>
                        <vue-numeric type="text" id="numberPlato" class="form-control" :min="0" :max="99"
                          placeholder="0" currency-symbol-position="suffix" v-model="producto.numPlato">
                        </vue-numeric>
                        <!--<input type="number" class="form-control" id="numberPlato" max="5"
                          v-bind:placeholder="$t('numeroPlato')" v-model="producto.numPlato" />-->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-tab>

            <v-tab :key="'modos'" title="Modos" v-if="listModos.length >= 1">
              <div class="col-md-12 container">
                <div class="row">
                  <div class="table-responsive" style="overflow: auto" v-for="(modo, index) in listModos">

                    <div class="form-group">

                      <div class="col-md-2" style="display: inline-block !important;">
                        <strong><del v-if="modo.deshabilitado == 1">{{ modo.nombreModo }}</del>
                          <spam v-else>{{ modo.nombreModo }}</spam>
                        </strong>
                      </div>

                      <div class="col-md-1" style="display: inline-block !important;">
                        <label for="tarifa1"><strong>{{ $t("tarifa1") }}</strong></label>
                        <br v-if="modo.deshabilitado == 1">
                        <vue-numeric currency="€" inputmode="decimal" type="text" id="tarifa1" class="form-control"
                          :read-only="modo.deshabilitado == 1" currency-symbol-position="suffix" :precision="2"
                          v-model="modo.tarifa1" @keydown.native="$methods.evitarComasDecimales">
                        </vue-numeric>
                      </div>

                      <div class="col-md-1" style="display: inline-block !important;">
                        <label for="tarifa2"><strong>{{ $t("tarifa2") }}</strong></label>
                        <br v-if="modo.deshabilitado == 1">
                        <vue-numeric currency="€" inputmode="decimal" type="text" id="tarifa1" class="form-control"
                          :read-only="modo.deshabilitado == 1" currency-symbol-position="suffix" :precision="2"
                          v-model="modo.tarifa2" @keydown.native="$methods.evitarComasDecimales">
                        </vue-numeric>
                      </div>

                      <div class="col-md-1" style="display: inline-block !important;">
                        <label for="tarifa3"><strong>{{ $t("tarifa3") }}</strong></label>
                        <br v-if="modo.deshabilitado == 1">
                        <vue-numeric currency="€" inputmode="decimal" type="text" id="tarifa1" class="form-control"
                          :read-only="modo.deshabilitado == 1" currency-symbol-position="suffix" :precision="2"
                          v-model="modo.tarifa3" @keydown.native="$methods.evitarComasDecimales">
                        </vue-numeric>
                      </div>

                      <div class="col-md-1" style="display: inline-block !important;">
                        <label for="tarifa4"><strong>{{ $t("tarifa4") }}</strong></label>
                        <br v-if="modo.deshabilitado == 1">
                        <vue-numeric currency="€" inputmode="decimal" type="text" id="tarifa1" class="form-control"
                          :read-only="modo.deshabilitado == 1" currency-symbol-position="suffix" :precision="2"
                          v-model="modo.tarifa4" @keydown.native="$methods.evitarComasDecimales">
                        </vue-numeric>
                      </div>

                      <div class="col-md-2" style="display: inline-block !important;">
                        <label><strong>{{ $t("tipoIva") }}</strong></label>
                        <el-select class="select-default" size="large" id="listIVA" :disabled="modo.deshabilitado == 1"
                          v-model="modo.impuesto" :placeholder="$t('seleccionaIVA')">
                          <el-option v-for="iva in listaTipoIva" class="select-primary" :value="iva" :label="iva"
                            :key="iva + '- tipoIva'">
                          </el-option>
                        </el-select>
                      </div>

                      <div class="col-md-1" style="display: inline-block !important;">
                        <div class="form-group">
                          <label>
                            <strong>{{ $t("noMostrar") }}</strong>
                          </label>
                          <el-switch v-model="modo.baja" active-color="#13ce66" inactive-color="#bcbcbc"
                            :disabled="modo.deshabilitado == 1">
                          </el-switch>
                        </div>
                      </div>

                      <div class="col-md-1" style="display: inline-block !important;">
                        <div class="form-group">
                          <label>
                            <strong>{{ $t("deshabilitar") }}</strong>
                          </label>
                          <el-switch v-model="modo.deshabilitado" active-color="#13ce66" inactive-color="#bcbcbc">
                          </el-switch>
                        </div>
                      </div>

                    </div>

                  </div>
                </div>
              </div>
            </v-tab>

            <v-tab :key="'preciosCoste'" title="Precios de coste">
              <!-- CONTINUAR AQUI -->

              <div class="extraAverageInfo">
                <p>Para calcular el Precio de Coste, se suman el coste de las bases, la media de los opcionales y,
                  finalmente, se consideran los extras vendidos de este producto en el último mes para añadir su media
                  al total.</p>
                <p>Por defecto, el cálculo del extra no se incluye en el total. Si desea incluirlo, marque la casilla a
                  continuación.</p>
              </div>

              <!-- btn tarifa 1-->
              <div class="col-md-12">

                <div class="applyExtraAverage">
                  <label>
                    <input type="checkbox" v-model="isExtraAverageChecked" />
                    <strong>Incluir la media de extras en el cálculo</strong>
                  </label>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="precioCoste"><strong>{{ $t("precioCoste") }} con IVA tarifa 1</strong></label>
                      <div class="d-flex align-items-center">
                        <vue-numeric currency="€" inputmode="decimal" type="text" id="precioCoste"
                          class="form-control me-2" currency-symbol-position="suffix" :precision="2"
                          v-model="producto.precioCoste" @keydown.native="$methods.evitarComasDecimales">
                        </vue-numeric>
                        <button @click="calcularCosto(false, isExtraAverageChecked, 1)" v-tooltip.top-center="$t('calcularCostoAPartirDeMateriasPrimas')
                          " class="btn l calculateIcon" style="height: 100%;">
                          <i class="fas fa-calculator"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="precioCosteSinIVA"><strong>{{ $t("precioCoste") }} sin IVA tarifa 1</strong></label>
                      <div class="d-flex align-items-center">
                        <vue-numeric currency="€" inputmode="decimal" type="text" id="precioCosteSinIVA"
                          class="form-control me-2" currency-symbol-position="suffix" :precision="2"
                          v-model="producto.precioCosteSinIVA" @keydown.native="$methods.evitarComasDecimales">
                        </vue-numeric>
                        <button @click="calcularCosto(true, isExtraAverageChecked, 1)" v-tooltip.top-center="$t('calcularCostoAPartirDeMateriasPrimas')
                          " class="btn l calculateIcon" style="height: 100%;">
                          <i class="fas fa-calculator"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--fin btn tarifa 1-->
              <!-- btn tarifa2-->
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="precioCoste"><strong>{{ $t("precioCoste") }} con IVA tarifa 2</strong></label>
                      <div class="d-flex align-items-center">
                        <vue-numeric currency="€" inputmode="decimal" type="text" id="precioCoste"
                          class="form-control me-2" currency-symbol-position="suffix" :precision="2"
                          v-model="producto.precioCoste2" @keydown.native="$methods.evitarComasDecimales">
                        </vue-numeric>
                        <button @click="calcularCosto(false, isExtraAverageChecked, 2)" v-tooltip.top-center="$t('calcularCostoAPartirDeMateriasPrimas')
                          " class="btn l calculateIcon" style="height: 100%;">
                          <i class="fas fa-calculator"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="precioCosteSinIVA"><strong>{{ $t("precioCoste") }} sin IVA tarifa 2</strong></label>
                      <div class="d-flex align-items-center">
                        <vue-numeric currency="€" inputmode="decimal" type="text" id="precioCosteSinIVA"
                          class="form-control me-2" currency-symbol-position="suffix" :precision="2"
                          v-model="producto.precioCosteSinIVA2" @keydown.native="$methods.evitarComasDecimales">
                        </vue-numeric>
                        <button @click="calcularCosto(true, isExtraAverageChecked, 2)" v-tooltip.top-center="$t('calcularCostoAPartirDeMateriasPrimas')
                          " class="btn l calculateIcon" style="height: 100%;">
                          <i class="fas fa-calculator"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- fin btn tarifa2-->

              <!-- btn tarifa3-->
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="precioCoste"><strong>{{ $t("precioCoste") }} con IVA tarifa 3</strong></label>
                      <div class="d-flex align-items-center">
                        <vue-numeric currency="€" inputmode="decimal" type="text" id="precioCoste"
                          class="form-control me-2" currency-symbol-position="suffix" :precision="2"
                          v-model="producto.precioCoste3" @keydown.native="$methods.evitarComasDecimales">
                        </vue-numeric>
                        <button @click="calcularCosto(false, isExtraAverageChecked, 3)" v-tooltip.top-center="$t('calcularCostoAPartirDeMateriasPrimas')
                          " class="btn l calculateIcon" style="height: 100%;">
                          <i class="fas fa-calculator"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="precioCosteSinIVA"><strong>{{ $t("precioCoste") }} sin IVA tarifa 3</strong></label>
                      <div class="d-flex align-items-center">
                        <vue-numeric currency="€" inputmode="decimal" type="text" id="precioCosteSinIVA"
                          class="form-control me-2" currency-symbol-position="suffix" :precision="2"
                          v-model="producto.precioCosteSinIVA3" @keydown.native="$methods.evitarComasDecimales">
                        </vue-numeric>
                        <button @click="calcularCosto(true, isExtraAverageChecked, 3)" v-tooltip.top-center="$t('calcularCostoAPartirDeMateriasPrimas')
                          " class="btn l calculateIcon" style="height: 100%;">
                          <i class="fas fa-calculator"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--fin btn tarifa3-->

              <!-- btn tarifa4-->
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="precioCoste"><strong>{{ $t("precioCoste") }} con IVA tarifa 4</strong></label>
                      <div class="d-flex align-items-center">
                        <vue-numeric currency="€" inputmode="decimal" type="text" id="precioCoste"
                          class="form-control me-2" currency-symbol-position="suffix" :precision="2"
                          v-model="producto.precioCoste4" @keydown.native="$methods.evitarComasDecimales">
                        </vue-numeric>
                        <button @click="calcularCosto(false, isExtraAverageChecked, 4)" v-tooltip.top-center="$t('calcularCostoAPartirDeMateriasPrimas')
                          " class="btn l calculateIcon" style="height: 100%;">
                          <i class="fas fa-calculator"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="precioCosteSinIVA"><strong>{{ $t("precioCoste") }} sin IVA tarifa 4</strong></label>
                      <div class="d-flex align-items-center">
                        <vue-numeric currency="€" inputmode="decimal" type="text" id="precioCosteSinIVA"
                          class="form-control me-2" currency-symbol-position="suffix" :precision="2"
                          v-model="producto.precioCosteSinIVA4" @keydown.native="$methods.evitarComasDecimales">
                        </vue-numeric>
                        <button @click="calcularCosto(true, isExtraAverageChecked, 4)" v-tooltip.top-center="$t('calcularCostoAPartirDeMateriasPrimas')
                          " class="btn l calculateIcon" style="height: 100%;">
                          <i class="fas fa-calculator"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- fin btn tarifa4-->

            </v-tab>
            <v-tab :key="'impresion'" title="Impresión">
              <div class="row">
                <div class="col-md-12">
                  <p class="wrapperTitleImpresion">
                    {{ $t("impresionDeComandas") }}
                  </p>
                </div>

                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{
                          $t("impresoraComandasTPV")
                        }}</strong></label>

                        <el-select class="select-default" size="large" id="impresoraComandasTPV"
                          v-model="producto.printerName" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listPrinter" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{
                          $t("impresoraComandasPDA")
                        }}</strong></label>

                        <el-select class="select-default" size="large" id="impresoraComandasPDA"
                          v-model="producto.printerPDAName" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasPDA')">
                          <el-option v-for="printer in listPrinter" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-12">
                  <p class="wrapperTitleImpresion">
                    {{ $t("copiaDeImpresionDeComandas") }}
                  </p>
                </div>

                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{
                          $t("copiaImpresoraComandasTPV")
                        }}</strong></label>

                        <el-select class="select-default" size="large" id="copiaImpresoraComandasTPV"
                          v-model="producto.printerName2" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listPrinter" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{
                          $t("copiaImpresoraComandasPDA")
                        }}</strong></label>

                        <el-select class="select-default" size="large" id="copiaImpresoraComandasPDA"
                          v-model="producto.printerPDAName2" filterable placeholder="seleccionaImpresoraDeComandasPDA">
                          <el-option v-for="printer in listPrinter" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-12">
                      <p class="wrapperTitleImpresion">
                        {{ $t("monitorDeCocina") }}
                      </p>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{ $t("impresionKDSTPV") }}</strong></label>

                        <el-select class="select-default" size="large" id="impresionKDSTPV"
                          v-model="producto.impresionKDSTPV" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listKds" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{ $t("copiaImpresionKDSTPV") }}</strong></label>

                        <el-select class="select-default" size="large" id="copiaImpresionKDSTPV"
                          v-model="producto.copiaImpresionKDSTPV" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listKds" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{ $t("impresionKDSPDA") }}</strong></label>

                        <el-select class="select-default" size="large" id="impresionKDSPDA"
                          v-model="producto.impresionKDSPDA" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listKds" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{ $t("copiaImpresionKDSPDA") }}</strong></label>

                        <el-select class="select-default" size="large" id="copiaImpresionKDSPDA"
                          v-model="producto.copiaImpresionKDSPDA" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listKds" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <br>
                </div>
                <div class="col-md-12">

                  <div class="row">
                    <div class="col-md-12">
                      <p class="wrapperTitleImpresion">
                        {{ $t("impresionPorPlana") }}
                      </p>
                    </div>


                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{ $t("impresionPlano") + " 1" }}</strong></label>

                        <el-select class="select-default" size="large" id="impresionPlano1"
                          v-model="producto.impresionPlano1" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listPrinter" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{ $t("copiaImpresionPlano") + " 1" }}</strong></label>

                        <el-select class="select-default" size="large" id="copiaImpresionPlano1"
                          v-model="producto.copiaImpresionPlano1" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listPrinter" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{ $t("impresionPlano") + " 2" }}</strong></label>

                        <el-select class="select-default" size="large" id="impresionPlano2"
                          v-model="producto.impresionPlano2" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listPrinter" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{ $t("copiaImpresionPlano") + " 2" }}</strong></label>

                        <el-select class="select-default" size="large" id="copiaImpresionPlano2"
                          v-model="producto.copiaImpresionPlano2" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listPrinter" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{ $t("impresionPlano") + " 3" }}</strong></label>

                        <el-select class="select-default" size="large" id="impresionPlano3"
                          v-model="producto.impresionPlano3" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listPrinter" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{ $t("copiaImpresionPlano") + " 3" }}</strong></label>

                        <el-select class="select-default" size="large" id="copiaImpresionPlano3"
                          v-model="producto.copiaImpresionPlano3" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listPrinter" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="listPlanos.length > 3">
                      <div class="form-group">
                        <label><strong>{{ $t("impresionPlano") + " 4" }}</strong></label>

                        <el-select class="select-default" size="large" id="impresionPlano4"
                          v-model="producto.impresionPlano4" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listPrinter" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="listPlanos.length > 3">
                      <div class="form-group">
                        <label><strong>{{ $t("copiaImpresionPlano") + " 4" }}</strong></label>

                        <el-select class="select-default" size="large" id="copiaImpresionPlano4"
                          v-model="producto.copiaImpresionPlano4" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listPrinter" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="listPlanos.length > 4">
                      <div class="form-group">
                        <label><strong>{{ $t("impresionPlano") + " 5" }}</strong></label>

                        <el-select class="select-default" size="large" id="impresionPlano5"
                          v-model="producto.impresionPlano5" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listPrinter" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="listPlanos.length > 4">
                      <div class="form-group">
                        <label><strong>{{ $t("copiaImpresionPlano") + " 5" }}</strong></label>

                        <el-select class="select-default" size="large" id="copiaImpresionPlano5"
                          v-model="producto.copiaImpresionPlano5" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listPrinter" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="listPlanos.length > 5">
                      <div class="form-group">
                        <label><strong>{{ $t("impresionPlano") + " 6" }}</strong></label>

                        <el-select class="select-default" size="large" id="impresionPlano6"
                          v-model="producto.impresionPlano6" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listPrinter" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="listPlanos.length > 5">
                      <div class="form-group">
                        <label><strong>{{ $t("copiaImpresionPlano") + " 6" }}</strong></label>

                        <el-select class="select-default" size="large" id="copiaImpresionPlano6"
                          v-model="producto.copiaImpresionPlano6" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listPrinter" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="listPlanos.length > 6">
                      <div class="form-group">
                        <label><strong>{{ $t("impresionPlano") + " 7" }}</strong></label>

                        <el-select class="select-default" size="large" id="impresionPlano7"
                          v-model="producto.impresionPlano7" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listPrinter" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="listPlanos.length > 6">
                      <div class="form-group">
                        <label><strong>{{ $t("copiaImpresionPlano") + " 7" }}</strong></label>

                        <el-select class="select-default" size="large" id="copiaImpresionPlano7"
                          v-model="producto.copiaImpresionPlano7" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listPrinter" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="listPlanos.length > 7">
                      <div class="form-group">
                        <label><strong>{{ $t("impresionPlano") + " 8" }}</strong></label>

                        <el-select class="select-default" size="large" id="impresionPlano8"
                          v-model="producto.impresionPlano8" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listPrinter" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="listPlanos.length > 7">
                      <div class="form-group">
                        <label><strong>{{ $t("copiaImpresionPlano") + " 8" }}</strong></label>

                        <el-select class="select-default" size="large" id="copiaImpresionPlano8"
                          v-model="producto.copiaImpresionPlano8" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listPrinter" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                  </div>


                </div>
                <div class="col-md-12">

                  <div class="row">
                    <div class="col-md-12">
                      <p class="wrapperTitleImpresion">
                        {{ $t("impresionPorKDS") }}
                      </p>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{ $t("impresionPlanoKDS") + " 1" }}</strong></label>

                        <el-select class="select-default" size="large" id="impresionPlanoKDS1"
                          v-model="producto.impresionPlanoKDS1" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listKds" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{ $t("copiaImpresionPlanoKDS") + " 1" }}</strong></label>

                        <el-select class="select-default" size="large" id="copiaImpresionPlanoKDS1"
                          v-model="producto.copiaImpresionPlanoKDS1" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listKds" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{ $t("impresionPlanoKDS") + " 2" }}</strong></label>

                        <el-select class="select-default" size="large" id="impresionPlanoKDS2"
                          v-model="producto.impresionPlanoKDS2" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listKds" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{ $t("copiaImpresionPlanoKDS") + " 2" }}</strong></label>

                        <el-select class="select-default" size="large" id="copiaImpresionPlanoKDS2"
                          v-model="producto.copiaImpresionPlanoKDS2" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listKds" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{ $t("impresionPlanoKDS") + " 3" }}</strong></label>

                        <el-select class="select-default" size="large" id="impresionPlanoKDS3"
                          v-model="producto.impresionPlanoKDS3" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listKds" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{ $t("copiaImpresionPlanoKDS") + " 3" }}</strong></label>

                        <el-select class="select-default" size="large" id="copiaImpresionPlanoKDS3"
                          v-model="producto.copiaImpresionPlanoKDS3" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listKds" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="listPlanos.length > 3">
                      <div class="form-group">
                        <label><strong>{{ $t("impresionPlanoKDS") + " 4" }}</strong></label>

                        <el-select class="select-default" size="large" id="impresionPlanoKDS4"
                          v-model="producto.impresionPlanoKDS4" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listKds" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="listPlanos.length > 3">
                      <div class="form-group">
                        <label><strong>{{ $t("copiaImpresionPlanoKDS") + " 4" }}</strong></label>

                        <el-select class="select-default" size="large" id="copiaImpresionPlanoKDS4"
                          v-model="producto.copiaImpresionPlanoKDS4" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listKds" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="listPlanos.length > 4">
                      <div class="form-group">
                        <label><strong>{{ $t("impresionPlanoKDS") + " 5" }}</strong></label>

                        <el-select class="select-default" size="large" id="impresionPlanoKDS5"
                          v-model="producto.impresionPlanoKDS5" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listKds" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="listPlanos.length > 4">
                      <div class="form-group">
                        <label><strong>{{ $t("copiaImpresionPlanoKDS") + " 5" }}</strong></label>

                        <el-select class="select-default" size="large" id="copiaImpresionPlanoKDS5"
                          v-model="producto.copiaImpresionPlanoKDS5" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listKds" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="listPlanos.length > 5">
                      <div class="form-group">
                        <label><strong>{{ $t("impresionPlanoKDS") + " 6" }}</strong></label>

                        <el-select class="select-default" size="large" id="impresionPlanoKDS6"
                          v-model="producto.impresionPlanoKDS6" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listKds" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="listPlanos.length > 5">
                      <div class="form-group">
                        <label><strong>{{ $t("copiaImpresionPlanoKDS") + " 6" }}</strong></label>

                        <el-select class="select-default" size="large" id="copiaImpresionPlanoKDS6"
                          v-model="producto.copiaImpresionPlanoKDS6" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listKds" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="listPlanos.length > 6">
                      <div class="form-group">
                        <label><strong>{{ $t("impresionPlanoKDS") + " 7" }}</strong></label>

                        <el-select class="select-default" size="large" id="impresionPlanoKDS7"
                          v-model="producto.impresionPlanoKDS7" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listKds" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="listPlanos.length > 6">
                      <div class="form-group">
                        <label><strong>{{ $t("copiaImpresionPlanoKDS") + " 7" }}</strong></label>

                        <el-select class="select-default" size="large" id="copiaImpresionPlanoKDS7"
                          v-model="producto.copiaImpresionPlanoKDS7" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listKds" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="listPlanos.length > 7">
                      <div class="form-group">
                        <label><strong>{{ $t("impresionPlanoKDS") + " 8" }}</strong></label>

                        <el-select class="select-default" size="large" id="impresionPlanoKDS8"
                          v-model="producto.impresionPlanoKDS8" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listKds" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="listPlanos.length > 7">
                      <div class="form-group">
                        <label><strong>{{ $t("copiaImpresionPlanoKDS") + " 8" }}</strong></label>

                        <el-select class="select-default" size="large" id="copiaImpresionPlanoKDS8"
                          v-model="producto.copiaImpresionPlanoKDS8" filterable
                          :placeholder="$t('seleccionaImpresoraDeComandasTPV')">
                          <el-option v-for="printer in listKds" class="select-primary" :value="printer.name"
                            :label="printer.name" :key="printer.name">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-tab>
            <v-tab v-if="idProducto" :key="'materiasprimas'" title="Materias primas">
              <div class="row">
                <div class="col-md-12" style="margin-top: 10px">
                  <button class="btn btn-primary" @click="openModalAgregarSubproducto()" :disabled="inProgress"
                    v-if="!restriccionBusinessCentral">
                    <i class="fas fa-search"></i> {{ $t("buscarMateriaPrima") }}
                  </button>
                  <!-- <button class="btn btn-primary" @click="openModalAgregarSubproducto()" :disabled="inProgress" >
                    <i class="fas fa-search"></i> {{ $t("buscarMateriaPrima") }}
                  </button> -->
                  <button class="btn btn-success" @click="openModalNuevoSubproducto()" :disabled="inProgress"
                    v-if="!restriccionBusinessCentral">
                    <i class="fas fa-plus"></i> {{ $t("nuevaMateriaPrima") }}
                  </button>
                  <!-- <button class="btn btn-success" @click="openModalNuevoSubproducto()" :disabled="inProgress">
                    <i class="fas fa-plus"></i> {{ $t("nuevaMateriaPrima") }}
                  </button> -->
                  <button class="btn btn-warning" @click="editSubproduct()" :disabled="inProgress"
                    v-if="!restriccionBusinessCentral">
                    <i class="fas fa-save"></i> {{ $t("guardarMateriaPrima") }}
                  </button>
                  <!-- <button class="btn btn-warning" @click="editSubproduct()" :disabled="inProgress">
                    <i class="fas fa-save"></i> {{ $t("guardarMateriaPrima") }}
                  </button> -->

                  <button class="btn btn-dribbble" @click="openModalCopiarSub()" :disabled="inProgress"
                    v-if="!restriccionBusinessCentral">
                    <i class="fas fa-exchange-alt"></i>
                    {{ $t("copiaMateriaPrima") }}
                  </button>
                  <!-- 
                  <button class="btn btn-dribbble" @click="openModalCopiarSub()" :disabled="inProgress">
                    <i class="fas fa-exchange-alt"></i>
                    {{ $t("copiaMateriaPrima") }}
                  </button> -->

                  <span style="float: right">
                    <button @click="ordenarSubproductos" v-if="ordenarSubproduct" class="btn-success btn-sm">
                      <i class="far fa-save"></i> {{ $t("guardarOrden") }}
                    </button>
                    <input type="checkbox" name="sortProducts" v-model="ordenarSubproduct" id="sortProducts" />
                    <label for="sortProducts" style="cursor:pointer;">
                      <strong>{{ $t("ordenarSubproductos") }}</strong></label>
                  </span>
                </div>

                <div class="col-md-12">
                  <div class="table-responsive">
                    <table class="table table-bordered table-striped">
                      <thead class="thead-dark">
                        <tr>
                          <th>{{ $t("nombre") }}</th>
                          <th width="10%">{{ $t("partesT1") }}</th>
                          <th width="10%">{{ $t("partesT2") }}</th>
                          <th width="10%">{{ $t("partesT3") }}</th>
                          <th width="10%">{{ $t("partesT4") }}</th>
                          <th width="18%">{{ $t("tipo") }}</th>
                          <th v-if="!restriccionBusinessCentral" colspan="2" width="15%">{{ $t("variacion") }}</th>
                          <th v-else width="15%">{{ $t("variacion") }}</th>
                          <th width="5%">{{ $t("coste") }}</th>
                          <th width="5%">{{ $t("costeSinIVA") }}</th>
                          <th width="7%">
                            {{ $t("costeDto") }}. {{ $t("sinIVA") }}
                          </th>
                          <th width="7%">{{ $t("eliminar") }}</th>
                        </tr>
                      </thead>

                      <draggable v-model="listSubproductosByProducts" tag="tbody" :disabled="!ordenarSubproduct"
                        @start="drag = true" @end="drag = false">
                        <tr v-for="p in listSubproductosByProducts">
                          <td>
                            {{ p.name }}
                            <template v-if="p.baja">{{
                              $t("bajaConBrackets")
                            }}</template>
                          </td>
                          <td>
                            <input type="number" v-model="p.partes" class="form-control" @change="p.editado = 1"
                              min="1" />
                          </td>
                          <td>
                            <input type="number" v-model="p.partes2" class="form-control" @change="p.editado = 1"
                              min="1" :disabled="!producto.selPrice2" />
                          </td>
                          <td>
                            <input type="number" v-model="p.partes3" class="form-control" @change="p.editado = 1"
                              min="1" :disabled="!producto.selPrice3" />
                          </td>
                          <td>
                            <input type="number" v-model="p.partes4" class="form-control" @change="p.editado = 1"
                              min="1" :disabled="!producto.selPrice4" />
                          </td>
                          <td>
                            <el-select class="select-default" size="large" v-model="p.tipo"
                              @visible-change="changeTipo(1, p)" @change="(p.editado = 1), changeTipo(2, p)"
                              :placeholder="$t('seleccionaTipo')">
                              <el-option v-for="t in listaTipo" class="select-primary" :value="t.value" :label="t.label"
                                :key="t.value + '-' + t.label">
                              </el-option>
                            </el-select>
                          </td>
                          <td align="center" v-if="!restriccionBusinessCentral">
                            <el-button type="success " size="mini" @click="(p.sumaresta = 'R'), (p.editado = 1)"
                              v-if="p.sumaresta === 'S'" circle>
                              <i class="fas fa-plus"></i>
                            </el-button>
                            <el-button type="danger" v-else @click="(p.sumaresta = 'S'), (p.editado = 1)" size="mini"
                              circle>
                              <i class="fas fa-minus"></i>
                            </el-button>
                          </td>
                          <td align="right">
                            <vue-numeric currency="€" inputmode="decimal" type="text" id="variacion"
                              class="form-control" currency-symbol-position="suffix" :precision="2"
                              @change="p.editado = 1" @keydown.native="$methods.evitarComasDecimales"
                              v-model="p.variacionPrecio"></vue-numeric>
                          </td>
                          <td align="right">
                            {{ getPrecioCompra(p, false) | currency }}
                          </td>
                          <td align="right">
                            {{ getPrecioCompraSinIVA(p, false) | currency }}
                          </td>
                          <td align="right">
                            {{ getPrecioCompraSinIVA(p, true) | currency }}
                            <span style="margin-left: 3px;">
                              <i v-tooltip.top-center="p.dtoCompra + '%'" style="white" class="fa fa-info-circle">
                              </i>
                            </span>
                          </td>
                          <td align="center">
                            <el-button :disabled="restriccionBusinessCentral" @click="eliminarSubproducto(p)" circle>
                              <i class="fas fa-trash-alt"></i>
                            </el-button>
                          </td>
                        </tr>
                      </draggable>

                      <tr class="table-success">
                        <td>
                          <strong>{{ $t("total") }}:</strong>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td align="right">
                          {{ getTotalPrecioCompra(false) | currency }}
                        </td>
                        <td align="right">
                          {{ getTotalPrecioCompraSinIVA(false) | currency }}
                        </td>
                        <td align="right">
                          {{ getTotalPrecioCompraSinIVA(true) | currency }}
                        </td>
                        <td></td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </v-tab>

            <v-tab :key="'crearmateriasprimas'" v-if="!idProducto && !isRetail" :title="$t('crearMateriaPrima')" id="3">
              <div class="row">
                <!--CATEGORIAS-->
                <div class="col-md-4">
                  <div class="form-group">
                    <label><strong>{{ $t("etiqueta") }}</strong></label>

                    <el-select class="select-default" size="large" v-model="subproducto.idTag" filterable
                      :placeholder="$t('seleccionaEtiqueta')">
                      <el-option v-for="category in listEtiquetas" class="select-primary" :value="category.id"
                        :label="category.name" :key="category.name">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <!--PROVEEDORES-->
                <div class="col-md-4">
                  <div class="form-group">
                    <label><strong>{{ $t("proveedor") }}</strong></label>

                    <el-select class="select-default" size="large" v-model="subproducto.idSupplier" filterable
                      :placeholder="$t('seleccionaProveedor')">
                      <el-option v-for="proveedor in listProveedores" class="select-primary" :value="proveedor.id"
                        :label="proveedor.name" :key="proveedor.name">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <!--CASAS-->
                <div class="col-md-4">
                  <div class="form-group">
                    <label><strong>{{ $t("casa") }}</strong></label>

                    <el-select class="select-default" size="large" v-model="subproducto.idCasa" filterable
                      :placeholder="$t('seleccionaCasa')">
                      <el-option v-for="casa in listCasas" class="select-primary" :value="casa.id" :label="casa.name"
                        :key="casa.name">
                      </el-option>
                    </el-select>
                  </div>
                </div>

                <div class="col-md-8">
                  <div class="form-group">
                    <label for="nameCasa"><strong>{{ $t("nombreSubproducto") }} <span>*</span></strong></label>
                    <input type="text" class="form-control" :class="{
                      'is-valid':
                        subproducto.name.length > 0 &&
                        subproducto.name.length <= maxNameSubproducto,
                      'is-invalid':
                        subproducto.name.length > maxNameSubproducto,
                    }" id="nameCasa" v-bind:placeholder="$t('introduzcaNombre')" v-model="subproducto.name"
                      ref="name" />
                    <input type="hidden" v-model="subproducto.xname" />
                    <small class="form-text text-muted">{{ subproducto.name.length }}/50</small>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="codigodebarrasubproducto">
                      <strong>{{ $t("codigoBarra") }}</strong>
                    </label>
                    <input type="text" class="form-control" id="codigodebarrasubproducto"
                      v-bind:placeholder="$t('introduzcaCodigoDeBarras')" v-model="subproducto.codigoBarras" />
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <label for="direccionsubproducto"><strong>{{ $t("descripcion") }}</strong></label>
                            <input type="text" class="form-control" id="direccionsubproducto"
                              v-bind:placeholder="$t('introduzcaDescripcion')" v-model="subproducto.descripcion" />
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="form-group">
                            <label><strong>{{ $t("tipo") }}</strong></label>

                            <el-select class="select-default" size="large" v-model="subproducto.tipo" filterable
                              :placeholder="$t('seleccionaTipo')">
                              <el-option v-for="tipo in listaTipoUn" class="select-primary" :value="tipo" :label="tipo"
                                :key="tipo">
                              </el-option>
                            </el-select>
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="escandalloSubproducto"><strong>{{ $t("escandallo") }}</strong></label>
                            <el-input-number id="escandalloSubproducto" v-model="subproducto.escandallo"
                              style="text-align: left !important;" :min="0" :precision="0" :controls="false"
                              :placeholder="$t('introduzcaEscandallo')" class="align-content-left">
                            </el-input-number>
                          </div>
                        </div>

                        <div class="col-md-12">
                          <div class="row">
                            <div class="col-md-12">
                              <label><strong>{{ $t("colorBoton") }}</strong></label>
                            </div>

                            <div class=" col-md-2 col-4">
                              <div class="radio">
                                <label>
                                  <input v-model="subproducto.color" type="radio" name="colors" value="amarillo" />
                                  <div class="colorWrap" style="background-color: #ffec9f"></div>
                                </label>
                              </div>
                            </div>

                            <div class=" col-md-2 col-4">
                              <div class="radio">
                                <label>
                                  <input v-model="subproducto.color" type="radio" name="colors" value="rojo" />
                                  <div class="colorWrap" style="background-color: #ffbbbb"></div>
                                </label>
                              </div>
                            </div>

                            <div class=" col-md-2 col-4">
                              <div class="radio">
                                <label>
                                  <input v-model="subproducto.color" type="radio" name="colors" value="verde" />
                                  <div class="colorWrap" style="background-color: #c1ffc1"></div>
                                </label>
                              </div>
                            </div>

                            <div class=" col-md-2 col-4">
                              <div class="radio">
                                <label>
                                  <input v-model="subproducto.color" type="radio" name="colors" value="morado" />
                                  <div class="colorWrap" style="background-color: #ffbfff"></div>
                                </label>
                              </div>
                            </div>

                            <div class=" col-md-2 col-4">
                              <div class="radio">
                                <label>
                                  <input v-model="subproducto.color" type="radio" name="colors" value="blanco" />
                                  <div class="colorWrap" style="background-color: #FFFFFF"></div>
                                </label>
                              </div>
                            </div>

                            <div class=" col-md-2 col-4">
                              <div class="radio">
                                <label>
                                  <input v-model="subproducto.color" type="radio" name="colors" value="azul" />
                                  <div class="colorWrap" style="background-color: #cad3ff"></div>
                                </label>
                              </div>
                            </div>

                            <div class=" col-md-2 col-4">
                              <div class="radio">
                                <label>
                                  <input v-model="subproducto.color" type="radio" name="colors" value="naranja" />
                                  <div class="colorWrap" style="background-color: #ffa54a"></div>
                                </label>
                              </div>
                            </div>

                            <div class=" col-md-2 col-4">
                              <div class="radio">
                                <label>
                                  <input v-model="subproducto.color" type="radio" name="colors" value="gris" />
                                  <div class="colorWrap" style="background-color: #bbbbbb"></div>
                                </label>
                              </div>
                            </div>

                            <div class=" col-md-2 col-4">
                              <div class="radio">
                                <label>
                                  <input v-model="subproducto.color" type="radio" name="colors" value="negro" />
                                  <div class="colorWrap" style="background-color: #000000"></div>
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <label for="precioCompraSubproductoSinIva"><strong>{{
                              $t("precioCompraSinIva")
                            }}</strong></label>
                            <!--<input class="form-control" v-model="subproducto.precioCompraSinIva"-->
                            <!--type="number"-->
                            <!--id="precioCompraSubproductoSinIva"-->
                            <!--@change="calculatePrice(subproducto,false)"/>-->

                            <vue-numeric currency="€" inputmode="decimal" type="text" class="form-control"
                              currency-symbol-position="suffix" :precision="4"
                              @blur="calculatePrice(subproducto, false)" v-model="subproducto.precioCompraSinIva"
                              @keydown.native="$methods.evitarComasDecimales"></vue-numeric>
                          </div>
                        </div>

                        <div class="col-md-12">
                          <div class="form-group">
                            <label><strong>{{ $t("tipoIva") }}</strong></label>

                            <el-select v-if="!listIva" class="select-default" size="large" v-model="subproducto.tipoIva"
                              filterable @change="calculatePrice(subproducto, false)"
                              :placeholder="$t('seleccionaIVA')">
                              <el-option v-for="iva in listaTipoIva" class="select-primary" :value="iva" :label="iva"
                                :key="iva">
                              </el-option>
                            </el-select>

                            <el-select v-else class="select-default" size="large" v-model="subproducto.tipoIva"
                              filterable @change="calculatePrice(subproducto, false)"
                              :placeholder="$t('seleccionaIVA')">
                              <el-option v-for="iva in listIva" class="select-primary" :value="iva" :label="iva"
                                :key="iva">
                              </el-option>
                            </el-select>
                          </div>
                        </div>

                        <div class="col-md-12">
                          <div class="form-group">
                            <label for="cuotaIVA"><strong>{{ $t("cuotaIVA") }}</strong></label>
                            <input class="form-control" :value="(
                              subproducto.precioCompra -
                              subproducto.precioCompraSinIva
                            ).toFixed(2)
                              " type="number" disabled id="cuotaIVA" />
                          </div>
                        </div>

                        <div class="col-md-12">
                          <div class="form-group">
                            <label for="precioCompraSubproducto"><strong>{{
                              $t("precioCompraConIva")
                            }}</strong></label>
                            <!--<input class="form-control" v-model="subproducto.precioCompra"-->
                            <!--type="number"-->
                            <!--id="precioCompraSubproducto"-->
                            <!--@keyup="calculatePrice(subproducto,true)"/>-->
                            <vue-numeric currency="€" inputmode="decimal" type="text" class="form-control"
                              currency-symbol-position="suffix" :precision="4" @blur="calculatePrice(subproducto, true)"
                              @keydown.native="$methods.evitarComasDecimales" v-model="subproducto.precioCompra">
                            </vue-numeric>
                          </div>
                        </div>

                        <div class="col-md-12">
                          <div class="form-group">
                            <label for="descuentoCompraSubproducto"><strong>{{
                              $t("descuentoCompra")
                            }}</strong></label><span style="font-size: x-small">
                              {{ $t("porcentaje") }}</span>
                            <input type="number" min="0" class="form-control" id="descuentoCompraSubproducto"
                              placeholder="0%" v-model="subproducto.descuentoCompra" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-12">
                  <hr />
                </div>

                <div class="col-md-2" style="padding-top: 35px">
                  <div class="form-group">
                    <div class="form-group">
                      <label>
                        <strong>{{ $t("guardarEnAlmacen") }}</strong>
                      </label>
                      <el-switch v-model="subproducto.guardarAlmacen" active-color="#13ce66" inactive-color="#bcbcbc">
                      </el-switch>
                    </div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="stockMinimoSubproducto"><strong>{{ $t("unidadesStockMinimo") }}</strong></label>
                    <input type="number" min="0" class="form-control" id="stockMinimoSubproducto"
                      v-bind:placeholder="$t('introduzcaStockMinimo')" v-model="subproducto.stockMinimo" />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="stockMinimoSubproducto"><strong>{{ $t("partesStockMinimo") }}</strong></label>
                    <input type="number" min="0" class="form-control" id="stockMinimoPartesSubproducto"
                      v-bind:placeholder="'Inserta partes del stock mínimo'" v-model="subproducto.stockMinimoPartes" />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="stockOptimoSubproducto"><strong>{{ $t("stockOptimo") }}</strong></label>
                    <input type="number" min="0" class="form-control" id="stockOptimoSubproducto"
                      v-bind:placeholder="$t('introduzcaStockOptimo')" v-model="subproducto.stockOptimo" />
                  </div>
                </div>

                <div class="col-md-2" style="padding-top: 35px">
                  <div class="form-group">
                    <div class="form-group">
                      <label>
                        <strong>{{ $t("baja") }}</strong>
                      </label>
                      <el-switch v-model="subproducto.baja" active-color="#13ce66" inactive-color="#bcbcbc">
                      </el-switch>
                    </div>
                  </div>
                </div>

                <div v-if="listCuentasGastosSage.length > 1" class="col-md-12">
                  <hr />
                  <label><strong>{{ tieneDimoni ? $t('enlaceContable') : $t('sage200') }}</strong></label>
                  <br />
                  <label>{{ $t("aContinuacionSeListaranLasCuentasDeTipo") }}
                    <strong>{{ $t("gastoMinuscula") }}</strong>
                    {{ $t("paraQue") }}
                    <strong>{{ $t("asocieMinuscula") }}</strong>
                    {{ $t("unaParaSuPosterior") }}
                    <strong>{{ tieneDimoni ? $t('relacionEnContabilidad') : $t('relacionEnSage') }}</strong></label>
                  <br />
                  <el-select class="select-default select-account" v-model="subproducto.idCuenta"
                    :placeholder="$t('seleccioneUnaCuenta')">
                    <el-option v-for="cuenta in listCuentasGastosSage" class="select-primary" :value="cuenta.id" :label="cuenta.codigoCuenta +
                      cuenta.codigoSubCuenta +
                      ' - ' +
                      cuenta.nombreCuenta
                      " :key="cuenta.id">
                    </el-option>
                  </el-select>
                  <template v-if="tieneDimoni">
                    <label for="porcentajeContable">
                      <strong>{{ $t("porcentajeContable") }}</strong>
                    </label>
                    <input type="number" min="0" max="100" class="form-control col-md-1" id="porcentajeContable"
                      v-bind:placeholder="$t('introduzcaElPorcentajeDeLaPrimeraCuentaContable')"
                      v-model="producto.porcentajeContable" />

                    <br />
                    <br />
                    <el-select class="select-default select-account" v-model="producto.idCuenta2" filterable
                      :placeholder="$t('seleccioneUnaCuenta')">
                      <el-option v-for="cuenta in listCuentasSage" class="select-primary select-account"
                        :value="cuenta.id" :label="cuenta.codigoCuenta +
                          cuenta.codigoSubCuenta +
                          ' - ' +
                          cuenta.nombreCuenta
                          " :key="cuenta.id + '-' + cuenta.nombreCuenta">
                      </el-option>
                    </el-select>

                    <input type="number" min="0" max="100" class="form-control col-md-1"
                      style="display: inline !important;" id="porcentajeContable"
                      v-model="producto.porcentajeContable2" />

                    <br />
                    <br />
                    <el-select class="select-default select-account" v-model="producto.idCuenta3" filterable
                      :placeholder="$t('seleccioneUnaCuenta')">
                      <el-option v-for="cuenta in listCuentasSage" class="select-primary select-account"
                        :value="cuenta.id" :label="cuenta.codigoCuenta +
                          cuenta.codigoSubCuenta +
                          ' - ' +
                          cuenta.nombreCuenta
                          " :key="cuenta.id + '-' + cuenta.nombreCuenta">
                      </el-option>
                    </el-select>

                    <input type="number" min="0" max="100" class="form-control col-md-1"
                      style="display: inline !important;" id="porcentajeContable"
                      v-model="producto.porcentajeContable3" />
                  </template>
                  <br />
                </div>
              </div>
            </v-tab>

            <!-- MENUS -->

            <v-tab :key="'platosdelmenu'" v-if="producto.isMenu && !isClosed" :title="$t('platosDelMenu')" id="5">
              <label style="margin-left: 15px" for="opcion1">
                {{ $t("platosTip1") }} <br />
                {{ $t("platosTip2") }}
              </label>
              <div class="col-md-3">
                <br />
                <div class="row">
                  <div class="col-md-10" :class="primerPlato.id != 0 ? 'col-10' : 'col-12'">
                    <div class="form-group">
                      <label><strong>{{ $t("primerPlato") }}</strong></label>
                      <input type="text" class="form-control" id="opcion1" @click="editandoPrimero = true"
                        @blur="categoriesMenuShow(platos[0])" v-model="platos[0].nombrePlato"
                        v-bind:placeholder="'ENTRANTES...'" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-10" :class="segundoPlato.id != 0 ? 'col-10' : 'col-12'">
                    <div class="form-group">
                      <label><strong>{{ $t("segundoPlato") }}</strong></label>
                      <input type="text" class="form-control" id="opcion2" @click="editandoSegundo = true"
                        @blur="categoriesMenuShow(platos[1])" v-model="platos[1].nombrePlato"
                        v-bind:placeholder="'PRIMEROS...'" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-10" :class="tercerPlato.id != 0 ? 'col-10' : 'col-12'">
                    <div class="form-group">
                      <label><strong>{{ $t("tercerPlato") }}</strong></label>
                      <input type="text" class="form-control" id="opcion2" @click="editandoTercero = true"
                        @blur="categoriesMenuShow(platos[2])" v-model="platos[2].nombrePlato"
                        v-bind:placeholder="'SEGUNDOS...'" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-10" :class="cuartoPlato.id != 0 ? 'col-10' : 'col-12'">
                    <div class="form-group">
                      <label><strong>{{ $t("cuartoPlato") }}</strong></label>
                      <input type="text" class="form-control" id="opcion2" @click="editandoCuarto = true"
                        @blur="categoriesMenuShow(platos[3])" v-model="platos[3].nombrePlato"
                        v-bind:placeholder="'POSTRES...'" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-10" :class="quintoPlato.id != 0 ? 'col-10' : 'col-12'">
                    <div class="form-group">
                      <label><strong>{{ $t("quintoPlato") }}</strong></label>
                      <input type="text" class="form-control" id="opcion2" @click="editandoQuinto = true"
                        @blur="categoriesMenuShow(platos[4])" v-model="platos[4].nombrePlato"
                        v-bind:placeholder="'...'" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-10" :class="sextoPlato.id != 0 ? 'col-10' : 'col-12'">
                    <div class="form-group">
                      <label><strong>{{ $t("sextoPlato") }}</strong></label>
                      <input type="text" class="form-control" id="opcion2" @click="editandoSexto = true"
                        @blur="categoriesMenuShow(platos[5])" v-model="platos[5].nombrePlato"
                        v-bind:placeholder="'...'" />
                    </div>
                  </div>
                </div>
              </div>
            </v-tab>

            <v-tab :key="'productosdelmenu'" v-if="producto.isMenu" :title="$t('productosDelMenu')" id="6">
              <div v-if="!isClosed">
                <label style="margin-left: 15px" for="productos">
                  {{ $t("productosPlatosTip") }}
                </label>
                <br />
              </div>
              <div class="col-md-12">
                <div class="row mt-3" v-if="!isClosed">
                  <div class="col-md-2">
                    <div class="form-group">
                      <label><strong>{{ $t("seleccionaUnPlato") }}:</strong></label>
                      <el-select class="select-default" v-model="platoSeleccionado" :placeholder="'Nombre del plato'">
                        <el-option v-for="p in listaPlatos" :key="p.idPlato" :label="p.nombrePlato" :value="p.idPlato">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="form-group">
                      <label><strong>{{ $t("producto") }}:</strong></label>
                      <el-select :value="productoSeleccionado ? productoSeleccionado.id : null"
                        @input="onProductoSelect" class="select-default" filterable remote clearable reserve-keyword
                        :loading="loadingProductos" :remote-method="searchProductosByPlato"
                        :placeholder="$t('producto')">
                        <el-option v-for="p in opcionesProductos" :key="p.id" :label="p.nameProducto" :value="p.id"
                          :disabled="p.seleccionable === false">
                          <span class="opcion-plato">
                            <span class="opcion-plato__nombre"
                              :class="{ 'opcion-plato__nombre--baja': p.activo === false }">{{ p.nameProducto }}</span>
                            <span v-if="p.tipoProducto" class="badge-tipo-producto"
                              :class="'badge-tipo-producto--' + p.tipoProducto.toLowerCase()">
                              {{ p.tipoProducto }}
                            </span>
                            <span v-if="p.activo !== undefined" class="badge-estado-producto"
                              :class="p.activo ? 'badge-estado-producto--activo' : 'badge-estado-producto--baja'">
                              {{ p.activo ? $t("activo") : $t("dadoDeBaja") }}
                            </span>
                          </span>
                        </el-option>
                      </el-select>
                      <!--<el-select class="select-default" v-model="productoSeleccionado" filterable remote reserve-keyword
                        :remote-method="searchProductosByPlato" :placeholder="$t('producto')">
                        <el-option v-for="p in listProductosTodos" :key="p.id" :label="p.nameProducto" :value="p">
                        </el-option>
                      </el-select>-->
                    </div>
                  </div>

                  <div class="col-md-1 col-12" v-if="productoSeleccionado != null">
                    <br />
                    <button @click="anadirProductoAPlato()" class="btn btn-success mt-1 mb-3 w-100">
                      <i class="fa fa-save"></i>
                    </button>
                    <!-- anadirProductoAPlato(productoSeleccionado.id) -->
                  </div>
                </div>
                <div class="row mt-3" v-else>
                  <div class="col-md-5">
                    <div class="form-group">
                      <label><strong>{{ $t("producto") }}:</strong></label>
                      <el-select class="select-default" v-model="productoSeleccionado" filterable remote reserve-keyword
                        :remote-method="searchProductoMenuCerrado" :placeholder="$t('producto')">
                        <el-option v-for="p in listProductosTodos" :key="p.id" :label="p.name" :value="p">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="col-md-1 col-12" v-if="productoSeleccionado != null">
                    <br />
                    <button @click="anadirProductoAMenu2()" class="btn btn-success mt-1 mb-3 w-100">

                      <i class="fa fa-save"></i>

                    </button>
                  </div>
                </div>
                <div class="row mt-2">
                  <table class="table table-sm mb-4 table-bordered table-striped" v-if="listProductosPlato.length > 0">
                    <thead class="thead-dark">
                      <tr>
                        <th>{{ $t("nombre") }}</th>
                        <th v-if="isClosed">{{ $t('orden') }}</th>
                        <th>{{ $t("acciones") }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="prod in listProductosPlato" :key="prod.id">
                        <td width="40%">{{ prod.nameProducto }}</td>
                        <td width="10%" style="text-align: center" v-if="isClosed">
                          <el-input-number v-model="prod.n_plato" style="text-align: left !important;" :min="1"
                            :precision="0" :controls="false" :placeholder="'1'"
                            @change.native="cambiarOrdenProductoMenuCerrado(prod)" class="align-content-left">
                          </el-input-number>
                        </td>
                        <td width="5%" style="text-align: center;">
                          <span style="color: red; /*margin-left: 25px;*/" v-if="!isClosed"
                            @click="eliminarProductoDePlato(prod.id)">
                            <i class="fa fa-trash"></i>
                          </span>
                          <span v-else style="color: red; /*margin-left: 25px;*/"
                            @click="eliminarProductoMenuCerrado(prod.id_menudet)">
                            <i class="fa fa-trash"></i>
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <br />
                </div>
              </div>
            </v-tab>

            <v-tab v-if="listCuentasSage.length > 1" :key="'cuentassage'"
              :title="tieneDimoni ? $t('enlaceContable') : $t('sage200')">
              <label>{{ $t("aContinuacionSeListaranLasCuentasDeTipo") }}
                <strong>{{ $t("ventaMinuscula") }}</strong> {{ $t("paraQue") }}
                <strong>{{ $t("asocieMinuscula") }}</strong>
                {{ $t("unaParaSuPosterior") }}
                <strong>{{ tieneDimoni ? $t('relacionEnContabilidad') : $t('relacionEnSage') }}</strong></label>
              <br />
              <br />
              <el-select class="select-default select-account" v-model="producto.idCuenta" filterable
                :placeholder="$t('seleccioneUnaCuenta')">
                <el-option v-for="cuenta in listCuentasSage" class="select-primary select-account" :value="cuenta.id"
                  :label="cuenta.codigoCuenta +
                    cuenta.codigoSubCuenta +
                    ' - ' +
                    cuenta.nombreCuenta
                    " :key="cuenta.id + '-' + cuenta.nombreCuenta">
                </el-option>
              </el-select>
              <template v-if="tieneDimoni">
                <!--<label for="porcentajeContable">
                  <strong>{{ $t("porcentajeContable") }}</strong>
                </label>-->
                <input type="number" min="0" max="100" class="form-control col-md-1" style="display: inline !important;"
                  id="porcentajeContable" v-model="producto.porcentajeContable" />

                <br />
                <br />
                <el-select class="select-default select-account" v-model="producto.idCuenta2" filterable
                  :placeholder="$t('seleccioneUnaCuenta')">
                  <el-option v-for="cuenta in listCuentasSage" class="select-primary select-account" :value="cuenta.id"
                    :label="cuenta.codigoCuenta +
                      cuenta.codigoSubCuenta +
                      ' - ' +
                      cuenta.nombreCuenta
                      " :key="cuenta.id + '-' + cuenta.nombreCuenta">
                  </el-option>
                </el-select>

                <input type="number" min="0" max="100" class="form-control col-md-1" style="display: inline !important;"
                  id="porcentajeContable" v-model="producto.porcentajeContable2" />

                <br />
                <br />
                <el-select class="select-default select-account" v-model="producto.idCuenta3" filterable
                  :placeholder="$t('seleccioneUnaCuenta')">
                  <el-option v-for="cuenta in listCuentasSage" class="select-primary select-account" :value="cuenta.id"
                    :label="cuenta.codigoCuenta +
                      cuenta.codigoSubCuenta +
                      ' - ' +
                      cuenta.nombreCuenta
                      " :key="cuenta.id + '-' + cuenta.nombreCuenta">
                  </el-option>
                </el-select>

                <input type="number" min="0" max="100" class="form-control col-md-1" style="display: inline !important;"
                  id="porcentajeContable" v-model="producto.porcentajeContable3" />
              </template>
            </v-tab>

            <v-tab v-if="configuradorPLU || tieneTspoonlab || tieneA3Software" :key="'tspoonlab'"
              :title="tieneA3Software ? 'A3Software' : 'PLUs'">

              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-12">
                    <label for="namePrice1"><strong v-if="tieneA3Software">CODARTERP 1</strong><strong v-else>PLU
                        1</strong></label>
                  </div>
                  <div class="col-md-3 col-10">
                    <div class="form-group">
                      <input type="text" class="form-control" id="namePrice1" v-bind:placeholder="$t('tarifa1')"
                        v-model="producto.namePrice1" disabled />
                    </div>
                  </div>
                  <div class="col-md-2 col-12">
                    <el-input v-model="producto.PLU1"></el-input>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <label for="namePrice1"><strong v-if="tieneA3Software">CODARTERP 2</strong><strong v-else>PLU
                        2</strong></label>
                  </div>
                  <div class="col-md-3 col-10">
                    <div class="form-group">
                      <input type="text" class="form-control" id="namePrice2" v-bind:placeholder="$t('tarifa2')"
                        v-model="producto.namePrice2" disabled />
                    </div>
                  </div>
                  <div class="col-md-2 col-12">
                    <el-input v-model="producto.PLU2"></el-input>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <label for="namePrice1"><strong v-if="tieneA3Software">CODARTERP 3</strong><strong v-else>PLU
                        3</strong></label>
                  </div>
                  <div class="col-md-3 col-10">
                    <div class="form-group">
                      <input type="text" class="form-control" id="namePrice3" v-bind:placeholder="$t('tarifa3')"
                        v-model="producto.namePrice3" disabled />
                    </div>
                  </div>
                  <div class="col-md-2 col-12">
                    <el-input v-model="producto.PLU3"></el-input>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <label for="namePrice1"><strong v-if="tieneA3Software">CODARTERP 4</strong><strong v-else>PLU
                        4</strong></label>
                  </div>
                  <div class="col-md-3 col-10">
                    <div class="form-group">
                      <input type="text" class="form-control" id="namePrice4" v-bind:placeholder="$t('tarifa4')"
                        v-model="producto.namePrice4" disabled />
                    </div>
                  </div>
                  <div class="col-md-2 col-12">
                    <el-input v-model="producto.PLU4"></el-input>
                  </div>
                </div>
              </div>
            </v-tab>
            <br />
          </vue-tabs>

          <div class="row">
            <div class="col-md-12" style="margin-top: 10px">
              <button class="btn btn-primary" v-once-click="idSector != 0 ? comprobarCodigoBarras : handleSave"
                :disabled="inProgress">
                <i class="fa fa-check-square"></i> {{ $t("guardar") }}
              </button>
              <router-link v-if="previousRoute === 'diagnostico-carta'" :to="{
                name: 'diagnostico-carta',
                params: {
                  idBusiness: idBusiness,
                  idCarta: idCarta
                }
              }">
                <button class="btn btn-danger">
                  <i class="fa fa-window-close"></i>
                  {{ $t("cancelar") }}
                </button>
              </router-link>

              <router-link v-else-if="previousRoute === 'productos-carta'" :to="{ name: 'productos-carta' }">
                <button class="btn btn-danger">
                  <i class="fa fa-window-close"></i>
                  {{ $t("cancelar") }}
                </button>
              </router-link>

              <router-link v-else :to="{
                name: 'productos',
                query: { filtro: filtro },
                params: { idBusiness: idBusiness, pag: pag }
              }">
                <button class="btn btn-danger">
                  <i class="fa fa-window-close"></i>
                  {{ $t("cancelar") }}
                </button>
              </router-link>
              <el-checkbox v-model="checkReply" border class="checkbox-element" v-if="idSector == 0">
                {{ $t("replicar") }}
              </el-checkbox>

              <button v-if="idProducto && idSector == 0 && !restriccionBusinessCentral" class="btn btn-google"
                :disabled="inProgress" @click="clonarProducto">
                <i class="fas fa-exchange-alt"></i>
                {{ $t("clonarProducto") }}
              </button>

              <button :hidden="!tieneProductCarta || distinguirPrecios || checkReply" class="btn btn-info"
                @click="openModalReplicaCarta()" v-if="idSector == 0">
                <i class="fa fa-check-square"></i> {{ $t("guardaryreplicar") }}
              </button>

              <button v-if="idSector == 0 && !restriccionBusinessCentral && !tieneProductCarta" class="btn btn-info"
                :disabled="inProgress" @click="insertarProductoEnCarta()">
                <i class="fa fa-check-square"></i> {{ $t("CrearProductoEnCarta") }}
              </button>

            </div>
          </div>
        </div>
      </div>
    </div>

    <modal name="modal-producttarifamenu" :adaptive="true" :scrollable="true" height="auto" :clickToClose="true">
      <div v-if="productoSeleccionado != null">
        <div class="modal-header" style="padding-bottom: 0px">
          <h5>El producto <strong>{{ productoSeleccionado.nameProducto }}</strong> tiene múltiples tarifas:</h5>
        </div>
        <div class="modal-body" style="padding-top: 0px">
          <el-radio-group v-model="tarifaProductMenu" style="margin-top: 5px">
            <div class="col-md-12">
              <el-radio v-if="productoSeleccionado.selPrice1" :label=1 :key="1">{{ productoSeleccionado.nameTarifa1
              }}</el-radio>
              <el-radio v-if="productoSeleccionado.selPrice2" :label=2 :key="2">{{ productoSeleccionado.nameTarifa2
              }}</el-radio>
              <el-radio v-if="productoSeleccionado.selPrice3" :label=3 :key="3">{{ productoSeleccionado.nameTarifa3
              }}</el-radio>
              <el-radio v-if="productoSeleccionado.selPrice4" :label=4 :key="4">{{ productoSeleccionado.nameTarifa4
              }}</el-radio>
            </div>
          </el-radio-group>
        </div>

        <div class="modal-footer">
          <div align="right" class="col-12">
            <button @click="cerrarModalProductTarifaMenu()" class="btn btn-danger btnNoReplicar">
              <i class="fa fa-window-close" style="padding-right : 10px;"></i>{{ $t("cancelar") }}
            </button>
            <button v-if="!isClosed" @click="guardarProductoMenuTarifa()" class="btn btn-primary btnReplicar">
              <i class="fas fa-copy" style="padding-right : 10px;"></i>{{ $t("aceptar") }}
            </button>
            <button v-else @click="anadirProductoAMenu()" class="btn btn-primary btnReplicar">
              <i class="fas fa-copy" style="padding-right : 10px;"></i>{{ $t("aceptar") }}
            </button>
          </div>
        </div>
      </div>
    </modal>

    <modal name="modal-copysub" :adaptive="true" :scrollable="true" height="auto" :clickToClose="true">
      <div>
        <div class="modal-header" style="padding-bottom: 0px">
          <h5>{{ $t("copiarMateriaPrima") }}</h5>
        </div>
        <div class="modal-body" style="padding-top: 0px">
          1 - {{ $t("seleccioneQueTipoDeMateriasPrimasQuiereCopiar") }}

          <el-checkbox-group v-model="listTipo" style="margin-top: 5px">
            <div class="col-md-12">
              <el-checkbox label="Bases" key="0"></el-checkbox>
              <el-checkbox label="Opcionales" key="1"></el-checkbox>
              <el-checkbox label="Extras" key="2"></el-checkbox>
            </div>
          </el-checkbox-group>

          <hr />

          2 - {{ $t("seleccioneAQueCategoriaQuiereCopiarLasMateriasPrimas") }}
          <el-checkbox-group v-model="listcategoriesCopySub" style="margin-top: 5px">
            <div class="col-md-12" v-for="c in listCategory">
              <el-checkbox :label="c.id" :key="c.id + '-' + c.name">
                {{ c.name }}
              </el-checkbox>
            </div>
          </el-checkbox-group>
        </div>
        <div class="modal-footer">
          <div align="right" class="col-12">
            <button @click="showModalCopySub()" class="btn btn-primary">
              <i class="fas fa-exchange-alt"></i> {{ $t("copiarMateriaPrima") }}
            </button>
          </div>
        </div>
      </div>
    </modal>

    <modal name="modal-replicar-carta" :adaptive="true" :scrollable="true" height="auto" :clickToClose="false">
      <div>
        <div class="modal-header" style="padding-bottom: 0px">
          <h5>{{ $t("replicarencarta") }}</h5>
        </div>
        <div class="modal-body" style="padding-top: 0px">
          {{ $t("deseaguardarelproductoencarta") }}
          <div class="col-md-12" style="padding-top: 20px">
            <el-checkbox label="check" key="" v-model="checkModalReply">{{
              $t("leidoyacepto")
            }}</el-checkbox>
          </div>
        </div>
        <div class="modal-footer">
          <div align="right" class="col-12">
            <button @click="cerrarModalReplicar()" class="btn btn-danger btnNoReplicar " :disabled="!checkModalReply">
              <i class="fa fa-window-close" style="padding-right : 10px;"></i>{{ $t("cancelar") }}
            </button>
            <button @click="guardarYreplicarProductoEnCarta()" class="btn btn-primary btnReplicar"
              :disabled="!checkModalReply || inProgress">
              <i class="fas fa-copy" style="padding-right : 10px;"></i>{{ $t("aceptarreplicarencarta") }}
            </button>
          </div>
        </div>
      </div>
    </modal>

    <!-- Modal para seleccionar categoria al crear en carta -->
    <modal name="modal-select-categoria-carta" :adaptive="true" :scrollable="true" height="auto" :clickToClose="false">
      <div>
        <div class="modal-header" style="padding-bottom: 0px">
          <h5>{{ $t("enlazarACategoria") || "Enlazar a una categoría" }}</h5>
        </div>
        <div class="modal-body" style="padding-top: 0px">
          <p>{{ $t("deseaEnlazarProductoCategoria") || "¿Desea enlazar el nuevo producto a una categoría existente en la carta?" }}</p>
          <div class="col-md-12" style="padding-top: 10px">
            <label><strong>{{ $t("categoria") || "Categoría" }}</strong></label>
            <el-select v-model="selectedCategoriaCartaId"
              :placeholder="$t('seleccionarCategoria') || 'Seleccionar categoría'" class="select-default"
              style="margin-left: 1rem;" size="large" filterable clearable>
              <el-option v-for="categoria in listCategoriesCarta" :key="categoria.id" :label="categoria.nombre"
                :value="categoria.id"></el-option>
            </el-select>
          </div>
        </div>
        <div class="modal-footer">
          <div align="right" class="col-12">
            <button @click="cerrarModalSelectCategoria()" class="btn btn-danger">
              <i class="fa fa-window-close" style="padding-right : 10px;"></i>{{ $t("cancelar") }}
            </button>
            <button @click="crearProductoSinCategoria()" class="btn btn-secondary">
              <i class="fas fa-check" style="padding-right : 10px;"></i>{{ $t("omitirYCrear") || "Omitir y crear" }}
            </button>
            <button @click="crearProductoConCategoria()" class="btn btn-primary btnReplicar"
              :disabled="!selectedCategoriaCartaId">
              <i class="fas fa-check" style="padding-right : 10px;"></i>{{ $t("aceptarYAgregar") || "Aceptar y agregar"
              }}
            </button>
          </div>
        </div>
      </div>
    </modal>

    <modal name="modalagregarSubproducto" :adaptive="true" :scrollable="true" height="auto" :clickToClose="true">
      <div>
        <div class="modal-header" style="padding-bottom: 0px">
          <h5>{{ $t("agregarMateriasPrimas") }}</h5>
        </div>
        <div class="modal-body" style="padding-top: 0px">
          <div class="row">
            <div class="col-md-9">
              <input @keyup.enter.prevent="remoteMethod()" style="margin-bottom: 10px" type="text" class="form-control"
                id="buscadorSubproducts" :placeholder="$t('buscarMateriaPrima')" v-model="search" />
            </div>

            <div class="col-md-3">
              <button class="btn btn-primary" @click="remoteMethod()">
                <i class="fas fa-search"></i> {{ $t("buscarSinPuntos") }}
              </button>
            </div>
          </div>

          <el-checkbox-group :min="1" v-model="idsSubproductos" style="margin-top: 5px">
            <el-checkbox v-for="s in listSubproducts" :label="s.id" :key="s.id + '-' + s.name" border>
              {{ s.name }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="modal-footer">
          <div align="right" class="col-12">
            <button v-if="idsSubproductos.length !== 0" @click="agregarSubproductos()" class="btn btn-primary">
              <i class="fas fa-plus"></i> {{ $t("agregarMateriasPrimas") }}
            </button>
          </div>
        </div>
      </div>
    </modal>

    <modal name="modal-crear-subproductos" :adaptive="true" :scrollable="true" height="auto" :clickToClose="true">
      <template>
        <div>
          <div class="modal-header">
            <h5>{{ $t("anyadirNuevoSubproducto") }}</h5>
          </div>
          <div class="modal-body">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label><strong>{{ $t("etiqueta") }}</strong></label>

                    <el-select class="select-default" size="large" v-model="subproducto.idTag" filterable
                      :placeholder="$t('seleccioneEtiqueta')">
                      <el-option v-for="category in listEtiquetas" class="select-primary" :value="category.id"
                        :label="category.name" :key="category.id + '-' + category.name">
                      </el-option>
                    </el-select>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label><strong>{{ $t("proveedor") }}</strong></label>
                    <el-select class="select-default" size="large" v-model="subproducto.idSupplier" filterable
                      :placeholder="$t('seleccionaProveedor')">
                      <el-option v-for="proveedor in listProveedores" class="select-primary" :value="proveedor.id"
                        :label="proveedor.name" :key="proveedor.id + '-' + proveedor.name">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="nameCasaAgregar"><strong>{{ $t("nombreSubproducto") }} <span>*</span></strong></label>
                    <input type="text" class="form-control" :class="{
                      'is-valid':
                        subproducto.name.length > 0 &&
                        subproducto.name.length <= 50,
                      'is-invalid': subproducto.name.length > 50,
                    }" id="nameCasaAgregar" v-bind:placeholder="$t('introduzcaNombre')" v-model="subproducto.name"
                      ref="name" />
                    <input type="hidden" v-model="subproducto.xname" />
                    <small class="form-text text-muted">{{ subproducto.name.length }}/50
                    </small>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="codigodebarrasubproductoAgregar">
                      <strong>{{ $t("codigoBarra") }}</strong>
                    </label>
                    <input type="text" class="form-control" id="codigodebarrasubproductoAgregar"
                      v-bind:placeholder="$t('introduzcaCodigoDeBarras')" v-model="subproducto.codigoBarras" />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="direccionsubproductoAgregar"><strong>{{ $t("descripcion") }}</strong></label>
                    <input type="text" class="form-control" id="direccionsubproductoAgregar"
                      v-bind:placeholder="$t('introduzcaDescripcion')" v-model="subproducto.descripcion" />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label><strong>{{ $t("tipo") }}</strong></label>

                    <el-select class="select-default" size="large" v-model="subproducto.tipo" filterable
                      :placeholder="$t('seleccionaTipo')">
                      <el-option v-for="tipo in listaTipoUn" class="select-primary" :value="tipo" :label="tipo"
                        :key="tipo + '- tipo'">
                      </el-option>
                    </el-select>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="escandalloSubproductoAgregar"><strong>{{ $t("escandallo") }}</strong></label>
                    <!--<input
                      type="number"
                      min="0"
                      class="form-control"
                      id="escandalloSubproductoAgregar"
                      v-bind:placeholder="$t('introduzcaEscandallo')"
                      v-model="subproducto.escandallo"
                    />-->
                    <el-input-number id="escandalloSubproductoAgregar" v-model="subproducto.escandallo" :min="0"
                      :precision="0" :controls="false" :placeholder="$t('introduzcaEscandallo')">
                    </el-input-number>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label><strong>{{ $t("precioCompraSinIva") }}</strong></label>
                    <!--<input class="form-control" v-model="subproducto.precioCompraSinIva"-->
                    <!--type="number"-->
                    <!--id="precioCompraSubproductoSinIva"-->
                    <!--@change="calculatePrice(subproducto,false)"/>-->

                    <vue-numeric currency="€" inputmode="decimal" type="text" class="form-control"
                      currency-symbol-position="suffix" :precision="4" @blur="calculatePrice(subproducto, false)"
                      @keydown.native="$methods.evitarComasDecimales" v-model="subproducto.precioCompraSinIva">
                    </vue-numeric>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label><strong>{{ $t("tipoIva") }}</strong></label>

                    <el-select class="select-default" size="large" v-model="subproducto.tipoIva" filterable
                      @change="calculatePrice(subproducto, false)" :placeholder="$t('seleccionaIVA')">
                      <el-option v-for="iva in listIva" class="select-primary" :value="iva" :label="iva"
                        :key="iva + '- iva'">
                      </el-option>
                    </el-select>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="cuotaIVAAgregar"><strong>{{ $t("cuotaIVA") }}</strong></label>
                    <input class="form-control" :value="(
                      subproducto.precioCompra -
                      subproducto.precioCompraSinIva
                    ).toFixed(2)
                      " type="number" disabled id="cuotaIVAAgregar" />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label><strong>{{ $t("precioCompraConIva") }}</strong></label>
                    <!--<input class="form-control" v-model="subproducto.precioCompra"-->
                    <!--type="number"-->
                    <!--id="precioCompraSubproducto"-->
                    <!--@keyup="calculatePrice(subproducto,true)"/>-->
                    <vue-numeric currency="€" inputmode="decimal" type="text" class="form-control"
                      currency-symbol-position="suffix" :precision="4" @blur="calculatePrice(subproducto, true)"
                      @keydown.native="$methods.evitarComasDecimales" v-model="subproducto.precioCompra"></vue-numeric>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="descuentoCompraSubproductoAgregar"><strong>{{ $t("descuentoCompra")
                    }}</strong></label><span style="font-size: x-small">
                      {{ $t("porcentaje") }}</span>
                    <input type="number" min="0" class="form-control" id="descuentoCompraSubproductoAgregar"
                      placeholder="0%" v-model="subproducto.descuentoCompra" />
                  </div>
                </div>

                <div class="col-md-12">
                  <hr />
                </div>

                <div class="col-md-6" style="padding-top: 35px">
                  <div class="form-group">
                    <div class="form-group">
                      <label>
                        <strong>{{ $t("baja") }}</strong>
                      </label>
                      <el-switch v-model="subproducto.baja" active-color="#13ce66" inactive-color="#bcbcbc">
                      </el-switch>
                    </div>
                  </div>
                </div>

                <div class="col-md-6" style="padding-top: 35px">
                  <div class="form-group">
                    <div class="form-group">
                      <label>
                        <strong>{{ $t("guardarEnAlmacen") }}</strong>
                      </label>
                      <el-switch v-model="subproducto.guardarAlmacen" active-color="#13ce66" inactive-color="#bcbcbc">
                      </el-switch>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="stockMinimoSubproductoAgregar"><strong>{{ $t("stockMinimo") }}</strong></label>
                    <input type="number" min="0" class="form-control" id="stockMinimoSubproductoAgregar"
                      v-bind:placeholder="$t('introduzcaStockMinimo')" v-model="subproducto.stockMinimo" />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="stockOptimoSubproductoAgregar"><strong>{{ $t("stockOptimo") }}</strong></label>
                    <input type="number" min="0" class="form-control" id="stockOptimoSubproductoAgregar"
                      v-bind:placeholder="$t('introduzcaStockOptimo')" v-model="subproducto.stockOptimo" />
                  </div>
                </div>
                <div v-if="listCuentasGastosSage.length > 1" class="col-md-12">
                  <hr />
                  <label><strong>{{ tieneDimoni ? $t('enlaceContable') : $t('sage200') }}</strong></label>
                  <br />
                  <label>{{ $t("aContinuacionSeListaranLasCuentasDeTipo") }}
                    <strong>{{ $t("gastoMinuscula") }}</strong>
                    {{ $t("paraQue") }}
                    <strong>{{ $t("asocieMinuscula") }}</strong>
                    {{ $t("unaParaSuPosterior") }}
                    <strong>{{ tieneDimoni ? $t('relacionEnContabilidad') : $t('relacionEnSage') }}</strong></label>
                  <br />
                  <el-select class="select-default select-account" v-model="subproducto.idCuenta"
                    :placeholder="$t('seleccioneUnaCuenta')">
                    <el-option v-for="cuenta in listCuentasGastosSage" class="select-primary" :value="cuenta.id" :label="cuenta.codigoCuenta +
                      cuenta.codigoSubCuenta +
                      ' - ' +
                      cuenta.nombreCuenta
                      " :key="cuenta.id + '-' + cuenta.nombreCuenta">
                    </el-option>
                  </el-select>
                  <br />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button @click="saveSubproducto(idProducto)" class="btn btn-primary">
              <i class="fa fa-check-circle"></i> {{ $t("aceptar") }}
            </button>
          </div>
        </div>
      </template>
    </modal>

    <modal name="modalReply" :adaptive="true" :scrollable="true" height="auto" width="90%" :clickToClose="false">
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">{{ $t("replicarProducto") }}</h4>
        </div>

        <div class="modal-body">
          <input type="checkbox" id="checkSelectAll" name="checkSelectAll" v-model="checkSelectAll"
            @click="selectAll" />
          <label for="checkSelectAll" class="checkSelectAll">
            {{ $t("seleccionarTodos") }}
          </label>

          <div class="alert alert-info" style="margin-top: 12px; margin-bottom: 0; padding: 10px 14px;">
            <i class="fa fa-info-circle"></i>
            <span v-if="familiaReplicar.length > 1">
              {{ $t("replicaFamiliaAviso") }}
              <strong>{{ descripcionFamilia }}</strong>
              ({{ familiaReplicar.length }} {{ $t("productosPorNegocio") }})
            </span>
            <span v-else>
              {{ $t("replicaTipoDetectado") }} <strong>{{ tipoProductoBC }}</strong>
            </span>
            <div v-if="categoriaFijadaPorTipo" style="margin-top: 6px;">
              <small>{{ $t("categoriaFijadaPorTipoAviso", { TIPO: tipoProductoBC }) }}</small>
            </div>
          </div>

          <div class="table-responsive" style="margin-top: 15px">
            <table class="table table-sm table-bordered">
              <thead class="thead-light">
                <tr>
                  <th v-if="businessCentral" style="width: 5%">{{ ("En el negocio") }}</th>
                  <th style="width: 20%">{{ $t("negocio") }}</th>
                  <th style="width: 20%">{{ $t("categoria") }}</th>
                  <th v-if="businessCentral" style="width: 15%">{{ $t("categoriaEnlazada") }}</th>
                  <th v-if="businessCentral && showPrice1" style="width: 11%">
                    <small>{{ displayPriceName(1) }} 1</small>
                  </th>
                  <th v-if="businessCentral && showPrice2" style="width: 11%">
                    <small>{{ displayPriceName(2) }} 2</small>
                  </th>
                  <th v-if="businessCentral && showPrice3" style="width: 11%">
                    <small>{{ displayPriceName(3) }} 3</small>
                  </th>
                  <th v-if="businessCentral && showPrice4" style="width: 11%">
                    <small>{{ displayPriceName(4) }} 4</small>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!negociosReplicables.length">
                  <td colspan="8" class="text-center text-muted" style="padding: 18px;">
                    {{ $t("sinNegociosParaReplicar") }}
                  </td>
                </tr>
                <tr v-for="business in listBusinesses" :key="business.id" v-if="business.id != idBusiness">
                  <!-- Estado: check si existe, cruz si no -->
                  <td v-if="businessCentral" style="text-align: center; vertical-align: middle;">
                    <i v-if="business.exists" class="fas fa-check-circle" style="color: green; font-size: 1.2rem;"></i>
                    <i v-else class="fas fa-times-circle" style="color: red; font-size: 1.2rem;"></i>
                  </td>
                  <td>
                    <el-checkbox v-model="business.checked" border class="w-100"
                      :disabled="!business.categories || business.categories.length === 0">
                      {{ business.establishmentName }}
                    </el-checkbox>
                    <small v-if="!business.categories || business.categories.length === 0" class="text-danger">
                      <i class="fa fa-exclamation-triangle"></i> {{ $t("negocioSinCategorias") }}
                    </small>
                  </td>
                  <td>
                    <el-select class="select-default w-100" size="small"
                      :disabled="!business.checked || categoriaFijadaPorTipo" v-model="business.idCategory"
                      :placeholder="$t('seleccionaUnaCategoria')">
                      <el-option v-for="c in business.categories" class="select-primary" :value="c.id" :label="c.name"
                        :key="c.id + '-' + c.name" />
                    </el-select>
                    <small v-if="categoriaFijadaPorTipo" class="text-muted">
                      <i class="fa fa-lock"></i> {{ $t("categoriaFijadaPorTipo", { TIPO: tipoProductoBC }) }}
                    </small>
                  </td>
                  <td v-if="businessCentral">
                    <el-select class="select-default w-100" size="small" :disabled="!business.checked"
                      v-model="business.idCategoriaEnlazada" :placeholder="$t('seleccionaUnaCategoria')">
                      <el-option v-for="c in business.categories.filter(cat => cat.id !== business.idCategory)"
                        class="select-primary" :value="c.id" :label="c.name" :key="c.id + '-' + c.name" />
                    </el-select>
                  </td>
                  <td v-if="businessCentral && showPrice1">
                    <div class="d-flex align-items-center">
                      <input type="checkbox" v-model="business.incluirTarifa1"
                        :disabled="!business.checked || (business.isBusinessCentral === false || business.businessCentral === false)"
                        style="margin-right:6px;" v-tooltip.top-center="'Replicar esta tarifa en este negocio'" />
                      <input type="number" class="form-control form-control-sm"
                        :disabled="!business.checked || (business.isBusinessCentral === false || business.businessCentral === false) || !business.incluirTarifa1"
                        v-model.number="business.price1" step="0.01" min="0"
                        :placeholder="business.price1 || producto.price1" />
                    </div>
                  </td>
                  <td v-if="businessCentral && showPrice2">
                    <div class="d-flex align-items-center">
                      <input type="checkbox" v-model="business.incluirTarifa2"
                        :disabled="!business.checked || (business.isBusinessCentral === false || business.businessCentral === false)"
                        style="margin-right:6px;" v-tooltip.top-center="'Replicar esta tarifa en este negocio'" />
                      <input type="number" class="form-control form-control-sm"
                        :disabled="!business.checked || (business.isBusinessCentral === false || business.businessCentral === false) || !business.incluirTarifa2"
                        v-model.number="business.price2" step="0.01" min="0"
                        :placeholder="business.price2 || producto.price2" />
                    </div>
                  </td>
                  <td v-if="businessCentral && showPrice3">
                    <div class="d-flex align-items-center">
                      <input type="checkbox" v-model="business.incluirTarifa3"
                        :disabled="!business.checked || (business.isBusinessCentral === false || business.businessCentral === false)"
                        style="margin-right:6px;" v-tooltip.top-center="'Replicar esta tarifa en este negocio'" />
                      <input type="number" class="form-control form-control-sm"
                        :disabled="!business.checked || (business.isBusinessCentral === false || business.businessCentral === false) || !business.incluirTarifa3"
                        v-model.number="business.price3" step="0.01" min="0"
                        :placeholder="business.price3 || producto.price3" />
                    </div>
                  </td>
                  <td v-if="businessCentral && showPrice4">
                    <div class="d-flex align-items-center">
                      <input type="checkbox" v-model="business.incluirTarifa4"
                        :disabled="!business.checked || (business.isBusinessCentral === false || business.businessCentral === false)"
                        style="margin-right:6px;" v-tooltip.top-center="'Replicar esta tarifa en este negocio'" />
                      <input type="number" class="form-control form-control-sm"
                        :disabled="!business.checked || (business.isBusinessCentral === false || business.businessCentral === false) || !business.incluirTarifa4"
                        v-model.number="business.price4" step="0.01" min="0"
                        :placeholder="business.price4 || producto.price4" />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="modal-footer">
          <button class="btn btn-default" @click="closeModal()">
            <i class="fa fa-times-circle"></i> {{ $t("cancelar") }}
          </button>

          <button v-if="producto.wasMenu == true" class="btn btn-primary" @click="openModalreplymenu()">
            <i class="fa fa-check-circle"></i>
            {{ $t("aceptar") }}
          </button>

          <button v-else class="btn btn-primary" @click="replyProduct">
            <i class="fa fa-check-circle"></i>
            {{ $t("aceptar") }}
          </button>
        </div>
      </div>
    </modal>


    <!-- No hay ningun otro negocio donde replicar -->
    <modal name="modalSinNegocios" :adaptive="true" height="auto" width="420px">
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">{{ $t("replicarProducto") }}</h4>
        </div>

        <div class="modal-body text-center" style="padding: 26px 18px;">
          <i class="fa fa-info-circle" style="font-size: 2.4rem; color: #51bcda;"></i>
          <p style="margin-top: 14px; margin-bottom: 0;">{{ $t("sinNegociosParaReplicar") }}</p>
        </div>

        <div class="modal-footer">
          <button class="btn btn-primary" @click="cerrarSinNegocios()">
            <i class="fa fa-check-circle"></i> {{ $t("aceptar") }}
          </button>
        </div>
      </div>
    </modal>

    <!-- Informe de lo que se ha replicado en cada negocio -->
    <modal name="modalResultadoReplica" :adaptive="true" :scrollable="true" height="auto" width="70%"
      :clickToClose="false">
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">{{ $t("resultadoReplicacion") }}</h4>
        </div>

        <div class="modal-body">
          <div class="table-responsive">
            <table class="table table-sm table-bordered">
              <thead class="thead-light">
                <tr>
                  <th style="width: 26%">{{ $t("negocio") }}</th>
                  <th style="width: 37%">{{ $t("replicados") }}</th>
                  <th style="width: 37%">{{ $t("incidencias") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="linea in informeReplica" :key="linea.idBusiness">
                  <td style="vertical-align: middle;">
                    <i v-if="!linea.errores || !linea.errores.length" class="fas fa-check-circle"
                      style="color: green;"></i>
                    <i v-else class="fas fa-exclamation-triangle" style="color: #e6a23c;"></i>
                    {{ linea.establishmentName }}
                  </td>
                  <td>
                    <div v-for="(p, i) in linea.replicados" :key="'r-' + i">
                      <small><strong>{{ p.tipo }}</strong> &mdash; {{ p.nombre }} <em>({{ p.accion }})</em></small>
                    </div>
                    <small v-if="!linea.replicados || !linea.replicados.length" class="text-muted">&mdash;</small>
                  </td>
                  <td>
                    <div v-for="(e, i) in linea.errores" :key="'e-' + i">
                      <small class="text-danger">{{ e }}</small>
                    </div>
                    <small v-if="!linea.errores || !linea.errores.length" class="text-muted">&mdash;</small>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="modal-footer">
          <button class="btn btn-primary" @click="cerrarResultadoReplica()">
            <i class="fa fa-check-circle"></i> {{ $t("aceptar") }}
          </button>
        </div>
      </div>
    </modal>

    <modal name="modalReplyMenu" :adaptive="true" :scrollable="true" height="auto" width="40%" :clickToClose="false">
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">{{ $t("replicarProducto") }}</h4>
        </div>

        <div class="modal-body">
          <vue-tabs @tab-change="handleTabChange2" v-model="tabs">
            <template v-for="business in businessListPlatos">
              <v-tab :key="business.id" v-if="business.checked" :title="business.establishmentName">
                <vue-tabs v-model="tabs">
                  <template v-for="(plato) in business.listaPlatos2">
                    <v-tab :key="plato.id" :title="plato.plato">
                      <div v-for="productor in plato.products" :key="productor.id">
                        <div class="row">
                          <div class="col-md-6">
                            <el-label style="width: 100%;margin-left: 2%">
                              {{ productor.name }}
                            </el-label>
                          </div>
                          <div class="col-md-6">
                            <el-select v-model="productor.idCategory" class="select-default" size="large"
                              style="width: 100%;margin-left: 2%" :placeholder="$t('seleccionaUnaCategoria')">
                              <el-option :key="c.id" v-for="c in business.categories" class="select-primary"
                                :value="c.id" :label="c.name">
                              </el-option>
                            </el-select>
                          </div>

                        </div>
                      </div>
                    </v-tab>
                  </template>
                </vue-tabs>
              </v-tab>
            </template>
          </vue-tabs>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" @click="closeModal()">
            <i class="fa fa-times-circle"></i> {{ $t("cancelar") }}
          </button>
          <button class="btn btn-primary" :disabled="inProgress" @click="checkCategory()">
            <!-- replyProduct -->
            <i class="fa fa-check-circle"></i>
            {{ $t("aceptar") }}
          </button>
        </div>
      </div>
    </modal>

    <modal name="guardar-o-guardar-replicar" :adaptive="true" :scrollable="true" height="auto" :clickToClose="false">
      <div>
        <div class="modal-header" style="padding-bottom: 0px">
          <h5>{{ $t("replicarencarta") }}</h5>
        </div>
        <div class="modal-body" style="padding-top: 0px">
          {{ $t("guardarOreplicar") }}
          <div class="col-md-12" style="padding-top: 20px">
            <el-checkbox label="check" key="" v-model="checkModalReply2">{{
              $t("leidoyacepto")
            }}</el-checkbox>
          </div>
        </div>
        <div class="modal-footer">
          <div align="right" class="col-12">
            <button @click="cerrarModalReplicar()" class="btn btn-danger btnNoReplicar">
              <i class="fa fa-window-close" style="padding-right: 10px;"></i>{{ $t("cancelar") }}
            </button>
            <button @click="saveProducto()" class="btn btn-primary" :disabled="inProgress"
              :style="!checkModalReply2 ? 'background-color:#ccc; color:#888; border-color:#ccc; cursor:not-allowed;' : ''">
              <i class="fa fa-check-square" style="padding-right: 10px;"></i>{{ $t("guardar") }}
            </button>
            <button :hidden="checkReply" @click="guardarYreplicarProductoEnCarta()" class="btn btn-info" :disabled="inProgress"
              :style="!checkModalReply2 ? 'background-color:#ccc; color:#888; border-color:#ccc; cursor:not-allowed;' : ''">
              <i class="fa fa-check-square" style="padding-right: 10px;"></i>{{ $t("guardarYreplicar") }}
            </button>
          </div>
        </div>
      </div>
    </modal>

  </div>
</template>

<script>
import swal from "sweetalert2";
import { mapState } from "vuex";
import { Loading } from "element-ui";
import draggable from "vuedraggable";
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
  Checkbox,
  CheckboxGroup,
  InputNumber,
  Input,
  Switch,
  Radio,
  RadioGroup,
} from "element-ui";
import { VBModal } from 'bootstrap-vue';
import { forEach } from 'mathjs';


export default {
  props: ["idBusiness", "idProducto", "pag", "filtro", "idSectorParam"],
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // Aquí accedemos a la instancia del componente (vm) y establecemos previousRoute
      vm.previousRoute = from.name;
      // console.log('Ruta anterior en beforeRouteEnter: ', vm.previousRoute);
    });
  },

  created() {
    this.idBusiness = this.$route.params.idBusiness;
    this.idProducto = this.$route.params.idProducto;
    this.idUser = this.$route.params.idUser;


    this.action = this.idProducto
      ? this.$i18n.t("editar")
      : this.$i18n.t("nuevo");

    this.loadingGeneral = Loading.service({ text: this.$t("cargando") });

    let promesasCargaInicial = [
      this.getIdTpvByBusiness(),
      this.getIva(),
      this.getCategory(),
      this.getSupraCategoryConfig(),
      this.getPlanos(),
      this.getPrinters(),
    ];

    this.identificacionNegocio();
    this.getConfigDimoni();
    this.getIsRetail();
    this.getConfigTspoonlab();
    this.getConfigConfiguradorPLU();
    this.getConfigA3Software();
    this.tieneBusinessCentral();
    this.searchProductInProductCarta(this.idProducto);

    Promise.all([
      this.getCompanies(),
      // this.getCompanyConfigs()
    ]);

    //Si estamos editando, consigue el producto y sus subproductos
    if (this.idProducto) {
      let promesaProducto = this.getProducto();
      promesasCargaInicial.push(promesaProducto);
      promesasCargaInicial.push(this.getSubproductByProduct());
      this.supraCategoriesPromise = promesaProducto.then(() => this.getSupraCategories());
      promesasCargaInicial.push(this.supraCategoriesPromise);

      this.peticionesFinSpiner = 6;
    } else {
      this.supraCategoriesPromise = this.getSupraCategories();
      promesasCargaInicial.push(this.supraCategoriesPromise);

      this.peticionesFinSpiner = 4;
    }

    Promise.all(promesasCargaInicial)
      .catch(function (error) {
        console.log(error);
      })
      .then(() => {
        this.esperandoCargaInicial = false;
        if (this.loadingGeneral) {
          this.loadingGeneral.close();
        }
      });

    //Si tiene sector
    if (this.idSectorParam) {
      this.idSector = this.idSectorParam;
    }

    // Si tiene config de distinguir precios de la carta
    this.getConfigDistinguirPrecios();
    const jwt = this.$route.query.jwt;
    // console.log("JWT recibido:", jwt);
    this.previousRoute = this.$route.name;



  },
  updated() {
    if (this.esperandoCargaInicial) {
      return;
    }

    this.nPeticiones++;

    if (this.idProducto) {
      if (this.nPeticiones === this.peticionesFinSpiner) {
        this.loadingGeneral.close();
      }
    } else {
      if (this.nPeticiones === this.peticionesFinSpiner) {
        this.loadingGeneral.close();
      }
    }
  },
  components: {
    [Checkbox.name]: Checkbox,
    [Switch.name]: Switch,
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
    [InputNumber.name]: InputNumber,
    [CheckboxGroup.name]: CheckboxGroup,
    [Input.name]: Input,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    draggable,
  },
  mounted() {
    this.$refs.name.focus();
  },
  data() {
    return {
      //PRUEBAS INICIO PAGINA
      listSubproductosPlatos: [],
      loadingGeneral: null,
      peticionesFinSpiner: 0,
      nPeticiones: 0,
      esperandoCargaInicial: true,
      distinguirPrecios: false,
      tieneProductCarta: false,
      listPlanos: [],
      producto: {
        id: 0,
        orden: 999,
        idCategory: null,
        idSupraCategory: 0,
        tipoIva: 10,
        xname: "",
        nombreProducto: "",
        precioCoste: 0,
        precioCosteSinIVA: 0,
        precioCoste2: 0,
        precioCosteSinIVA2: 0,
        precioCoste3: 0,
        precioCosteSinIVA3: 0,
        precioCoste4: 0,
        precioCosteSinIVA4: 0,
        descripcion: "",
        codigoBarras: "",
        color: "amarillo",
        baja: false,
        descuento: false,
        selPrice1: false,
        selPrice2: false,
        selPrice3: false,
        selPrice4: false,
        namePrice1: "",
        namePrice2: "",
        namePrice3: "",
        namePrice4: "",
        numOpcionales: 0,
        price1: 0,
        price2: 0,
        price3: 0,
        price4: 0,

        printerName: this.$t("ningunaSeleccionada"),
        printerPDAName: this.$t("ningunaSeleccionada"),
        printerName2: this.$t("ningunaSeleccionada"),
        printerPDAName2: this.$t("ningunaSeleccionada"),

        impresionPlano1: this.$t("ningunaSeleccionada"),
        copiaImpresionPlano1: this.$t("ningunaSeleccionada"),
        impresionPlano2: this.$t("ningunaSeleccionada"),
        copiaImpresionPlano2: this.$t("ningunaSeleccionada"),
        impresionPlano3: this.$t("ningunaSeleccionada"),
        copiaImpresionPlano3: this.$t("ningunaSeleccionada"),
        impresionPlano4: this.$t("ningunaSeleccionada"),
        copiaImpresionPlano4: this.$t("ningunaSeleccionada"),
        impresionPlano5: this.$t("ningunaSeleccionada"),
        copiaImpresionPlano5: this.$t("ningunaSeleccionada"),
        impresionPlano6: this.$t("ningunaSeleccionada"),
        copiaImpresionPlano6: this.$t("ningunaSeleccionada"),
        impresionPlano7: this.$t("ningunaSeleccionada"),
        copiaImpresionPlano7: this.$t("ningunaSeleccionada"),
        impresionPlano8: this.$t("ningunaSeleccionada"),
        copiaImpresionPlano8: this.$t("ningunaSeleccionada"),

        impresionPlanoKDS1: this.$t("ningunaSeleccionada"),
        copiaImpresionPlanoKDS1: this.$t("ningunaSeleccionada"),
        impresionPlanoKDS2: this.$t("ningunaSeleccionada"),
        copiaImpresionPlanoKDS2: this.$t("ningunaSeleccionada"),
        impresionPlanoKDS3: this.$t("ningunaSeleccionada"),
        copiaImpresionPlanoKDS3: this.$t("ningunaSeleccionada"),
        impresionPlanoKDS4: this.$t("ningunaSeleccionada"),
        copiaImpresionPlanoKDS4: this.$t("ningunaSeleccionada"),
        impresionPlanoKDS5: this.$t("ningunaSeleccionada"),
        copiaImpresionPlanoKDS5: this.$t("ningunaSeleccionada"),
        impresionPlanoKDS5: this.$t("ningunaSeleccionada"),
        copiaImpresionPlanoKDS5: this.$t("ningunaSeleccionada"),
        impresionPlanoKDS6: this.$t("ningunaSeleccionada"),
        copiaImpresionPlanoKDS6: this.$t("ningunaSeleccionada"),
        impresionPlanoKDS7: this.$t("ningunaSeleccionada"),
        copiaImpresionPlanoKDS7: this.$t("ningunaSeleccionada"),
        impresionPlanoKDS8: this.$t("ningunaSeleccionada"),
        copiaImpresionPlanoKDS8: this.$t("ningunaSeleccionada"),

        impresionKDSTPV: this.$t("ningunaSeleccionada"),
        copiaImpresionKDSTPV: this.$t("ningunaSeleccionada"),
        impresionKDSPDA: this.$t("ningunaSeleccionada"),
        copiaImpresionKDSPDA: this.$t("ningunaSeleccionada"),

        precio: false,
        opcion1: "",
        opcion2: "",
        opcion3: "",
        opcion4: "",
        opcion5: "",
        peso: false,
        importe: false,
        promocionable: false,
        mostrarPC: true,
        mostrarPDA: true,
        noImprimir: false,
        seleccionarIngredientes: false,
        numPlato: 0,
        subproductos: [],
        idCuenta: "0",
        porcentajeContable: 0,
        idCuenta2: "0",
        porcentajeContable2: 0,
        idCuenta3: "0",
        porcentajeContable3: 0,
        isMenu: 0,
        PLU: "",
        PLU1: "",
        PLU2: "",
        PLU3: "",
        PLU4: "",
        dialogVisible: true,
        grupoEnlazado: "",
        invertIngredientsSelection: false,

        //isClosed: false, //menu cerrado
      },
      versionTpv: "",
      tarifaProductMenu: 0,
      isClosed: false,
      checkSelectAll: false,
      listBusinesses: [],

      // Replicacion Business Central
      familiaReplicar: [],
      informeReplica: [],
      checkReply: false,
      maxNameProductsEstandar: 50,
      maxNameProductsBusinessCentral: 100,
      action: "",
      inProgress: false,
      listaTipoIva: [0, 4, 10, 21],
      listCategory: [],
      loadingCategories: true,
      listSupraCategories: [],
      mostrarSupraCategorias: false,
      supraCategoriaObligatoria: false,
      supraCategoryConfigPromise: null,
      supraCategoriesPromise: null,
      listPrinter: [],
      listKds: [],
      nombreNegocio: "",
      listaTipo: [
        { label: this.$t("base"), value: "B" },
        { label: this.$t("extra"), value: "E" },
        { label: this.$t("opcional"), value: "O" },
      ],
      tipoAnterior: "",

      listSubproductosByProducts: [],
      listSubproducts: [],
      search: "",
      checkModalReply: false,
      checkModalReply2: false,

      listaTipoUn: [
        this.$t("uds"),
        this.$t("cajas"),
        this.$t("botellas"),
        this.$t("barriles"),
        this.$t("palets"),
        this.$t("bolsas"),
        "Kgs",
        this.$t("litros"),
        this.$t("rollos"),
      ],

      loading: false,
      idsSubproductos: [],

      listIva: [],

      listProveedores: [],
      listEtiquetas: [],
      listCasas: [],

      subproducto: {
        idTag: 0,
        idSupplier: 0,
        idCasa: 0,
        name: "",
        xname: "",
        descripcion: "",
        codigoBarras: "",
        tipo: "Uds.",
        tipoIva: 10,
        descuentoCompra: 0,
        precioCompra: 0,
        precioCompraSinIva: 0,
        escandallo: 1,
        stockMinimo: 0.0,
        stockMinimoPartes: 0.0,
        stockOptimo: 0.0,
        color: "amarillo",
        guardarAlmacen: true,
        baja: false,
        idCuenta: "0",
        noMostrarInformeSectores: 0
      },
      maxNameSubproducto: 50,
      tabs: 0,
      mostrarAsociar: false,

      ordenarSubproduct: false,

      //COPY SUB
      listcategoriesCopySub: [],
      listTipo: [],

      //DESCARGAR ETIQUETAS
      numEtiquetas: 1,

      idTpv: "",
      listCuentasSage: [],
      listCuentasGastosSage: [],

      //MENU
      isMenu: false,
      action: "",
      idMenu: this.$route.params.idMenu,
      idCarta: this.$route.params.idCarta,
      menu: {
        idCategoria: 0,
        idProduct: "",
        idProductCarta: "",
        nombre: "",
        descripcion: "",
        imagen: "",
        tipoCarta: "",
        numeroPrimeros: 0,
        numeroSegundos: 0,
        numeroTerceros: 0,
        numeroCuartos: 0,
        numeroQuintos: 0,
        numeroSextos: 0,
        nombreTarifa1: "",
        precioTarifa1: 0,
        nombreTarifa2: "",
        precioTarifa2: 0,
        nombreTarifa3: "",
        precioTarifa3: 0,
        nombreTarifa4: "",
        precioTarifa4: 0,
        updated: "",
        orden: 999,
        noDisponible: false,
        baja: false,
      },

      listCategories: [],
      listProductos: [],
      listPlatos: [],
      listCategoriaMenu: [],
      listProductosTodos: [],
      loadingProductos: false,
      img: "",

      listTipoProducto: [
        {
          value: "",
          label: this.$t("todos"),
        },
        {
          value: "P",
          label: this.$t("pedidos"),
        },
        {
          value: "C",
          label: this.$t("cartaASecas"),
        },
      ],

      //MATERIAS PRIMAS
      listaTipo: [
        { label: this.$t("base"), value: "B" },
        { label: this.$t("extra"), value: "E" },
        { label: this.$t("opcional"), value: "O" },
      ],
      listMateriasPrimas: [],
      listSearchMateriasPrimas: [],
      idMateriaPrima: "",
      tipoAnterior: "",

      listTipo: [],
      listcategoriesCopySub: [],
      nombreMenu: "",
      loading: "",
      editandoPrimero: false,
      editandoSegundo: false,
      editandoTercero: false,
      editandoCuarto: false,
      editandoQuinto: false,
      editandoSexto: false,
      primerPlato: {
        id: 0,
        idMenu: 0,
        nombre: "",
        numero: 1,
      },
      segundoPlato: {
        id: 0,
        idMenu: 0,
        nombre: "",
        numero: 2,
      },
      tercerPlato: {
        id: 0,
        idMenu: 0,
        nombre: "",
        numero: 3,
      },
      cuartoPlato: {
        id: 0,
        idMenu: 0,
        nombre: "",
        numero: 4,
      },
      quintoPlato: {
        id: 0,
        idMenu: 0,
        nombre: "",
        numero: 5,
      },
      sextoPlato: {
        id: 0,
        idMenu: 0,
        nombre: "",
        numero: 6,
      },
      platoSeleccionado: 0,
      productoSeleccionado: null,
      listProductosPlato: [],
      listProductosPlatoId: [],

      menu: {
        plato1: "",
        plato2: "",
        plato3: "",
        plato4: "",
        plato5: "",
        plato6: "",
      },

      platos: [
        { nombrePlato: "", idPlato: 1 },
        { nombrePlato: "", idPlato: 2 },
        { nombrePlato: "", idPlato: 3 },
        { nombrePlato: "", idPlato: 4 },
        { nombrePlato: "", idPlato: 5 },
        { nombrePlato: "", idPlato: 6 },
      ],

      listaPlatos: [],

      nombrePlatoInsert: "",

      idSector: 0,

      tieneDimoni: false,

      categoryList: [],
      businessListPlatos: [],
      idCategoryProductoPlato: 0,
      tieneTspoonlab: false,
      tieneA3Software: false,
      configuradorPLU: false,

      //Modos
      listModos: [],

      //isRetail
      isRetail: false,

      //isExtraAverageChecked
      isExtraAverageChecked: false,
      previousRoute: null,
      tieneCarta: false,
      businessCentral: false,
      categoriasSeleccionadas: [],

      //BUSINESS CENTRAL
      businessCentral: false,
      restriccionBusinessCentral: false,

      //CompanyConfigs
      companyConfigs: [],
      idCompany: 0,

      // Modal para seleccionar categoría al crear en carta
      listCategoriesCarta: [],
      selectedCategoriaCartaId: null,
      modalSelectCategoriaCartaVisible: false,
      cartaProductoData: null,
      cartaPostInsertionCallback: null,

      // Contexto de guardado temporal antes de mostrar modal
      pendingProductSaveContext: null,
    };
  },
  beforeDestroy() {
    // Evitar que timers de debounce disparen peticiones sobre un componente ya destruido
    clearTimeout(this._searchTimer);
    clearTimeout(this._searchTimerCerrado);
  },
  watch: {
    $route(to, from) {
      if (to.params.idProducto) {
        this.idProducto = to.params.idProducto;
        this.getProducto();
        this.getSubproductByProduct();

      }

      if (to.params.idSector) {
        this.idSector = to.params.idSector;
      }

      if (this.idSectorParam);
      {
        this.idSector = this.idSectorParam;
      }
    },
    platoSeleccionado: function (newVal, oldVal) {

      // Cancelar cualquier búsqueda en vuelo y sus timers al cambiar de plato:
      // así una respuesta tardía del plato anterior no repuebla la lista.
      clearTimeout(this._searchTimer);
      clearTimeout(this._searchTimerCerrado);
      this._searchSeq = (this._searchSeq || 0) + 1;
      this._searchSeqCerrado = (this._searchSeqCerrado || 0) + 1;
      this.loadingProductos = false;

      this.listProductosPlatoId = [];

      this.productoSeleccionado = null;

      this.listProductosTodos = [];

      if (this.isClosed) {
        this.getProductsMenuCerrado();
      } else {
        this.getProductosByPlato();
      }

    },
    "menu.nombre": function (newVal, oldVal) {
      this.nombreMenu = newVal;
    },
  },
  computed: {
    ...mapState(["sectores", "listaSectores"]),
    // Opciones del selector de producto: lista buscada + el producto ya seleccionado.
    // Al teclear una búsqueda nueva se vacía listProductosTodos; sin esto el el-select
    // se quedaba sin la opción del valor elegido y aparecía en blanco.
    opcionesProductos() {
      const lista = Array.isArray(this.listProductosTodos) ? this.listProductosTodos : [];
      const sel = this.productoSeleccionado;
      if (sel && sel.id != null && !lista.some((p) => p.id === sel.id)) {
        return [sel, ...lista];
      }
      return lista;
    },
    // Con restricción de Business Central el nombre no se puede editar y viene
    // impuesto por BC, así que el máximo sube de 50 a 100 caracteres.
    maxNameProducts() {
      return this.restriccionBusinessCentral
        ? this.maxNameProductsBusinessCentral
        : this.maxNameProductsEstandar;
    },

    // Tipo de producto segun la nomenclatura de Business Central:
    // PLU2 marca el tipo y PLU3 el subtipo (CON / SUPLEMENTO) o la unidad de medida.
    tipoProductoBC() {
      const plu2 = (this.producto.PLU2 || "").toString().trim().toUpperCase();
      const plu3 = (this.producto.PLU3 || "").toString().trim().toUpperCase();

      if (plu3 === "CON") return "CON";
      if (plu3 === "SUPLEMENTO") return "SUPLEMENTO";
      if (plu2 === "TARIFAS") return "TARIFAS";
      if (plu2 === "FORMATOS") return "FORMATOS";

      return "SIMPLE";
    },

    descripcionFamilia() {
      return this.familiaReplicar.map((m) => m.tipo).join(" + ");
    },

    negociosReplicables() {
      return this.listBusinesses.filter((b) => b.id != this.idBusiness);
    },

    // Un CON o un SUPLEMENTO va siempre a su categoria propia, la que tenga en
    // el negocio origen. Solo el producto base admite que se le elija categoria.
    categoriaFijadaPorTipo() {
      return (
        this.tipoProductoBC === "CON" || this.tipoProductoBC === "SUPLEMENTO"
      );
    },

    showPrice1() {
      // Mostrar tarifa1 si es BC y: selPrice1 activado, o existe namePrice1, o existe price1, o existe PLU3 junto a price1
      const hasName = this.producto.namePrice1 && this.producto.namePrice1.toString().trim() !== "";
      const hasPrice = this.producto.price1 !== null && this.producto.price1 !== undefined && this.producto.price1 !== "" && Number(this.producto.price1) !== 0;
      const hasPlu3 = this.producto.PLU3 && this.producto.PLU3.toString().trim() !== "";
      return this.businessCentral && (this.producto.selPrice1 || hasName || hasPrice || (hasPlu3 && hasPrice));
    },
    showPrice2() {
      const hasName = this.producto.namePrice2 && this.producto.namePrice2.toString().trim() !== "";
      const hasPrice = this.producto.price2 !== null && this.producto.price2 !== undefined && this.producto.price2 !== "" && Number(this.producto.price2) !== 0;
      const hasPlu3 = this.producto.PLU3 && this.producto.PLU3.toString().trim() !== "";
      return this.businessCentral && (this.producto.selPrice2 || hasName || hasPrice || (hasPlu3 && hasPrice));
    },
    showPrice3() {
      const hasName = this.producto.namePrice3 && this.producto.namePrice3.toString().trim() !== "";
      const hasPrice = this.producto.price3 !== null && this.producto.price3 !== undefined && this.producto.price3 !== "" && Number(this.producto.price3) !== 0;
      const hasPlu3 = this.producto.PLU3 && this.producto.PLU3.toString().trim() !== "";
      return this.businessCentral && (this.producto.selPrice3 || hasName || hasPrice || (hasPlu3 && hasPrice));
    },
    showPrice4() {
      const hasName = this.producto.namePrice4 && this.producto.namePrice4.toString().trim() !== "";
      const hasPrice = this.producto.price4 !== null && this.producto.price4 !== undefined && this.producto.price4 !== "" && Number(this.producto.price4) !== 0;
      const hasPlu3 = this.producto.PLU3 && this.producto.PLU3.toString().trim() !== "";
      return this.businessCentral && (this.producto.selPrice4 || hasName || hasPrice || (hasPlu3 && hasPrice));
    },
  },
  methods: {
    getConfigDimoni() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          numConfig: 83,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "general/getConfigTpv",
          config
        ).then(function (response) {
          if (response.data.response) {
            vm.tieneDimoni = true;
          } else {
            vm.tieneDimoni = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getIsRetail() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "general/getIsRetail",
          config
        ).then(function (response) {
          if (response.data.response) {
            vm.isRetail = true;
          } else {
            vm.isRetail = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getConfigTspoonlab() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          numConfig: 112,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "general/getConfigTpv",
          config
        ).then(function (response) {
          if (response.data.response) {
            vm.tieneTspoonlab = true;
          } else {
            vm.tieneTspoonlab = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getConfigConfiguradorPLU() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          numConfig: 117,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "general/getConfigTpv",
          config
        ).then(function (response) {
          if (response.data.response) {
            vm.configuradorPLU = true;
          } else {
            vm.configuradorPLU = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getConfigA3Software() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          numConfig: 113,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "general/getConfigTpv",
          config
        ).then(function (response) {
          if (response.data.response) {
            vm.tieneA3Software = true;
          } else {
            vm.tieneA3Software = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getConfigDistinguirPrecios() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          numConfig: 55,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
        .then(function (response) {
          if (response.data.response) {
            vm.distinguirPrecios = true;
          } else {
            vm.distinguirPrecios = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    cerrarModalReplicar() {
      this.$modal.hide("modal-replicar-carta");
      this.$modal.hide("guardar-o-guardar-replicar");
    },

    cerrarModalProductTarifaMenu() {

      this.$modal.hide("modal-producttarifamenu");


    },
    cargarCuentasPorIdTpv() {
      var config = {
        params: {
          idTpv: this.idTpv,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "importacion/getSageBusinessDataByIdTpv",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.listCuentasSage.push({
              id: "0",
              codigoCuenta: "0",
              codigoSubCuenta: "",
              nombreCuenta: vm.$t("sinCuentaAsociada"),
            });
            vm.listCuentasGastosSage.push({
              id: "0",
              codigoCuenta: "0",
              codigoSubCuenta: "",
              nombreCuenta: vm.$t("sinCuentaAsociada"),
            });
            response.data.result.forEach((cuenta) => {
              if (cuenta.tipo == "B") {
                vm.listCuentasSage.push(cuenta);
              } else if (cuenta.tipo == "G") {
                vm.listCuentasGastosSage.push(cuenta);
              }
            });
            //vm.listCuentasSage = response.data.result;

            vm.respuesta = true;
          }
          vm.loading = false;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getModosPorIdTpv() {
      var config = {
        params: {
          idTpv: this.idTpv,
          idProduct: this.idProducto,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "products/getModosProducts",
          config
        )
        .then(function (response) {
          if (response.data.response) {

            vm.listModos = response.data.result;

          }
          vm.loading = false;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    changeTipo(entrada, producto) {
      var constError = 0;

      if (entrada === 1) {
        if (this.tipoAnterior === "") {
          this.tipoAnterior = producto.tipo;
        } else {
          this.tipoAnterior = "";
        }
      } else {
        this.listSubproductosByProducts.forEach(function (x) {
          if (
            x.idSubproduct === producto.idSubproduct &&
            x.tipo === producto.tipo
          ) {
            constError++;
          }
        });

        if (constError > 1) {
          producto.tipo = this.tipoAnterior;

          swal({
            title: this.$t("atencion"),
            text: this.$t("noPuedeHaberDosMateriasPrimasConElMismoTipo"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });
        }
      }
    },

    handleTabChange(tabIndex, newTab, oldTab) {
      if (newTab.id == "3") {
        this.loadingGeneral = Loading.service({ text: this.$t("cargando") });
        this.peticionesFinSpiner = 2;
        this.nPeticiones = 0;

        this.getCasas();
        this.getProveedores();

        this.getEtiquetas();
      }
    },

    handleTabChange2(tabIndex, newTab, oldTab) {
      // console.log(this.businessListPlatos[tabIndex]);
    },
    /*descargarCodigos() {


                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };
                var params = {
                    idProduct: this.idProducto,
                    numEtiquetas: this.numEtiquetas,

                    jwt: this.$store.getters.jwt
                };

                let vm = this;
                let controller = "downloadBarCode";
                this.axios.post(this.$store.getters.apiUrl + 'products/' + controller, params, config)
                    .then(function (response) {

                        if (response.data.response) {

                            let notify = "descargadas";
                            vm.$notify({
                                message: 'Etiquetas ' + notify + ' correctamente',
                                icon: 'nc-icon nc-check-2',
                                timeout: 2000,
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'success'
                            });


                        } else {
                            swal({
                                title: `Atención`,
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    }).catch(function (error) {
                    console.log(error);
                    vm.inProgress = false;
                });

            },*/

    openModalNuevoSubproducto() {
      this.loadingGeneral = Loading.service({ text: this.$t("cargando") });
      this.peticionesFinSpiner = 2;
      this.nPeticiones = 0;

      this.getCasas();
      this.getProveedores();
      this.getEtiquetas();

      this.$modal.show("modal-crear-subproductos");
    },


    getPlanos() {

      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt
        },
        headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      return this.axios.get(this.$store.getters.apiUrl + "online/getPlanos", config)
        .then(function (response) {
          if (response.data.response) {

            vm.listPlanos = response.data.result.salones;
          }

        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getCasas() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "subproducts/getCasasByBusinesses",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            if (response.data.result.length === 0) {
              let casas = {
                name: vm.$t("sinCasas"),
                id: 0,
              };

              vm.listCasas.push(casas);
            }

            for (let i = 0; i < response.data.result.length; i++) {
              if (i === 0) {
                let casas = {
                  name: vm.$t("sinCasas"),
                  id: 0,
                };

                vm.listCasas.push(casas);
              }

              let casasname = {
                name: response.data.result[i].name,
                id: response.data.result[i].id,
              };

              vm.listCasas.push(casasname);
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },
    getSubproductsByProductsMenu() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          idProduct: this.idProducto,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "products/getSubproductsByProductsMenu",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.listSubproductosPlatos = response.data.result

            vm.listSubproductosPlatos.forEach((plato) => {

              plato.products.forEach((product) => {

                product.subproducts.forEach((subproduct) => {
                  const newPrice = parseFloat(
                    subproduct.precioCompra / ((100 + subproduct.iva) / 100)
                  );
                  subproduct.precioCompraSinIva = newPrice;
                });

              });

            });

          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },
    calcularCosto(sinIva, isExtraAverageChecked, tarifa = 1) {
      // console.log("=== INICIO CALCULO ===");
      // console.log("sinIva:", sinIva, "| tarifa:", tarifa, "| extras:", isExtraAverageChecked);

      let total = 0;
      let totalOpcionales = 0;
      let numOpcionales = 0;
      let totalExtras = 0;
      let vm = this;

      const getPartes = (x) => {
        if (tarifa === 2) return x.partes2;
        if (tarifa === 3) return x.partes3;
        if (tarifa === 4) return x.partes4;
        return x.partes;
      };

      const asignarResultado = (valor) => {
        if (sinIva) {
          if (tarifa === 1) vm.producto.precioCosteSinIVA = valor;
          if (tarifa === 2) vm.producto.precioCosteSinIVA2 = valor;
          if (tarifa === 3) vm.producto.precioCosteSinIVA3 = valor;
          if (tarifa === 4) vm.producto.precioCosteSinIVA4 = valor;
        } else {
          if (tarifa === 1) vm.producto.precioCoste = valor;
          if (tarifa === 2) vm.producto.precioCoste2 = valor;
          if (tarifa === 3) vm.producto.precioCoste3 = valor;
          if (tarifa === 4) vm.producto.precioCoste4 = valor;
        }
      };

      if (this.producto.isMenu) {
        if (this.listSubproductosPlatos.length > 0) {
          this.loadingGeneral = Loading.service({ text: this.$t("cargando") });

          if (sinIva) {
            asignarResultado(0);
            this.listSubproductosPlatos.forEach((plato) => {
              let totalPlato = 0;
              let totalExtrasPlato = 0;
              plato.products.forEach((product) => {
                let totalProducto = 0;
                let totalOpcionalesProducto = 0;
                let numOpcionalesProducto = 0;
                product.subproducts.forEach(function (x) {
                  const partes = getPartes(x);
                  if (x.tipo === "B") totalProducto += vm.getPrecioCompraSinIVA(x, true, partes);
                  if (x.tipo === "O") { numOpcionalesProducto++; totalOpcionalesProducto += vm.getPrecioCompraSinIVA(x, true, partes); }
                  if (isExtraAverageChecked && x.tipo === "E") {
                    let vecesVendidas = x.veces_vendido_extra;
                    let precioExtra = vm.getPrecioCompraSinIVA(x, true, partes);
                    if (vecesVendidas != 0) totalExtrasPlato += precioExtra / vecesVendidas;
                  }
                });
                product.precioCosteSinIVA = numOpcionalesProducto === 0
                  ? totalProducto
                  : totalProducto + totalOpcionalesProducto / numOpcionalesProducto;
                totalPlato += product.precioCosteSinIVA;
              });
              let mediaTotal = totalPlato + totalExtrasPlato;
              if (!vm.isClosed) mediaTotal = totalPlato / plato.numeroPlatos + totalExtrasPlato;
              total += mediaTotal;
            });
          } else {
            asignarResultado(0);
            this.listSubproductosPlatos.forEach((plato) => {
              let totalPlato = 0;
              let totalExtrasPlato = 0;
              plato.products.forEach((product) => {
                let totalProducto = 0;
                let totalOpcionalesProducto = 0;
                let numOpcionalesProducto = 0;
                product.subproducts.forEach(function (x) {
                  const partes = getPartes(x);
                  if (x.tipo === "B") totalProducto += vm.getPrecioCompra(x, true, partes);
                  if (x.tipo === "O") { numOpcionalesProducto++; totalOpcionalesProducto += vm.getPrecioCompra(x, true, partes); }
                  if (isExtraAverageChecked && x.tipo === "E") {
                    let vecesVendidas = x.veces_vendido_extra;
                    let precioExtra = vm.getPrecioCompra(x, true, partes);
                    if (vecesVendidas != 0) totalExtrasPlato += precioExtra / vecesVendidas;
                  }
                });
                product.precioCoste = numOpcionalesProducto === 0
                  ? totalProducto
                  : totalProducto + totalOpcionalesProducto / numOpcionalesProducto;
                totalPlato += product.precioCoste;
              });
              let mediaTotal = totalPlato + totalExtrasPlato;
              if (!vm.isClosed) mediaTotal = totalPlato / plato.numeroPlatos + totalExtrasPlato;
              total += mediaTotal;
            });
          }

          asignarResultado(total);
          this.loadingGeneral.close();
        }

      } else {

        if (sinIva) {
          asignarResultado(0);
          this.listSubproductosByProducts.forEach(function (x) {
            const partes = getPartes(x);
            const precio = vm.getPrecioCompraSinIVA(x, true, partes);
            // console.log(`[${x.tipo}] ${x.name} | partes: ${partes} | escandallo: ${x.escandallo} | precioCompra: ${x.precioCompra} | dto: ${x.dtoCompra} | resultado: ${precio}`);
            if (x.tipo === "B") total += precio;
            if (x.tipo === "O") { numOpcionales++; totalOpcionales += precio; }
            if (isExtraAverageChecked && x.tipo === "E") {
              let vecesVendidas = x.veces_vendido_extra;
              if (vecesVendidas != 0) totalExtras += precio / vecesVendidas;
            }
          });
          // console.log("total bases:", total);
          // console.log("totalOpcionales:", totalOpcionales, "| numOpcionales:", numOpcionales);
          // console.log("media opcionales:", numOpcionales > 0 ? totalOpcionales / numOpcionales : 0);
          // console.log("totalExtras:", totalExtras);
          // console.log("RESULTADO FINAL:", numOpcionales === 0 ? total + totalExtras : total + totalOpcionales / numOpcionales + totalExtras);

          asignarResultado(
            numOpcionales === 0
              ? total + totalExtras
              : total + totalOpcionales / numOpcionales + totalExtras
          );

        } else {
          asignarResultado(0);
          this.listSubproductosByProducts.forEach(function (x) {
            const partes = getPartes(x);
            const precio = vm.getPrecioCompra(x, true, partes);
            // console.log(`[${x.tipo}] ${x.name} | partes: ${partes} | escandallo: ${x.escandallo} | precioCompra: ${x.precioCompra} | dto: ${x.dtoCompra} | resultado: ${precio}`);
            if (x.tipo === "B") total += precio;
            if (x.tipo === "O") { numOpcionales++; totalOpcionales += precio; }
            if (isExtraAverageChecked && x.tipo === "E") {
              let vecesVendidas = x.veces_vendido_extra;
              if (vecesVendidas != 0) totalExtras += precio / vecesVendidas;
            }
          });
          // console.log("total bases:", total);
          // console.log("totalOpcionales:", totalOpcionales, "| numOpcionales:", numOpcionales);
          // console.log("media opcionales:", numOpcionales > 0 ? totalOpcionales / numOpcionales : 0);
          // console.log("totalExtras:", totalExtras);
          // console.log("RESULTADO FINAL:", numOpcionales === 0 ? total + totalExtras : total + totalOpcionales / numOpcionales + totalExtras);

          asignarResultado(
            numOpcionales === 0
              ? total + totalExtras
              : total + totalOpcionales / numOpcionales + totalExtras
          );
        }
      }
    },
    calcularCostoTarifas(tarifa, sinIva) {
      let total = 0;
      let totalOpcionales = 0;
      let numOpcionales = 0;


      let vm = this;

      if (this.producto.isMenu) {
        //Preparamos la carga, ya que vamos a recoger todos los productos asociados con el menu
        if (this.listSubproductosPlatos.length > 0) {

          this.loadingGeneral = Loading.service({ text: this.$t("cargando") });

          //Si es sin IVA
          if (sinIva) {

            switch (tarifa) {
              case 2:
                this.producto.precioCosteSinIVA2 = 0;
                break;
              case 3:
                this.producto.precioCosteSinIVA3 = 0;
                break;
              case 4:
                this.producto.precioCosteSinIVA4 = 0;
                break;
            }

            //Recorremos los platos
            this.listSubproductosPlatos.forEach((plato) => {
              let totalPlato = 0;

              //Recorremos sus productos
              plato.products.forEach((product) => {
                let totalProducto = 0;
                let totalOpcionalesProducto = 0;
                let numOpcionalesProducto = 0;

                //Recorremos sus subproductos
                product.subproducts.forEach(function (x) {
                  if (x.tipo === "B") {
                    totalProducto += vm.getPrecioCompraSinIVATarifas(x, true);
                  }

                  if (x.tipo === "O") {
                    numOpcionalesProducto++;
                    totalOpcionalesProducto += vm.getPrecioCompraSinIVATarifas(x, true);
                  }
                });

                //Calculamos el precio del producto

                //Vamos sumando al total del plato
                switch (tarifa) {
                  case 2:

                    if (numOpcionalesProducto === 0) {
                      product.precioCosteSinIVA2 = totalProducto;
                    } else {
                      product.precioCosteSinIVA2 =
                        totalProducto + totalOpcionalesProducto / numOpcionalesProducto;
                    }

                    totalPlato += product.precioCosteSinIVA2;
                    break;
                  case 3:

                    if (numOpcionalesProducto === 0) {
                      product.precioCosteSinIVA3 = totalProducto;
                    } else {
                      product.precioCosteSinIVA3 =
                        totalProducto + totalOpcionalesProducto / numOpcionalesProducto;
                    }

                    totalPlato += product.precioCosteSinIVA3;
                    break;
                  case 4:

                    if (numOpcionalesProducto === 0) {
                      product.precioCosteSinIVA4 = totalProducto;
                    } else {
                      product.precioCosteSinIVA4 =
                        totalProducto + totalOpcionalesProducto / numOpcionalesProducto;
                    }

                    totalPlato += product.precioCosteSinIVA4;
                    break;
                }

              });

              let mediaTotal = totalPlato;
              //Una vez que ya no quedan más productos, dividimos el total del plato por el número de productos para sacar la media
              if (!vm.isClosed) {
                mediaTotal = totalPlato / plato.numeroPlatos;
              }

              //Con la media, sumaremos al total del menú
              total += mediaTotal;
            });

            switch (tarifa) {
              case 2:
                this.producto.precioCosteSinIVA2 = total;
                break;
              case 3:
                this.producto.precioCosteSinIVA3 = total;
                break;
              case 4:
                this.producto.precioCosteSinIVA4 = total;
                break;
            }


            this.loadingGeneral.close();

          } else {

            let tarifaElegida = 2;

            switch (tarifa) {
              case 2:
                this.producto.precioCoste2 = 0;
                tarifaElegida = 2;
                break;
              case 3:
                this.producto.precioCoste3 = 0;
                tarifaElegida = 3;
                break;
              case 4:
                this.producto.precioCoste4 = 0;
                tarifaElegida = 4;
                break;
            }

            this.listSubproductosPlatos.forEach((plato) => {
              let totalPlato = 0;

              //Recorremos sus productos
              plato.products.forEach((product) => {
                let totalProducto = 0;
                let totalOpcionalesProducto = 0;
                let numOpcionalesProducto = 0;

                product.subproducts.forEach(function (x) {

                  if (x.tipo === "B") {
                    totalProducto += vm.getPrecioCompraTarifas(x, true, tarifaElegida);
                  }

                  if (x.tipo === "O") {
                    numOpcionalesProducto++;
                    totalOpcionalesProducto += vm.getPrecioCompraTarifas(x, true, tarifaElegida);
                  }
                });

                switch (tarifa) {
                  case 2:

                    if (numOpcionalesProducto === 0) {
                      product.precioCoste2 = totalProducto;
                    } else {
                      product.precioCoste2 =
                        totalProducto + totalOpcionalesProducto / numOpcionalesProducto;
                    }

                    totalPlato += product.precioCoste2;
                    break;
                  case 3:

                    if (numOpcionalesProducto === 0) {
                      product.precioCoste3 = totalProducto;
                    } else {
                      product.precioCoste3 =
                        totalProducto + totalOpcionalesProducto / numOpcionalesProducto;
                    }

                    totalPlato += product.precioCoste3;
                    break;
                  case 4:

                    if (numOpcionalesProducto === 0) {
                      product.precioCoste4 = totalProducto;
                    } else {
                      product.precioCoste4 =
                        totalProducto + totalOpcionalesProducto / numOpcionalesProducto;
                    }

                    totalPlato += product.precioCoste4;
                    break;
                }

              });

              let mediaTotal = totalPlato;
              //Una vez que ya no quedan más productos, dividimos el total del plato por el número de productos para sacar la media
              if (!vm.isClosed) {
                mediaTotal = totalPlato / plato.numeroPlatos;
              }

              //Con la media, sumaremos al total del menú
              total += mediaTotal;

            });

            switch (tarifa) {
              case 2:
                this.producto.precioCoste2 = total;
                break;
              case 3:
                this.producto.precioCoste3 = total;
                break;
              case 4:
                this.producto.precioCoste4 = total;
                break;
            }

            this.loadingGeneral.close();
          }

        }

      } else {
        //sin iva
        let tarifaElegida = 2;
        switch (tarifa) {
          case 2:
            this.producto.precioCoste2 = 0;
            tarifaElegida = 2;
            break;
          case 3:
            this.producto.precioCoste3 = 0;
            tarifaElegida = 3;
            break;
          case 4:
            this.producto.precioCoste4 = 0;
            tarifaElegida = 4;
            break;
        }
        //fin sin iva
        //Comprobamos qué campo se quiere calcular
        if (sinIva) {
          switch (tarifa) {
            case 2:
              this.producto.precioCosteSinIVA2 = 0;
              break;
            case 3:
              this.producto.precioCosteSinIVA3 = 0;
              break;
            case 4:
              this.producto.precioCosteSinIVA4 = 0;
              break;
          }

          //Llamamos a las respectivas funciones
          this.listSubproductosByProducts.forEach(function (x) {
            if (x.tipo === "B") {
              total += vm.getPrecioCompraSinIVATarifas(x, true, tarifaElegida);
            }

            if (x.tipo === "O") {
              numOpcionales++;
              totalOpcionales += vm.getPrecioCompraSinIVATarifas(x, true, tarifaElegida);
            }
          });

          //Calculamos en función de los opcionales

          switch (tarifa) {
            case 2:

              if (numOpcionales === 0) {
                this.producto.precioCosteSinIVA2 = total;
              } else {
                this.producto.precioCosteSinIVA2 =
                  total + totalOpcionales / numOpcionales;
              }

              break;
            case 3:

              if (numOpcionales === 0) {
                this.producto.precioCosteSinIVA3 = total;
              } else {
                this.producto.precioCosteSinIVA3 =
                  total + totalOpcionales / numOpcionales;
              }

              break;
            case 4:

              if (numOpcionales === 0) {
                this.producto.precioCosteSinIVA4 = total;
              } else {
                this.producto.precioCosteSinIVA4 =
                  total + totalOpcionales / numOpcionales;
              }

              break;
          }
        } else {
          let tarifaElegida = 2;
          switch (tarifa) {
            case 2:
              this.producto.precioCoste2 = 0;
              tarifaElegida = 2;
              break;
            case 3:
              this.producto.precioCoste3 = 0;
              tarifaElegida = 3;
              break;
            case 4:
              this.producto.precioCoste4 = 0;
              tarifaElegida = 4;
              break;
          }

          //Llamamos a las respectivas funciones
          this.listSubproductosByProducts.forEach(function (x) {
            if (x.tipo === "B") {
              total += vm.getPrecioCompraTarifas(x, true, tarifaElegida);
            }

            if (x.tipo === "O") {
              numOpcionales++;
              totalOpcionales += vm.getPrecioCompraTarifas(x, true, tarifaElegida);
            }
          });

          //Calculamos en función de los opcionales


          switch (tarifa) {
            case 2:

              if (numOpcionales === 0) {
                this.producto.precioCoste2 = total;
              } else {
                this.producto.precioCoste2 = total + totalOpcionales / numOpcionales;
              }

              break;

            case 3:

              if (numOpcionales === 0) {
                this.producto.precioCoste3 = total;
              } else {
                this.producto.precioCoste3 = total + totalOpcionales / numOpcionales;
              }

              break;

            case 4:

              if (numOpcionales === 0) {
                this.producto.precioCoste4 = total;
              } else {
                this.producto.precioCoste4 = total + totalOpcionales / numOpcionales;
              }

              break;
          }
        }
      }

    },
    getProveedores() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "subproducts/getSuppliersByBusinesses",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            if (response.data.result.length === 0) {
              let category = {
                name: vm.$t("sinProveedores"),
                id: 0,
              };

              vm.listProveedores.push(category);
            }

            for (let i = 0; i < response.data.result.length; i++) {
              if (i === 0) {
                let proveedor = {
                  name: vm.$t("sinProveedores"),
                  id: 0,
                };

                vm.listProveedores.push(proveedor);
              }

              let proveedorname = {
                name: response.data.result[i].name,
                id: response.data.result[i].id,
              };

              vm.listProveedores.push(proveedorname);
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },
    getEtiquetas() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "subproducts/getTagsByBusiness",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            if (response.data.result.length === 0) {
              let category = {
                name: vm.$t("sinEtiqueta"),
                id: 0,
              };

              vm.listEtiquetas.push(category);
            }

            for (let i = 0; i < response.data.result.length; i++) {
              if (i === 0) {
                let category = {
                  name: vm.$t("sinEtiqueta"),
                  id: 0,
                };

                vm.listEtiquetas.push(category);
              }

              let categoryname = {
                name: response.data.result[i].name,
                id: response.data.result[i].id,
              };

              vm.listEtiquetas.push(categoryname);
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },
    getIva() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      return this.axios
        .get(this.$store.getters.apiUrl + "general/getIvaByTpv", config)
        .then(function (response) {
          if (response.data.response) {
            if (response.data.result) {
              response.data.result.forEach((iva) => {

                if (!vm.listIva.includes(iva)) vm.listIva.push(iva);
              })
            } else {
              vm.listIva = false;
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    agregarSubproductos() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      let controller;

      this.loadingGeneral = Loading.service({ text: this.$t("cargando") });

      var params = {
        idsSubproductos: this.idsSubproductos,
        idBusiness: this.idBusiness,
        idProduct: this.idProducto,

        jwt: this.$store.getters.jwt,
      };

      controller = "saveSubproductByProduct";

      this.axios
        .post(
          this.$store.getters.apiUrl + "products/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.loadingGeneral.close();

            let notify = vm.$t("agregadas");
            vm.$notify({
              message:
                vm.$t("materiasPrimas") +
                " " +
                notify +
                " " +
                vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });

            vm.$modal.hide("modalagregarSubproducto");
            vm.idsSubproductos = [];
            vm.getSubproductByProduct();
            vm.search = "";
            vm.listSubproducts = [];
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        });
    },

    remoteMethod(query) {
      let busqueda = this.search;

      this.loading = true;

      const controller = "searchSubproductsByProduct/" + this.search;

      var config = {
        params: {
          pag: this.pag,
          idBusiness: this.idBusiness,
          idProduct: this.idProducto,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "products/" + controller, config)
        .then(function (response) {
          if (response.data.response) {
            vm.listSubproducts = response.data.result.listSubproduct;
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.result,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    openModalCopiarSub() {
      this.$modal.show("modal-copysub");
    },
    openModalMenuTarifaProduct() {
      this.$modal.show("modal-producttarifamenu");
    },
    openModalReplicaCarta() {
      this.$modal.show("modal-replicar-carta");
    },

    openModalAgregarSubproducto() {
      this.$modal.show("modalagregarSubproducto");
    },

    openModalGuardarOguardarReplicar() {
      this.$modal.show("guardar-o-guardar-replicar");
    },

    getSubproductByProduct() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          idProduct: this.idProducto,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      return this.axios
        .get(
          this.$store.getters.apiUrl + "products/getSubproductByProduct",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.listSubproductosByProducts = response.data.result;
            vm.listSubproductosByProducts.forEach((subproduct) => {
              const newPrice = parseFloat(
                subproduct.precioCompra / ((100 + subproduct.iva) / 100)
              );
              subproduct.precioCompraSinIva = newPrice;
            });
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    eliminarSubproducto(p) {
      swal({
        title: this.$t("estasSeguroDeBorrarLaMateriaPrima"),
        text: this.$t("estaOperacionNoSePuedeDeshacer"),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: this.$t("siDeseoBorrarlo"),
        cancelButtonText: this.$t("cancelar"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.eliminarSubproduct(p);
        }
      });
    },

    editSubproduct() {
      let vm = this;

      this.listSubproductosByProducts.forEach(function (x) {
        if (x.tipo === "O") {
          if (vm.producto.numOpcionales === 0) {
            vm.producto.numOpcionales = 1;
          }
        }

        if (x.tipo === "E") {
          vm.producto.seleccionarIngredientes = true;
        }
      });

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let controller;

      //TODO FALTA TESTEAR
      var params = {
        listSubproducts: this.listSubproductosByProducts,
        idBusiness: this.idBusiness,
        jwt: this.$store.getters.jwt,
        idProduct: this.idProducto,
      };

      controller = "editSubproductByProduct";

      return this.axios
        .post(
          this.$store.getters.apiUrl + "products/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.loadingGeneral.close();

            let notify = vm.$t("modificadas");

            vm.$notify({
              message:
                vm.$t("materiasPrimas") +
                " " +
                notify +
                " " +
                vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        });
    },

    eliminarSubproduct(p) {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        subproduct: p,
        idProduct: this.idProducto,
        idBusiness: this.idBusiness,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "deleteSubproductByProduct";
      this.axios
        .post(
          this.$store.getters.apiUrl + "products/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.$notify({
              message: vm.$t("materiaPrimaEliminadaCorrectamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });

            vm.getSubproductByProduct();
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        });
    },

    identificacionNegocio() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/identifyBusiness", config)
        .then(function (response) {
          if (response.data.response) {
            vm.nombreNegocio = response.data.result;
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },

    checkCampos() {
      if (this.producto.nombreProducto.length > this.maxNameProducts) {
        swal({
          title: this.$t("atencion"),
          text:
            this.$t("laLongitudDelNombreNoPuedeSerMayorDe") +
            this.maxNameProducts +
            ".",
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
        return false;
      } else if (
        this.producto.nombreProducto === null ||
        this.producto.nombreProducto.length === 0
      ) {
        swal({
          title: this.$t("atencion"),
          text: this.$t(
            "relleneTodosLosDatosMarcadosConAsteriscoAntesDeEnviar"
          ),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
        return false;
      } else {
        return true;
      }
    },

    getSupraCategoryConfig() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;

      vm.inProgress = true;

      this.supraCategoryConfigPromise = this.axios
        .get(
          this.$store.getters.apiUrl + "supracategories/getSupraCategoryConfigByBusiness",
          config
        )
        .then(function (response) {
          if (response.data.response && response.data.result && response.data.result.found === true) {
            vm.mostrarSupraCategorias = true;
            vm.supraCategoriaObligatoria = !!response.data.result.mandatory;
          } else {
            vm.mostrarSupraCategorias = false;
            vm.supraCategoriaObligatoria = false;
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.mostrarSupraCategorias = false;
          vm.supraCategoriaObligatoria = false;
        })
        .then(function () {
          vm.inProgress = false;
        });

      return vm.supraCategoryConfigPromise;
    },

    async puedeGuardarConSupraCategoria() {
      await this.supraCategoryConfigPromise;
      await this.supraCategoriesPromise;

      const hayCategoriasParaElegir = this.listSupraCategories && this.listSupraCategories.length > 0;

      if (
        this.mostrarSupraCategorias &&
        this.supraCategoriaObligatoria &&
        !this.producto.idSupraCategory &&
        hayCategoriasParaElegir
      ) {
        swal({
          title: this.$t("atencion"),
          text: this.$t("supraCategoriaObligatoria"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
        return false;
      }

      return true;
    },
    getSupraCategories() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      return this.axios
        .get(
          this.$store.getters.apiUrl + "supracategories/getSupraCategoriesByBusiness",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.listSupraCategories = [];
            for (let i = 0; i < response.data.result.length; i++) {
              vm.listSupraCategories.push({
                id: parseInt(response.data.result[i].id),
                name: response.data.result[i].name,
              });
            }
            // Si el id no existe en la lista, forzar a 0
            if (vm.producto.idSupraCategory && vm.producto.idSupraCategory !== 0) {
              const found = vm.listSupraCategories.find(
                (s) => s.id === parseInt(vm.producto.idSupraCategory)
              );
              if (!found) {
                vm.producto.idSupraCategory = 0;
              }
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getCategory() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      return this.axios
        .get(
          this.$store.getters.apiUrl + "products/getCategoryByBusinesses",
          config
        )
        .then(function (response) {
          vm.loadingCategories = false;
          if (response.data.response) {
            if (response.data.result.length === 0) {
              vm.listCategory.push(category);
            } else {
              if (!vm.idProducto) {
                vm.producto.idCategory = response.data.result[0].id;
              }
              for (let i = 0; i < response.data.result.length; i++) {
                let category = {
                  name: response.data.result[i].name,
                  id: response.data.result[i].id,
                };

                vm.listCategory.push(category);
              }
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getProducto() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          idProduct: this.idProducto,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      return this.axios
        .get(this.$store.getters.apiUrl + "products/getProductById", config)
        .then(function (response) {
          if (response.data.response) {
            vm.producto = response.data.result;

            // console.log("el producto", vm.producto);
            // console.log("la response", response.data.result)

            vm.producto.grupoEnlazado = (vm.producto.grupoEnlazado && vm.producto.grupoEnlazado !== "0" && vm.producto.grupoEnlazado !== 0) ? Number(vm.producto.grupoEnlazado) : "";
            vm.producto.idSupraCategory = vm.producto.idSupraCategory ? parseInt(vm.producto.idSupraCategory) : 0;
            //Si tiene menu
            if (vm.producto.isMenu == 1) {
              vm.producto.isMenu = true;
              vm.producto.wasMenu = true;
              //Lo consigue y consigue los subproductos
              vm.getMenuById();
              vm.getSubproductsByProductsMenu();
            } else {
              vm.producto.isMenu = false;
              vm.producto.wasMenu = false;
            }
            vm.producto.xname = response.data.result.nombreProducto;
            vm.versionTpv = response.data.result.versionTpv;



            if (!response.data.result.printerName) {
              vm.producto.printerName = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.printerName2) {
              vm.producto.printerName2 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.printerPDAName2) {
              vm.producto.printerPDAName2 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.impresionPlano1) {
              vm.producto.impresionPlano1 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.copiaImpresionPlano1) {
              vm.producto.copiaImpresionPlano1 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.impresionPlano2) {
              vm.producto.impresionPlano2 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.copiaImpresionPlano2) {
              vm.producto.copiaImpresionPlano2 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.impresionPlano3) {
              vm.producto.impresionPlano3 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.copiaImpresionPlano3) {
              vm.producto.copiaImpresionPlano3 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.impresionPlano4) {
              vm.producto.impresionPlano4 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.copiaImpresionPlano4) {
              vm.producto.copiaImpresionPlano4 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.impresionPlano5) {
              vm.producto.impresionPlano5 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.copiaImpresionPlano5) {
              vm.producto.copiaImpresionPlano5 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.impresionPlano6) {
              vm.producto.impresionPlano6 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.copiaImpresionPlano6) {
              vm.producto.copiaImpresionPlano6 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.impresionPlano7) {
              vm.producto.impresionPlano7 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.copiaImpresionPlano7) {
              vm.producto.copiaImpresionPlano7 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.impresionPlano8) {
              vm.producto.impresionPlano8 = vm.$t("ningunaSeleccionada");
            } if (!response.data.result.copiaImpresionPlano8) {
              vm.producto.copiaImpresionPlano8 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.impresionPlanoKDS1) {
              vm.producto.impresionPlanoKDS1 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.copiaImpresionPlanoKDS1) {
              vm.producto.copiaImpresionPlanoKDS1 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.impresionPlanoKDS2) {
              vm.producto.impresionPlanoKDS2 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.copiaImpresionPlanoKDS2) {
              vm.producto.copiaImpresionPlanoKDS2 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.impresionPlanoKDS3) {
              vm.producto.impresionPlanoKDS3 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.copiaImpresionPlanoKDS3) {
              vm.producto.copiaImpresionPlanoKDS3 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.impresionPlanoKDS4) {
              vm.producto.impresionPlanoKDS4 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.copiaImpresionPlanoKDS4) {
              vm.producto.copiaImpresionPlanoKDS4 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.impresionPlanoKDS5) {
              vm.producto.impresionPlanoKDS5 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.copiaImpresionPlanoKDS5) {
              vm.producto.copiaImpresionPlanoKDS5 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.impresionPlanoKDS6) {
              vm.producto.impresionPlanoKDS6 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.copiaImpresionPlanoKDS6) {
              vm.producto.copiaImpresionPlanoKDS6 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.impresionPlanoKDS7) {
              vm.producto.impresionPlanoKDS7 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.copiaImpresionPlanoKDS7) {
              vm.producto.copiaImpresionPlanoKDS7 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.impresionPlanoKDS8) {
              vm.producto.impresionPlanoKDS8 = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.copiaImpresionPlanoKDS8) {
              vm.producto.copiaImpresionPlanoKDS8 = vm.$t("ningunaSeleccionada");
            }

            if (!response.data.result.impresionKDSTPV) {
              vm.producto.impresionKDSTPV = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.copiaImpresionKDSTPV) {
              vm.producto.copiaImpresionKDSTPV = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.impresionKDSPDA) {
              vm.producto.impresionKDSPDA = vm.$t("ningunaSeleccionada");
            }
            if (!response.data.result.copiaImpresionKDSPDA) {
              vm.producto.copiaImpresionKDSPDA = vm.$t("ningunaSeleccionada");
            }

            if (!response.data.result.printerPDAName) {
              vm.producto.printerPDAName = vm.$t("ningunaSeleccionada");
            }

            if (response.data.result.baja) {
              vm.producto.baja = false;
            } else {
              vm.producto.baja = true;
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getProductobyName(idBusiness, productoObj) {
      var config = {
        params: {
          idBusiness: idBusiness,
          nameProduct: productoObj.name,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "products/getProductsbyName", config)
        .then(function (response) {
          if (response.data.response) {
            vm.idCategoryProductoPlato = response.data.result;
          }
        });
    },
    getPrinters() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      return this.axios
        .get(
          this.$store.getters.apiUrl + "printer/getPrintersByBusinesses",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            let printer = {
              name: vm.$t("ningunaSeleccionada"),
              id: 0,
            };

            vm.listPrinter.push(printer);

            for (let i = 0; i < response.data.result.impresoras.length; i++) {
              let printername = {
                name: response.data.result.impresoras[i],
              };

              vm.listPrinter.push(printername);
            }

            vm.listKds.push(printer);

            for (let i = 0; i < response.data.result.kds.length; i++) {
              let printername = {
                name: response.data.result.kds[i],
              };

              vm.listKds.push(printername);
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    guardarSectores() {
      if (this.idSector != 0) {

        let controller = "getBusinessesBySector";

        var config = {
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          params: {
            jwt: this.$store.getters.jwt,
          },
        };

        var params = {
          idBusiness: parseInt(this.idBusiness),
          idSector: this.idSector,
          product: this.producto,
          jwt: this.$store.getters.jwt,
        };

        this.loadingGeneral = Loading.service({ text: this.$t("cargando") });
        let vm = this;
        this.axios
          .post(
            this.$store.getters.apiUrl + "products/" + controller,
            params,
            config
          )
          .then(function (response) {
            vm.inProgress = false;

            if (response.data.response) {
              var config = {
                params: {
                  jwt: vm.$store.getters.jwt,
                },
                headers: { Authorization: "Bearer " + vm.$store.getters.jwt },
              };

              var params = {
                listBusinesses: response.data.result,
                idBusiness: vm.idBusiness,
                producto: vm.producto,
                jwt: vm.$store.getters.jwt,
              };

              vm.axios
                .post(
                  vm.$store.getters.apiUrl +
                  "products/replyCategoriesByBusiness",
                  params,
                  config
                )
                .then(function (response) {

                  vm.inProgress = false;

                  if (response.data.response) {
                    var config = {
                      params: {
                        jwt: vm.$store.getters.jwt,
                      },
                      headers: {
                        Authorization: "Bearer " + vm.$store.getters.jwt,
                      },
                    };

                    var params = {
                      listBusinesses: response.data.result,
                      idBusiness: vm.idBusiness,
                      listSubproduct: vm.listSubproductosByProducts,
                      product: vm.producto,
                      menu: vm.platos,
                      productosMenu: vm.listSubproductosPlatos,
                      isMenu: vm.producto.isMenu,
                      jwt: vm.$store.getters.jwt,
                      subproduct: vm.subproducto,
                      sectores: true,
                    };

                    vm.axios
                      .post(
                        vm.$store.getters.apiUrl + "products/replyProductSectores",
                        params,
                        config
                      )
                      .then(function (response) {
                        vm.inProgress = false;

                        if (response.data.response) {
                          vm.loadingGeneral.close();

                          let notify = vm.idProducto ? "actualizado" : "creado";

                          vm.$notify({
                            message:
                              vm.$t("producto") +
                              " " +
                              notify +
                              " " +
                              vm.$t("correctamente"),
                            icon: "nc-icon nc-check-2",
                            timeout: 2000,
                            horizontalAlign: "right",
                            verticalAlign: "top",
                            type: "success",
                          });

                          if (vm.previousRoute === "diagnostico-carta") {
                            vm.$router.push({
                              name: "diagnostico-carta",
                              params: {
                                idBusiness: vm.idBusiness,
                                idCarta: vm.idCarta
                              }
                            });
                          } else {
                            vm.$router.push({
                              name: "productos",
                              query: { filtro: vm.filtro },
                              params: {
                                idBusiness: vm.idBusiness,
                                idSubproducto: vm.idSubproducto,
                                pag: vm.pag,
                              },
                            });
                          };
                        } else {
                          vm.loadingGeneral.close();

                          if (response.data.message != undefined) {
                            console.log("Ocurrió un error inesperado:\n");
                            console.log(response.data.message);
                          }

                          swal({
                            title: vm.$t("atencion"),
                            text: response.data.message
                              ? response.data.message
                              : vm.$t("errorInesperadoEnvioCorreos"),
                            confirmButtonClass: "btn btn-info btn-fill",
                            type: "error",
                          });
                        }
                      })
                      .catch(function (error) {
                        console.log(error);
                        vm.inProgress = false;
                      });
                  } else {
                    vm.loadingGeneral.close();
                    swal({
                      title: vm.$t("atencion"),
                      text: response.data.message,
                      confirmButtonClass: "btn btn-info btn-fill",
                      type: "error",
                    });
                  }
                })
                .catch(function (error) {
                  console.log(error);
                  vm.inProgress = false;
                });
            } else {
              vm.loadingGeneral.close();
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          });
      }
    },
    comprobarCodigoBarras() {
      if ((this.sectores && this.$cookies.isKey('sectores')) && (this.producto.codigoBarras == "" || this.producto.codigoBarras == " ")) {
        swal({
          title: this.$t("atencion"),
          text: "Está a punto de guardar un producto sin código de barras. ¿Está seguro? Esto sobreescribirá los códigos de barra de los productos equivalentes en los sectores relacionados.",
          showCancelButton: true,
          confirmButtonText: 'Sí, estoy seguro',
          confirmButtonColor: '#3085d6',
          cancelButtonText: `Cancelar`,
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.value) {
            this.saveProducto();
          }
        })
      } else {
        this.saveProducto();
      }
    },
    checkPorcentajeContable() {
      if (!this.tieneDimoni || (parseInt(this.producto.porcentajeContable) + parseInt(this.producto.porcentajeContable2) + parseInt(this.producto.porcentajeContable3) == 100)) {
        return true;
      } else {
        swal({
          title: this.$t("atencion"),
          text: "La distribución del porcentaje tiene que ser del 100%",
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });

        return false;
      }
    },
    async saveProducto() {
      if (this.idProducto) {
        this.editSubproduct();
        this.enableMenu();
      }

      if (this.checkCampos() && this.checkPorcentajeContable()) {
        this.inProgress = true;

        if (!(await this.puedeGuardarConSupraCategoria())) {
          this.inProgress = false;
          return;
        }

        // GUARDAR NOMBRE CATEGORIA
        let nameCatego = "";
        for (let i = 0; i < this.listCategory.length; i++) {
          if (parseInt(this.listCategory[i].id) === parseInt(this.producto.idCategory)) {
            nameCatego = this.listCategory[i].name;
          }
        }

        let config = {
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          params: { nameCatego: nameCatego, jwt: this.$store.getters.jwt }
        };

        let vm = this;
        let controller = this.idProducto ? "editProductById" : "saveProduct";

        let params = {
          idBusiness: this.idBusiness,
          product: this.producto,
          menu: this.platos,
          jwt: this.$store.getters.jwt
        };

        if (!this.mostrarSupraCategorias) {
          params.product = Object.assign({}, this.producto, { idSupraCategory: 0 });
        }

        this.axios
          .post(this.$store.getters.apiUrl + "products/" + controller, params, config)
          .then(function (response) {
            vm.inProgress = false;

            if (!response.data.response) {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error"
              });
              return;
            }

            // MODOS
            if (vm.listModos.length >= 1) {
              vm.saveModos();
            }

            // NOTIFICACION
            if ((!vm.sectores && !vm.$cookies.isKey("sectores")) || vm.idSector == 0) {
              vm.$notify({
                message:
                  vm.$t("producto") +
                  " " +
                  (vm.idProducto ? vm.$t("actualizada") : vm.$t("creada")) +
                  " " +
                  vm.$t("correctamente"),
                icon: "nc-icon nc-check-2",
                timeout: 2000,
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success"
              });
            }

            // SUBPRODUCTO
            if (vm.subproducto.name !== "" && !vm.idProducto && !vm.isRetail) {
              vm.saveSubproducto(response.data.result);
            }

            // RETAIL
            if (!vm.idProducto && vm.isRetail) {
              vm.subproducto = {
                idTag: 0,
                idSupplier: 0,
                idCasa: 0,
                name: vm.producto.nombreProducto,
                xname: "",
                descripcion: vm.producto.descripcion,
                codigoBarras: vm.producto.codigobarras,
                tipo: "Uds.",
                tipoIva: vm.producto.tipoIva,
                descuentoCompra: 0,
                precioCompra: vm.producto.price1,
                precioCompraSinIva:
                  vm.producto.price1 != 0
                    ? vm.producto.price1 / (1 + vm.producto.tipoIva / 100)
                    : 0,
                escandallo: 1,
                stockMinimo: 0.0,
                stockMinimoPartes: 0.0,
                stockOptimo: 0.0,
                color: "amarillo",
                guardarAlmacen: true,
                baja: false,
                idCuenta: "0",
                noMostrarInformeSectores: 0
              };

              vm.saveSubproducto(response.data.result);
            }

            vm.$modal.hide("guardar-o-guardar-replicar");

            // REPLICAR
            if (vm.checkReply) {
              if (!vm.idProducto) {
                vm.producto.xname = vm.producto.nombreProducto;
              }

              // 1. Negocios
              vm.axios
                .get(
                  vm.$store.getters.apiUrl +
                  "categories/getCategoriesGeneralesByBusiness",
                  config
                )
                .then(function (responseCat) {
                  if (!responseCat.data.response) {
                    swal({
                      title: vm.$t("atencion"),
                      text: responseCat.data.message,
                      confirmButtonClass: "btn btn-info btn-fill",
                      type: "error"
                    });
                    return;
                  }

                  vm.listBusinesses = responseCat.data.result;

                  // 2. PLU SOLO SI BUSINESS CENTRAL
                  if (vm.businessCentral) {
                    const plu = vm.producto.PLU1;

                    if (!plu) {
                      console.warn("⚠️ PLU vacío, se omite búsqueda");
                      vm.initializeBusinessPrices();
                      //vm.markExistingBusinesses();   
                      vm.abrirModalReplicar();
                      return;
                    }

                    console.log("🔍 Buscando productos con PLU:", plu);

                    vm.axios
                      .get(
                        vm.$store.getters.apiUrl +
                        "products/getProductsByPLU/" +
                        encodeURIComponent(plu),
                        {
                          params: { jwt: vm.$store.getters.jwt }
                        }
                      )
                      .then(function (res) {
                        const products = res.data.result || [];
                        console.log("📦 Productos encontrados por PLU:", products);

                        vm.listBusinesses.forEach(function (b) {
                          const match = products.find(
                            p => p.establishmentName === b.establishmentName
                          );

                          if (match) {
                            vm.$set(b, "price1", parseFloat(match.price1) || 0);
                            vm.$set(b, "price2", parseFloat(match.price2) || 0);
                            vm.$set(b, "price3", parseFloat(match.price3) || 0);
                            vm.$set(b, "price4", parseFloat(match.price4) || 0);
                            // Guardamos el estado REAL de cada tarifa en ese negocio (BD)
                            vm.$set(b, "selPrice1", !!Number(match.selPrice1));
                            vm.$set(b, "selPrice2", !!Number(match.selPrice2));
                            vm.$set(b, "selPrice3", !!Number(match.selPrice3));
                            vm.$set(b, "selPrice4", !!Number(match.selPrice4));
                            vm.$set(b, "exists", true);

                            // Categoría REAL que ya tiene el producto en este negocio (por id, no por nombre)
                            const idCategoryDestino = match.idCategory ? parseInt(match.idCategory) : null;
                            const matchedCat = idCategoryDestino
                              ? b.categories.find(cat => parseInt(cat.id) === idCategoryDestino)
                              : null;

                            // Si no hay coincidencia conservamos la categoria que
                            // ya venia preseleccionada por el endpoint de negocios.
                            vm.$set(
                              b,
                              "idCategory",
                              matchedCat ? matchedCat.id : b.idCategory || null
                            );

                            // Categoría enlazada REAL que ya tiene el producto en este negocio (Business Central)
                            const idCategoriaEnlazadaDestino = match.idCategoriaEnlazada ? parseInt(match.idCategoriaEnlazada) : null;
                            const matchedCatEnlazada = idCategoriaEnlazadaDestino
                              ? b.categories.find(cat => parseInt(cat.id) === idCategoriaEnlazadaDestino)
                              : null;

                            vm.$set(
                              b,
                              "idCategoriaEnlazada",
                              matchedCatEnlazada ? matchedCatEnlazada.id : ''
                            );
                          } else {
                            vm.$set(b, "exists", false);
                            vm.$set(b, "price1", null);
                            vm.$set(b, "price2", null);
                            vm.$set(b, "price3", null);
                            vm.$set(b, "price4", null);
                            vm.$set(b, "selPrice1", null);
                            vm.$set(b, "selPrice2", null);
                            vm.$set(b, "selPrice3", null);
                            vm.$set(b, "selPrice4", null);
                            // OJO: no se vacia idCategory. El endpoint de negocios ya
                            // preselecciona una categoria valida del TPV destino y
                            // ponerla a null era lo que acababa en idCategory = 0.
                            vm.$set(b, "idCategoriaEnlazada", '');
                          }
                        });
                        vm.initializeBusinessPrices();
                        // vm.markExistingBusinesses(); 
                        vm.abrirModalReplicar();
                      })
                      .catch(function (error) {
                        console.error("Error al obtener productos por PLU:", error);
                        vm.abrirModalReplicar();
                      });
                  } else {
                    vm.abrirModalReplicar();
                  }
                })
                .catch(function (error) {
                  console.error("Error al obtener negocios:", error);
                });
            } else {
              // NO REPLICAR
              if (
                (!vm.sectores && !vm.$cookies.isKey("sectores")) ||
                vm.idSector == 0
              ) {
                if (vm.checkModalReply) {
                  vm.replicarProductoEnCarta();
                } else {
                  if (vm.previousRoute === "diagnostico-carta") {
                    vm.$router.push({
                      name: "diagnostico-carta",
                      params: {
                        idBusiness: vm.idBusiness,
                        idCarta: vm.idCarta
                      }
                    });
                  } else {
                    vm.$router.push({
                      name: "productos",
                      query: { filtro: vm.filtro },
                      params: {
                        idBusiness: vm.idBusiness,
                        idSubproducto: vm.idSubproducto,
                        pag: vm.pag
                      }
                    });
                  }
                }
              } else {
                vm.guardarSectores();
              }
            }
          })
          .catch(function (error) {
            console.log(error);
            vm.inProgress = false;
          });
      }
    },
    saveModos() {
      this.inProgress = true;

      var config = {
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        params: {
          jwt: this.$store.getters.jwt,
        },
      };

      let vm = this;

      let controller;
      //Si es un negocio normal
      controller = "saveModos";

      var params = {
        idTpv: this.idTpv,
        idProduct: this.idProducto,
        listModos: this.listModos,
        jwt: this.$store.getters.jwt,
      };

      this.axios
        .post(
          this.$store.getters.apiUrl + "products/" + controller,
          params,
          config
        )
        .then(function (response) {
          vm.inProgress = false;

          if (response.data.response) {

            if ((vm.sectores && vm.$cookies.isKey("sectores")) || vm.idSector != 0) {
              vm.saveModosSectores();
            }

          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        });
    },

    saveModosSectores() {
      if (this.idSector != 0) {

        let controller = "getBusinessesBySector";

        var config = {
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          params: {
            jwt: this.$store.getters.jwt,
          },
        };

        var params = {
          idBusiness: parseInt(this.idBusiness),
          idSector: this.idSector,
          product: this.producto,
          jwt: this.$store.getters.jwt,
        };

        this.loadingGeneral = Loading.service({ text: this.$t("cargando") });
        let vm = this;
        this.axios
          .post(
            this.$store.getters.apiUrl + "products/" + controller,
            params,
            config
          )
          .then(function (response) {
            vm.inProgress = false;

            if (response.data.response) {
              var config = {
                params: {
                  jwt: vm.$store.getters.jwt,
                },
                headers: { Authorization: "Bearer " + vm.$store.getters.jwt },
              };

              var params = {
                listBusinesses: response.data.result,
                idBusiness: vm.idBusiness,
                producto: vm.producto,
                listModos: vm.listModos,
                jwt: vm.$store.getters.jwt,
              };

              vm.axios
                .post(
                  vm.$store.getters.apiUrl +
                  "products/replyModosByBusiness",
                  params,
                  config
                )
                .then(function (response) {

                  vm.inProgress = false;

                })
                .catch(function (error) {
                  console.log(error);
                  vm.inProgress = false;
                });
            } else {
              vm.loadingGeneral.close();
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          });
      }
    },

    openModalreplymenu() {
      this.$modal.hide("modalReply");

      let listaPlatos2 = [];

      listaPlatos2 = this.listSubproductosPlatos.slice();

      this.listBusinesses.forEach(element => {
        if (element.checked && element.id !== this.idBusiness) {

          element.categories.forEach(c => {
            listaPlatos2.forEach(plato => {
              plato.products.forEach(producto => {
                // console.log(producto);
                if (c.name == producto.nameCategory) {
                  producto.idCategory = c.id;
                }
              });
            });
          });

          element.listaPlatos2 = listaPlatos2;
          this.businessListPlatos.push(JSON.parse(JSON.stringify(element, null, 2)));
        }
      });

      this.$modal.show("modalReplyMenu");
    },

    searchProductInProductCarta(idProduct) {
      var config = {
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        params: {
          idProduct: idProduct,
          jwt: this.$store.getters.jwt,
        },
      };
      let vm = this;

      this.axios
        .get(
          this.$store.getters.apiUrl + "products/searchProductInProductCarta",
          config
        )
        .then(function (response) {
          if (response.data.result.length > 0) {
            vm.tieneProductCarta = true;
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        });
    },

    async replicarProductoEnCarta() {
      if (!(await this.puedeGuardarConSupraCategoria())) {
        return;
      }

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        product: this.mostrarSupraCategorias ? this.producto : Object.assign({}, this.producto, { idSupraCategory: 0 }),
        jwt: this.$store.getters.jwt,
      };
      let vm = this;
      // console.log('Producto para replicar', this.producto);
      vm.axios
        .post(
          vm.$store.getters.apiUrl + "products/replicarEnCarta",
          params,
          config
        )
        .then(function (response) {
          if (vm.previousRoute === "diagnostico-carta") {
            // Si venías de "diagnostico-carta", volvemos a esa ruta
            this.$modal.hide("guardar-o-guardar-replicar");

          } else {
            vm.$router.push({
              name: "productos",
              query: { filtro: vm.filtro },
              params: {
                idBusiness: vm.idBusiness,
                idSubproducto: vm.idSubproducto,
                pag: vm.pag,
              },
            });
            this.$modal.hide("guardar-o-guardar-replicar");

          }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        });
    },

    async replyProduct() {
      if (!(await this.puedeGuardarConSupraCategoria())) {
        return;
      }

      if (this.producto.id != 0) {
        // this.getSubproductsByProductsMenu();
      }
      // console.log( this.listBusinesses);
      if (this.producto.wasMenu) {
        this.listBusinesses = this.businessListPlatos;
      }
      // console.log( this.listBusinesses);

      let vm = this;
      let xbusinesses = new Array();
      this.listBusinesses.forEach(function (business) {
        if (business.checked && String(business.id) !== String(vm.idBusiness)) {
          xbusinesses.push(business);
        }
      });

      if (!this.validarReplicacion(xbusinesses)) {
        return;
      }

      this.loadingGeneral = Loading.service({ text: this.$t("cargando") });

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let productoClonar = Object.assign({}, this.producto, { idCuenta: 0 });
      if (!this.mostrarSupraCategorias) {
        productoClonar.idSupraCategory = 0;
      }

      xbusinesses.forEach((b) => {
        const businessExplicitlyNotBC = (b.isBusinessCentral === false || b.businessCentral === false);

        // Una tarifa solo se excluye si el usuario la ha desmarcado explicitamente
        // o si el negocio no es Business Central. Que la columna no se muestre
        // (showPriceN falso porque el producto tiene precio 0) NO es motivo para
        // excluirla: eso vaciaba las tarifas de los productos de tipo Tarifas.
        for (let i = 1; i <= 4; i++) {
          const columnaVisible = this.businessCentral && this["showPrice" + i];
          const excluir = businessExplicitlyNotBC || b["incluirTarifa" + i] === false;

          // Si la columna no se le ha mostrado al usuario, no mandamos precio:
          // que herede el del producto origen en lugar del que hubiera en destino.
          if ((excluir || !columnaVisible) && b.hasOwnProperty("price" + i)) {
            delete b["price" + i];
          }

          // Mandamos la intencion explicita aunque no venga precio, para que el
          // backend sepa que NO debe activar esa tarifa en ese negocio.
          b["excluirTarifa" + i] = excluir;
        }
      });

      // console.log(this.producto.isMenu);
      // console.log(this.platos);
      // console.log(this.listSubproductosPlatos);


      var params = {
        listBusinesses: xbusinesses,
        idBusiness: this.idBusiness,
        listSubproduct: this.listSubproductosByProducts,
        menu: this.platos,
        isMenu: this.producto.isMenu,
        productosMenu: this.listSubproductosPlatos,
        product: productoClonar,
        jwt: this.$store.getters.jwt,
        subproduct: this.subproducto,
        isBusinessCentral: this.businessCentral,
        tipoProducto: this.tipoProductoBC,
      };

      // Business Central tiene su propio endpoint; el resto sigue por el legacy.
      const endpoint = this.businessCentral
        ? "products/replyProductBC"
        : "products/replyProduct";

      this.axios
        .post(this.$store.getters.apiUrl + endpoint, params, config)
        .then(function (response) {
          vm.inProgress = false;

          vm.loadingGeneral.close();

          if (response.data.response) {
            // Con informe mostramos el resultado y solo volvemos al listado
            // cuando el usuario lo cierra.
            if (response.data.informe && response.data.informe.length) {
              vm.informeReplica = response.data.informe;
              vm.$modal.hide("modalReply");
              vm.$modal.show("modalResultadoReplica");
            } else {
              vm.closeModal();
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          vm.loadingGeneral.close();
          console.log(error);
          vm.inProgress = false;
        });
    },
    getIdTpvByBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          idBusiness: this.idBusiness,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      return this.axios
        .get(this.$store.getters.apiUrl + "general/getTpvIdByBusiness", config)
        .then(function (response) {
          vm.idTpv = response.data;
          vm.cargarCuentasPorIdTpv();
          vm.getModosPorIdTpv();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    closeModal() {
      this.$modal.hide("modalReply");
      this.volverAlListado();
    },

    volverAlListado() {
      this.$router.push({
        name: "productos",
        query: { filtro: this.filtro },
        params: { idBusiness: this.idBusiness, pag: this.pag },
      });
    },

    // Punto unico de entrada al modal de replicar: si no hay ningun otro negocio
    // no tiene sentido abrir la tabla, se muestra un aviso.
    abrirModalReplicar() {
      if (!this.negociosReplicables.length) {
        this.$modal.show("modalSinNegocios");
        return;
      }

      this.cargarFamiliaReplicar();
      this.$modal.show("modalReply");
    },

    cerrarSinNegocios() {
      this.$modal.hide("modalSinNegocios");
      this.volverAlListado();
    },

    cerrarResultadoReplica() {
      this.$modal.hide("modalResultadoReplica");
      this.informeReplica = [];
      this.volverAlListado();
    },

    // Un CON o un SUPLEMENTO arrastra siempre a toda su familia (mismo PLU1).
    // Un Tarifas o un Formatos se replica solo.
    cargarFamiliaReplicar() {
      const tipo = this.tipoProductoBC;
      const plu1 = this.producto.PLU1;

      this.familiaReplicar = [{ tipo: tipo, name: this.producto.nombreProducto }];

      if (!this.businessCentral || !plu1 || tipo === "TARIFAS" || tipo === "FORMATOS") {
        return;
      }

      let vm = this;

      this.axios
        .get(this.$store.getters.apiUrl + "products/getFamiliaProducto", {
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          params: {
            jwt: this.$store.getters.jwt,
            plu1: plu1,
            idBusiness: this.idBusiness,
          },
        })
        .then(function (res) {
          const miembros = (res.data && res.data.result) || [];

          if (miembros.length) {
            vm.familiaReplicar = miembros;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    // No dejamos salir sin categoria: el backend acabaria escribiendo idCategory = 0.
    validarReplicacion(seleccionados) {
      if (!seleccionados.length) {
        swal({
          title: this.$t("atencion"),
          text: this.$t("seleccionaAlMenosUnNegocio"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "warning",
        });
        return false;
      }

      // Si el tipo fija la categoria (CON / SUPLEMENTO) no hay nada que validar:
      // el backend la resuelve por la que tiene el producto en el origen.
      if (this.categoriaFijadaPorTipo) {
        return true;
      }

      const sinCategoria = seleccionados.filter((b) => !b.idCategory);

      if (sinCategoria.length) {
        swal({
          title: this.$t("atencion"),
          text:
            this.$t("faltaCategoriaEnNegocios") +
            " " +
            sinCategoria.map((b) => b.establishmentName).join(", "),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "warning",
        });
        return false;
      }

      return true;
    },
    checkCategory() {
      let check = 0
      this.businessListPlatos.forEach(element => {
        element.listaPlatos2.forEach(plato => {
          plato.products.forEach(producto => {
            if (typeof producto.idCategory == 'undefined') {
              check = 1
            }
          });
        });
      });
      if (check == 1) {
        swal({
          title: this.$t("atencion"),
          text: "Hay productos que no tienen categorías asociadas",
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        this.replyProduct();
      }
    },
    selectAll() {
      if (this.checkSelectAll) {
        this.listBusinesses.forEach(function (business) {
          business.checked = false;
        });
      } else {
        this.listBusinesses.forEach(function (business) {
          business.checked = true;
        });
      }
    },

    initializeBusinessPrices() {
      this.listBusinesses.forEach((business) => {
        const businessExplicitlyNotBC = (business.isBusinessCentral === false || business.businessCentral === false);

        for (let i = 1; i <= 4; i++) {
          const showKey = `showPrice${i}`;
          const priceKey = `price${i}`;
          const selPriceKey = `selPrice${i}`;
          const incluirKey = `incluirTarifa${i}`;

          if (this.businessCentral && this[showKey] && !businessExplicitlyNotBC) {
            if (business[priceKey] === null || business[priceKey] === undefined) {
              business[priceKey] = this.producto[priceKey] || 0;
            }

            // Por defecto, premarcado (mejor desmarcar que marcar).
            // EXCEPCIÓN: si el negocio ya tenía este producto (exists=true),
            // reflejamos el estado real que tiene esa tarifa en BD para ese negocio.
            let valorPorDefecto = true;

            if (business.exists === true && business[selPriceKey] !== null && business[selPriceKey] !== undefined) {
              valorPorDefecto = Boolean(business[selPriceKey]);
            }

            if (business[incluirKey] === undefined) {
              this.$set(business, incluirKey, valorPorDefecto);
            }
          }
        }
      });
    },

    markExistingBusinesses() {
      // Si el negocio ya tiene precios o alguna marca que indique existencia, marcarlo para replicar
      this.listBusinesses.forEach((business) => {
        // Si ya viene marcado explícitamente, respetarlo
        if (business.checked) return;

        // Comprobar campos de precio: si alguno tiene valor distinto de 0, consideramos que el producto existe
        const hasPrice = (business.price1 && Number(business.price1) > 0) || (business.price2 && Number(business.price2) > 0) || (business.price3 && Number(business.price3) > 0) || (business.price4 && Number(business.price4) > 0);
        // Algunos endpoints pueden devolver flags como 'hasProduct' o 'exist'; contemplamos varias posibilidades
        const hasFlag = business.hasProduct || business.exist || business.productExists || false;

        if (hasPrice || hasFlag) {
          business.checked = true;
        }
      });
    },

    getBusinessPrice(business, index) {
      // Return a price number or null if not found
      const key = `price${index}`;

      // Direct field
      if (business[key] !== undefined && business[key] !== null && business[key] !== "") return Number(business[key]);

      // Common nested structures
      if (business.prices && typeof business.prices === 'object') {
        if (business.prices[key] !== undefined && business.prices[key] !== null && business.prices[key] !== "") return Number(business.prices[key]);
        if (business.prices[index] !== undefined && business.prices[index] !== null && business.prices[index] !== "") return Number(business.prices[index]);
      }

      // Look for product entry inside business.products
      if (Array.isArray(business.products)) {
        const p = business.products.find(prod => (prod.id == this.producto.id) || (prod.idProduct == this.producto.id) || (prod.idProductCarta == this.producto.id) || (prod.idProduct == this.producto.idProduct));
        if (p) {
          if (p[key] !== undefined && p[key] !== null && p[key] !== "") return Number(p[key]);
          if (p.price !== undefined && p.price !== null && p.price !== "") return Number(p.price);
          if (p.price1 !== undefined && index === 1 && p.price1 !== null && p.price1 !== "") return Number(p.price1);
        }
      }

      // Some payloads include categories -> products
      if (Array.isArray(business.categories)) {
        for (let c of business.categories) {
          if (Array.isArray(c.products)) {
            const p2 = c.products.find(prod => (prod.id == this.producto.id) || (prod.idProduct == this.producto.id));
            if (p2) {
              if (p2[key] !== undefined && p2[key] !== null && p2[key] !== "") return Number(p2[key]);
              if (p2.price !== undefined && p2.price !== null && p2.price !== "") return Number(p2.price);
              if (p2.price1 !== undefined && index === 1 && p2.price1 !== null && p2.price1 !== "") return Number(p2.price1);
            }
          }
        }
      }

      return null;
    },

    populateBusinessPricesFromData() {
      // Try to extract existing per-business prices from nested structures
      this.listBusinesses.forEach((business) => {
        for (let i = 1; i <= 4; i++) {
          try {
            const val = this.getBusinessPrice(business, i);
            if (val !== null) {
              business[`price${i}`] = Number(val);
            } else {
              // ensure property exists for reactivity
              if (!business.hasOwnProperty(`price${i}`)) business[`price${i}`] = null;
            }
          } catch (e) {
            // ignore
          }
        }
      });
    },

    // displayBusinessPrice removed; using inline fallbacks in template

    displayPriceName(index) {
      // Devuelve el nombre a mostrar para la tarifa: namePriceX si existe, si no y hay precio usar PLU3, si no fallback a 'tarifa'
      const nameKey = `namePrice${index}`;
      const priceKey = `price${index}`;
      const name = this.producto && this.producto[nameKey] ? this.producto[nameKey].toString().trim() : "";

      if (name && name !== "") return name;

      // Si existe precio y PLU3 definido, usar PLU3 como título temporal
      const priceVal = this.producto && this.producto[priceKey] ? Number(this.producto[priceKey]) : 0;
      const plu3 = this.producto && this.producto.PLU3 ? this.producto.PLU3.toString().trim() : "";

      if (plu3 !== "" && priceVal > 0) {
        return plu3;
      }

      return this.$t("tarifa");
    },

    getTotalPrecioCompra(dto) {
      let totalOpcionales = 0;
      let numOpcionales = 0;

      let total = 0;

      let vm = this;
      // console.log(this.listSubproductosByProducts);
      this.listSubproductosByProducts.forEach(function (x) {
        if (x.tipo === "B") {
          total += vm.getPrecioCompra(x, dto);
        }

        if (x.tipo === "O") {
          numOpcionales++;
          totalOpcionales += vm.getPrecioCompra(x, dto);
        }
      });

      if (numOpcionales === 0) {
        return total;
      } else {
        return total + totalOpcionales / numOpcionales;
      }
    },

    getPrecioCompra(producto, dto, partes = null) {
      const partesUsadas = partes !== null ? partes : producto.partes;
      if (producto.escandallo != 0) {
        var coste = (partesUsadas / producto.escandallo) * producto.precioCompra;
        if (producto.dtoCompra != 0) {
          var dtoPrecioSinIva =
            parseFloat(producto.precioCompra / (1 + producto.iva / 100)) *
            (producto.dtoCompra / 100);
          var precioDescuento =
            parseFloat(producto.precioCompra / (1 + producto.iva / 100)) -
            dtoPrecioSinIva;
          var precioDescuentoIVA = precioDescuento * (1 + producto.iva / 100);
          var costeDto = (partesUsadas / producto.escandallo) * precioDescuentoIVA;
        } else {
          var costeDto =
            (partesUsadas / producto.escandallo) *
            parseFloat(producto.precioCompra);
        }
        return dto ? costeDto : coste;
      } else {
        return 0;
      }
    },
    getPrecioCompraTarifas(producto, dto, parte) {
      let partes = 2;

      switch (parte) {
        case 2:
          partes = producto.partes2;
          break;
        case 3:
          partes = producto.partes3;
          break;
        case 4:
          partes = producto.partes4;
          break;
      }

      if (producto.escandallo != 0) {
        var coste =
          (partes / producto.escandallo) * producto.precioCompra;

        if (producto.dtoCompra != 0) {
          var costeDto =
            (partes / producto.escandallo) *
            parseFloat(producto.precioCompra);

          var dtoPrecioSinIva =
            parseFloat(producto.precioCompra / (1 + producto.iva / 100)) *
            (producto.dtoCompra / 100);

          var precioDescuento =
            parseFloat(producto.precioCompra / (1 + producto.iva / 100)) -
            dtoPrecioSinIva;

          var precioDescuentoIVA = precioDescuento * (1 + producto.iva / 100);

          costeDto =
            (partes / producto.escandallo) * precioDescuentoIVA;

          costeDto = costeDto;
        } else {
          var costeDto =
            (partes / producto.escandallo) *
            parseFloat(producto.precioCompra);
        }

        if (dto) {
          return costeDto;
        } else {
          return coste;
        }
      } else {
        return 0;
      }
    },
    getTotalPrecioCompraSinIVA(dto) {
      let totalOpcionales = 0;
      let numOpcionales = 0;

      let total = 0;

      let vm = this;
      this.listSubproductosByProducts.forEach(function (x) {
        if (x.tipo === "B") {
          total += vm.getPrecioCompraSinIVA(x, dto);
        }

        if (x.tipo === "O") {
          numOpcionales++;
          totalOpcionales += vm.getPrecioCompraSinIVA(x, dto);
        }
      });

      if (numOpcionales === 0) {
        return total;
      } else {
        return total + totalOpcionales / numOpcionales;
      }
    },
    getPrecioCompraSinIVA(producto, dto, partes = null) {
      const partesUsadas = partes !== null ? partes : producto.partes;
      if (producto.escandallo != 0) {
        var coste =
          (partesUsadas / producto.escandallo) * producto.precioCompraSinIva;
        if (producto.dtoCompra != 0) {
          var dtoPrecioSinIva =
            parseFloat(producto.precioCompraSinIva / (1 + producto.iva / 100)) *
            (producto.dtoCompra / 100);
          var precioDescuento =
            parseFloat(producto.precioCompraSinIva / (1 + producto.iva / 100)) -
            dtoPrecioSinIva;
          var precioDescuentoIVA = precioDescuento * (1 + producto.iva / 100);
          var costeDto = (partesUsadas / producto.escandallo) * precioDescuentoIVA;
        } else {
          var costeDto =
            (partesUsadas / producto.escandallo) *
            parseFloat(producto.precioCompraSinIva);
        }
        return dto ? costeDto : coste;
      } else {
        return 0;
      }
    },
    getPrecioCompraSinIVATarifas(producto, dto, parte) {
      let partesSinIVA = 2;

      switch (parte) {
        case 2:
          partesSinIVA = producto.partes2;
          break;
        case 3:
          partesSinIVA = producto.partes3;
          break;
        case 4:
          partesSinIVA = producto.partes4;
          break;
      }
      if (producto.escandallo != 0) {
        var coste =
          (partesSinIVA / producto.escandallo) * producto.precioCompraSinIva;

        if (producto.dtoCompra != 0) {
          var costeDto =
            (partesSinIVA / producto.escandallo) *
            parseFloat(producto.precioCompraSinIva);

          var dtoPrecioSinIva =
            parseFloat(producto.precioCompraSinIva / (1 + producto.iva / 100)) *
            (producto.dtoCompra / 100);

          var precioDescuento =
            parseFloat(producto.precioCompraSinIva / (1 + producto.iva / 100)) -
            dtoPrecioSinIva;

          var precioDescuentoIVA = precioDescuento * (1 + producto.iva / 100);

          costeDto =
            (partesSinIVA / producto.escandallo) * precioDescuentoIVA;

          costeDto = costeDto;
        } else {
          var costeDto =
            (partesSinIVA / producto.escandallo) *
            parseFloat(producto.precioCompraSinIva);
        }

        if (dto) {
          return costeDto;
        } else {
          return coste;
        }
      } else {
        return 0;
      }
    },
    calculatePrice(subproduct, iva) {
      if (iva) {
        var newPrice = parseFloat(
          subproduct.precioCompra / ((100 + subproduct.tipoIva) / 100)
        ).toFixed(2);
        subproduct.precioCompraSinIva = newPrice;
      } else {
        subproduct.precioCompra = (
          parseFloat(subproduct.precioCompraSinIva) +
          (parseFloat(subproduct.precioCompraSinIva) * subproduct.tipoIva) / 100
        ).toFixed(2);
      }
    },
    saveSubproducto(idProduct) {
      if (this.checkCamposSubproduct()) {
        this.inProgress = true;

        var config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        let controller = "";

        var params = {
          idBusiness: this.idBusiness,
          subproduct: this.subproducto,
          jwt: this.$store.getters.jwt,
          idProduct: idProduct,
          isRetail: this.isRetail,
          idCategoryProducto: this.producto.idCategory,
        };

        controller = "asociarSubproduct";

        let vm = this;

        this.axios
          .post(
            this.$store.getters.apiUrl + "products/" + controller,
            params,
            config
          )
          .then(function (response) {
            vm.inProgress = false;

            if (response.data.response) {
              let notify = vm.$t("asociacion");
              // vm.$notify({
              //     message: 'Subproducto ' + notify + ' correctamente',
              //     icon: 'nc-icon nc-check-2',
              //     timeout: 2000,
              //     horizontalAlign: 'right',
              //     verticalAlign: 'top',
              //     type: 'success'
              // });

              vm.$modal.hide("modal-crear-subproductos");

              //if (vm.idProducto) {
              vm.getSubproductByProduct();
              //}
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function (error) {
            console.log(error);
            vm.inProgress = false;
          });
      }
    },
    checkCamposSubproduct() {
      if (this.subproducto.name.length > this.subproducto) {
        swal({
          title: this.$t("atencion"),
          text:
            this.$t("laLongitudDelNombreNoPuedeSerMayorDe") +
            this.maxNameSubproducto +
            ".",
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
        return false;
      } else if (
        this.subproducto.name === null ||
        this.subproducto.name.length === 0
      ) {
        swal({
          title: this.$t("atencion"),
          text: this.$t(
            "relleneTodosLosDatosMarcadosConAsteriscoAntesDeEnviar"
          ),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
        return false;
      } else {
        return true;
      }
    },
    modalGuardarEnCarta() {
      swal({
        title: this.$t("pendienteDeConfirmacion"),
        text: this.$t("deseaguardarelproductoencarta"),
        // text:this.$t("Si marca 'No', contionuara el proceso con normalidad. "),
        input: "checkbox",
        inputPlaceholder: this.$t("leidoyacepto"),
        showCancelButton: swal.input ? true : false,
        showConfirmButton: swal.input ? true : false,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: this.$t("si"),
        cancelButtonText: this.$t("no"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          // console.log(swal);

          // console.log("A guardar!");
        } else {
          // console.log(swal);

          this.$router.push({
            name: "productos",
            query: { filtro: this.filtro },
            params: {
              idBusiness: this.idBusiness,
              idSubproducto: this.idSubproducto,
              pag: this.pag,
            },
          });
        }
      });
    },

    //COPY SUB

    showModalCopySub() {
      if (
        this.listcategoriesCopySub.length !== 0 &&
        this.listTipo.length !== 0
      ) {
        swal({
          title: this.$t(
            "estreProcesoBorraraLasMateriasPrimasActualesEnLasCategoriasSeleeccionadasDeLosTiposElegidos"
          ),
          text: this.$t("estaOperacionNoSePuedeDeshacer"),
          type: "info",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: this.$t("aceptarProceso"),
          cancelButtonText: this.$t("cancelar"),
          buttonsStyling: true,
        }).then((result) => {
          if (result.value) {
            this.copySub();
          }
        });
      } else {
        swal({
          title: this.$t("atencion"),
          text: this.$t("necesitasMarcarAlMenosUnTipoYUnaCategoria"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      }
    },
    copySub() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        idProduct: this.idProducto,
        idBusiness: this.idBusiness,
        numSubs: this.producto.numOpcionales,
        listCategories: this.listcategoriesCopySub,
        listTipo: this.listTipo,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "copySub";
      this.axios
        .post(
          this.$store.getters.apiUrl + "products/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.$notify({
              message: vm.$t("materiaPrimaCopiadaCorrectamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });

            vm.$modal.hide("modal-copysub");
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        });
    },

    ordenarSubproductos() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        listSubproduct: this.listSubproductosByProducts,
        idBusiness: this.idBusiness,
        idProduct: this.idProducto,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "updateorderSubproductByProduct";
      this.axios
        .post(
          this.$store.getters.apiUrl + "products/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.$notify({
              message: vm.$t("materiaPrimaOrdenadaCorrectamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });

            vm.$modal.hide("modal-copysub");
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        });
    },

    async clonarProducto() {
      if (!(await this.puedeGuardarConSupraCategoria())) {
        return;
      }

      this.listaPlatos = [];
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        idProduct: this.idProducto,
        producto: this.mostrarSupraCategorias ? this.producto : Object.assign({}, this.producto, { idSupraCategory: 0 }),
        idBusiness: this.idBusiness,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "cloneProduct";
      this.axios
        .post(
          this.$store.getters.apiUrl + "products/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.$notify({
              message: vm.$t("productosCopiadosCorrectamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });

            vm.$modal.hide("modal-copysub");

            vm.$router.push({
              name: "producto",
              params: {
                idBusiness: vm.idBusiness,
                idProducto: response.data.result,
              },
            });
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        });
    },

    //METODOS MENU

    getMenuById() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          idProduct: this.idProducto,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "products/getMenuById", config)
        .then(function (response) {
          if (response.data.response) {

            //Conseguimos los nombres de los platos del menú para la pantalla de edición de platos
            vm.platos[0].nombrePlato = response.data.result.t1;
            vm.platos[1].nombrePlato = response.data.result.t2;
            vm.platos[2].nombrePlato = response.data.result.t3;
            vm.platos[3].nombrePlato = response.data.result.t4;
            vm.platos[4].nombrePlato = response.data.result.t5;
            vm.platos[5].nombrePlato = response.data.result.t6;

            //Si es un menú cerrado
            if (response.data.result.isClosed) {
              vm.isClosed = true;
            }

            if (
              response.data.result.t1 != "" &&
              response.data.result.t1 != null
            ) {
              vm.listaPlatos.push({
                nombrePlato: response.data.result.t1,
                idPlato: 1,
              });

              vm.platoSeleccionado = 1;

            }
            if (
              response.data.result.t2 != "" &&
              response.data.result.t2 != null
            ) {
              vm.listaPlatos.push({
                nombrePlato: response.data.result.t2,
                idPlato: 2,
              });

              if (vm.platoSeleccionado == 0) vm.platoSeleccionado = 2;
            }
            if (
              response.data.result.t3 != "" &&
              response.data.result.t3 != null
            ) {
              vm.listaPlatos.push({
                nombrePlato: response.data.result.t3,
                idPlato: 3,
              });

              if (vm.platoSeleccionado == 0) vm.platoSeleccionado = 3;
            }
            if (
              response.data.result.t4 != "" &&
              response.data.result.t4 != null
            ) {
              vm.listaPlatos.push({
                nombrePlato: response.data.result.t4,
                idPlato: 4,
              });

              if (vm.platoSeleccionado == 0) vm.platoSeleccionado = 4;
            }
            if (
              response.data.result.t5 != "" &&
              response.data.result.t5 != null
            ) {
              vm.listaPlatos.push({
                nombrePlato: response.data.result.t5,
                idPlato: 5,
              });

              if (vm.platoSeleccionado == 0) vm.platoSeleccionado = 5;
            }
            if (
              response.data.result.t6 != "" &&
              response.data.result.t6 != null
            ) {
              vm.listaPlatos.push({
                nombrePlato: response.data.result.t6,
                idPlato: 6,
              });

              if (vm.platoSeleccionado == 0) vm.platoSeleccionado = 6;
            }

            //Dependiendo de si es cerrado o no conseguimos los productos que componen el menú de una forma u otra

            if (vm.isClosed) {
              vm.getProductsMenuCerrado();
            } else {
              vm.getProductosByPlato();
            }

          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },
    cambiarTipoMenu() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        idProduct: this.idProducto,
        idBusiness: this.idBusiness,
        type: this.isClosed
      };

      let controller = "changeMenuType", vm = this;

      this.axios
        .post(
          this.$store.getters.apiUrl + "products/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {

            vm.$notify({
              message:
                "Tipo" +
                " actualizado " + vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });

            if (vm.isClosed) {
              vm.getProductsMenuCerrado();
            }


          } else {
            swal({
              title: `Atención`,
              text: "Ocurrió un problema al cambiar el tipo de menú",
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          //vm.inProgress = false;
        });
    },
    enableMenu() {
      var enable = 0;
      var baja = 0;
      var fec_update = new Date().getTime() / 1000;

      if (this.producto.isMenu == true) {
        enable = 1;
      }

      if (this.producto.baja == true) {
        baja = 1;
      }

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        producto: this.producto,
        idBusiness: this.idBusiness,
        jwt: this.$store.getters.jwt,
        idProduct: this.idProducto,
        isMenu: enable,
        isBaja: baja,
        xupdate: fec_update,
        menu: this.platos,
      };

      let vm = this;

      if (this.producto.isMenu != this.producto.wasMenu) {

        let controller = "enableMenu";
        return this.axios
          .post(
            this.$store.getters.apiUrl + "products/" + controller,
            params,
            config
          )
          .then(function (response) {
            if (response.data.response) {
              /*let notify = "actualizado";
              vm.$notify({
                message: "Producto " + notify + " correctamente",
                icon: "nc-icon nc-check-2",
                timeout: 2000,
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success",
              });*/

            } else {
              swal({
                title: `Atención`,
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function (error) {
            console.log(error);
            //vm.inProgress = false;
          });
      } else {
        return Promise.resolve();
      }
    },

    categoriesMenuShow(menu) {
      let indice = -1;

      for (let i = 0; i < this.listaPlatos.length; i++) {
        if (this.listaPlatos[i].idPlato == menu.idPlato) {
          indice = i;
          break;
        }
      }

      if (indice == -1 && menu.nombrePlato != "" && menu.nombrePlato != null) {
        if (menu.idPlato == 1) {
          this.listaPlatos.splice(0, 0, menu);
        }
        if (menu.idPlato == 2) {
          this.listaPlatos.splice(1, 0, menu);
        }
        if (menu.idPlato == 3) {
          this.listaPlatos.splice(2, 0, menu);
        }
        if (menu.idPlato == 4) {
          this.listaPlatos.splice(3, 0, menu);
        }
        if (menu.idPlato == 5) {
          this.listaPlatos.splice(4, 0, menu);
        }
        if (menu.idPlato == 6) {
          this.listaPlatos.splice(5, 0, menu);
        }
      } else if (menu.nombrePlato != null) {
        this.listaPlatos[indice].nombrePlato = menu.nombrePlato;

        if (this.listaPlatos[indice].nombrePlato == "") {
          this.listaPlatos.splice(indice, 1);
        }
      }

      this.listaPlatos.sort(function (a, b) {
        if (a.idPlato > b.idPlato) {
          return 1;
        }
        if (a.idPlato < b.idPlato) {
          return -1;
        }
        return 0;
      });

      this.platoSeleccionado = this.listaPlatos[0].idPlato;
    },
    cambiarOrdenProductoMenuCerrado(producto) {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      var params = {
        idDetalle: producto.id_menudet,
        n_plato: producto.n_plato,
        idProductMenu: this.idProducto,
        idBusiness: this.idBusiness,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "cambiarOrdenProductoMenuCerrado";
      this.axios
        .post(
          this.$store.getters.apiUrl + "products/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.$notify({
              message:
                vm.$t("orden") +
                " " +
                vm.$t("actualizado") +
                " " +
                vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });

            vm.listProductosTodos = [];
            vm.productoSeleccionado = null;

            vm.getProductsMenuCerrado();

          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        });
    },
    eliminarProductoMenuCerrado(idDetalle) {

      if (idDetalle != 0) {
        var config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        var params = {
          idDetalle: idDetalle,
          idProductMenu: this.idProducto,
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        };

        let vm = this;
        let controller = "eliminarProductMenuCerrado";
        this.axios
          .post(
            this.$store.getters.apiUrl + "products/" + controller,
            params,
            config
          )
          .then(function (response) {
            if (response.data.response) {
              vm.$notify({
                message:
                  vm.$t("producto") +
                  " " +
                  vm.$t("eliminado") +
                  " " +
                  vm.$t("correctamente"),
                icon: "nc-icon nc-check-2",
                timeout: 2000,
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success",
              });

              vm.listProductosTodos = [];
              vm.productoSeleccionado = null;

              vm.getProductsMenuCerrado();
              vm.getSubproductsByProductsMenu();
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function (error) {
            console.log(error);
            vm.inProgress = false;
          });
      }
    },
    eliminarProductoDePlato(idProduct) {
      swal({
        title: this.$t(
          "estaSeguroDeQueQuiereDesvincularEsteProductoDelPlatoSeleccionado"
        ),
        text: this.$t("dejaraDeFormarParteDelMenuDeFormaInstantanea"),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: this.$t("siEstoySeguro"),
        cancelButtonText: this.$t("cancelar"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          if (idProduct != 0) {
            var config = {
              params: {
                jwt: this.$store.getters.jwt,
              },
              headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            var params = {
              idProduct: idProduct,
              n_plato: this.platoSeleccionado,
              idProductMenu: this.idProducto,
              idBusiness: this.idBusiness,
              jwt: this.$store.getters.jwt,
            };

            let vm = this;
            let controller = "eliminarProductPlato";
            this.axios
              .post(
                this.$store.getters.apiUrl + "products/" + controller,
                params,
                config
              )
              .then(function (response) {

                if (vm.producto.id != 0) {

                  vm.getSubproductsByProductsMenu();

                }
                if (response.data.response) {
                  vm.$notify({
                    message:
                      vm.$t("producto") +
                      " " +
                      vm.$t("eliminado") +
                      " " +
                      vm.$t("correctamente"),
                    icon: "nc-icon nc-check-2",
                    timeout: 2000,
                    horizontalAlign: "right",
                    verticalAlign: "top",
                    type: "success",
                  });
                  vm.listProductosPlatoId = [];
                  vm.listProductosTodos = [];
                  vm.productoSeleccionado = null;

                  vm.getProductosByPlato();


                } else {
                  swal({
                    title: vm.$t("atencion"),
                    text: response.data.message,
                    confirmButtonClass: "btn btn-info btn-fill",
                    type: "error",
                  });
                }
              })
              .catch(function (error) {
                console.log(error);
                vm.inProgress = false;
              });
          }
        }
      });
    },
    getProductsMenuCerrado() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          idProductMenu: this.idProducto,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;

      this.axios
        .get(this.$store.getters.apiUrl + "products/getProductsMenuCerrado", config)
        .then(function (response) {
          if (response.data.response) {
            vm.listProductosPlato = response.data.result;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getProductosByPlato() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          n_plato: this.platoSeleccionado,
          idProductMenu: this.idProducto,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;

      this.axios
        .get(this.$store.getters.apiUrl + "products/getProductsByPlato", config)
        .then(function (response) {
          if (response.data.response) {
            // Dedupe por id (la tabla usa :key="prod.id")
            const vistos = new Set();
            vm.listProductosPlato = (response.data.result || []).filter((prod) => {
              if (vistos.has(prod.id)) return false;
              vistos.add(prod.id);
              return true;
            });
            // Reasignar, NO acumular: antes hacía push en cada alta/baja y el array
            // crecía con ids repetidos, dejando el filtro includes() inconsistente.
            vm.listProductosPlatoId = vm.listProductosPlato.map((prod) => prod.id);
            // Quitar de la lista de búsqueda los que ya están en el plato
            const idsPlato = new Set(vm.listProductosPlatoId);
            vm.listProductosTodos = (vm.listProductosTodos || []).filter((p) => !idsPlato.has(p.id));
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    searchProductoMenuCerrado(query) {
      // Debounce: no lanzar una petición por cada tecla
      clearTimeout(this._searchTimerCerrado);
      const q = (query || "").trim();
      // Invalidar respuestas en vuelo cuanto antes
      this._searchSeqCerrado = (this._searchSeqCerrado || 0) + 1;
      this.tarifaProductMenu = 0;

      if (q === "") {
        this.loadingProductos = false;
        this.listProductosTodos = [];
        return;
      }

      this.loadingProductos = true;
      this._searchTimerCerrado = setTimeout(() => this.doSearchProductoMenuCerrado(q), 300);
    },
    doSearchProductoMenuCerrado(query) {
      const seq = (this._searchSeqCerrado = (this._searchSeqCerrado || 0) + 1);
      const controller = "searchProductoMenuCerrado/" + encodeURIComponent(query);
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "products/" + controller, config)
        .then(function (response) {
          // Descartar respuestas obsoletas (llegan desordenadas al teclear rápido)
          if (seq !== vm._searchSeqCerrado) return;
          vm.loadingProductos = false;

          if (response.data.response) {
            // Map por id => red de seguridad contra duplicados aunque la API repita
            const porId = new Map();
            (response.data.result || []).forEach((producto) => {
              porId.set(producto.id, producto);
            });
            vm.listProductosTodos = Array.from(porId.values());
          } else {
            vm.listProductosTodos = [];
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          if (seq !== vm._searchSeqCerrado) return;
          vm.loadingProductos = false;
          console.log(error);
        });
    },
    /*searchProductosByPlato(query) {
       this.listProductosTodos = [];
       this.tarifaProductMenu = 0;
       if (query !== "") {
         const controller = "searchProductosByPlato/" + query;
         var config = {
           params: {
             idBusiness: this.idBusiness,
             jwt: this.$store.getters.jwt,
           },
           headers: { Authorization: "Bearer " + this.$store.getters.jwt },
         };
 
         let vm = this;
         this.axios
           .get(this.$store.getters.apiUrl + "products/" + controller, config)
           .then(function (response) {
             if (response.data.response) {
               response.data.result.forEach((categoria) => {
                 categoria.productos.forEach((producto) => {
                   if (!vm.listProductosPlatoId.includes(producto.id)) {
                     vm.listProductosTodos.push(producto);
                   }
                 });
               });
             } else {
               swal({
                 title: vm.$t("atencion"),
                 text: response.data.message,
                 confirmButtonClass: "btn btn-info btn-fill",
                 type: "error",
               });
             }
           })
           .catch(function (error) {
             console.log(error);
           });
       }
     },*/

    searchProductosByPlato(query) {
      // Debounce: no lanzar una petición por cada tecla
      clearTimeout(this._searchTimer);
      const q = (query || "").trim();
      // Invalidar respuestas en vuelo cuanto antes
      this._searchSeq = (this._searchSeq || 0) + 1;
      this.tarifaProductMenu = 0;

      if (q === "") {
        this.loadingProductos = false;
        this.listProductosTodos = [];
        return;
      }

      this.loadingProductos = true;
      this._searchTimer = setTimeout(() => this.doSearchProductosByPlato(q), 300);
    },
    doSearchProductosByPlato(query) {
      const seq = (this._searchSeq = (this._searchSeq || 0) + 1);
      const controller = "searchProductosByPlato/" + encodeURIComponent(query);
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      // Distinguir SIMPLE / CON / SUPLEMENTO solo aplica con la integracion de
      // Business Central. Si el negocio no la tiene, no se manda el parametro y
      // la API devuelve la respuesta de siempre: la plantilla no pinta etiquetas
      // ni deshabilita nada porque esos campos no vienen.
      if (this.restriccionBusinessCentral) {
        config.params.isBusinessCentral = 1;
      }

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "products/" + controller, config)
        .then(function (response) {
          // Descartar respuestas obsoletas: escribes rápido y la respuesta de "ca"
          // llega después de la de "café". Esta era la causa de que "no salgan
          // productos que sí tengo".
          if (seq !== vm._searchSeq) return;
          vm.loadingProductos = false;

          if (response.data.response) {
            // Set de los ids ya presentes en el plato (más rápido que includes())
            const idsPlato = new Set(vm.listProductosPlatoId);
            // Map por id => sin duplicados aunque la API repita algo
            const porId = new Map();
            (response.data.result || []).forEach((categoria) => {
              (categoria.productos || []).forEach((producto) => {
                if (idsPlato.has(producto.id)) return;      // ya está en el plato
                producto.nombreCategoria = categoria.nombre;
                porId.set(producto.id, producto);
              });
            });
            vm.listProductosTodos = Array.from(porId.values());
          } else {
            vm.listProductosTodos = [];
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          if (seq !== vm._searchSeq) return;
          vm.loadingProductos = false;
          console.log(error);
        });
    },
    onProductoSelect(id) {
      // clearable emite null/undefined al limpiar
      if (id === null || id === undefined || id === "") {
        this.productoSeleccionado = null;
        return;
      }
      const lista = this.opcionesProductos || [];
      const elegido = lista.find((p) => p.id === id) || null;

      // Red de seguridad: un CON o un SUPLEMENTO no puede ser plato de menu.
      // El desplegable ya los deshabilita, esto cubre cualquier otra via.
      if (elegido && elegido.seleccionable === false) {
        this.productoSeleccionado = null;
        return;
      }

      // Los productos de baja SI se dejan pulsar (no llevan :disabled) para poder
      // explicar aqui que hay que hacer. Numier no los reactiva por su cuenta: el
      // alta llega desde Business Central en la siguiente sincronizacion, via
      // updateBasicProductData.
      if (elegido && elegido.activo === false) {
        swal({
          title: this.$t("productoDeBajaTitulo"),
          text: this.$t("productoDeBajaTexto"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "warning",
        });

        this.productoSeleccionado = null;
        return;
      }

      this.productoSeleccionado = elegido;
    },
    anadirProductoAMenu2() {

      if (this.compareVersions(this.versionTpv, "6.3.6.7") >= 0 && (this.productoSeleccionado.selPrice1 || this.productoSeleccionado.selPrice2 || this.productoSeleccionado.selPrice3 || this.productoSeleccionado.selPrice4)) {
        this.openModalMenuTarifaProduct()
      } else {
        this.anadirProductoAMenu();
      }
    },

    anadirProductoAMenu() {


      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      var params = {
        idProduct: this.productoSeleccionado.id,
        idProductMenu: this.idProducto,
        idBusiness: this.idBusiness,
        tarifa: this.tarifaProductMenu,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "addProductToMenu";
      this.axios
        .post(
          this.$store.getters.apiUrl + "products/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.$notify({
              message: "Producto añadido " + vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });

            vm.productoSeleccionado = null;

            //vm.getProductosByPlato();
            vm.getProductsMenuCerrado();
            vm.getSubproductsByProductsMenu();
            vm.tarifaProductMenu = 0
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        });
    },

    anadirProductoAPlato2() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      var params = {
        idProduct: this.productoSeleccionado.id,
        idPlato: this.platoSeleccionado,
        idProductMenu: this.idProducto,
        idBusiness: this.idBusiness,
        tarifa: this.tarifaProductMenu,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "addProductToPlato";
      this.axios
        .post(
          this.$store.getters.apiUrl + "products/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {

            if (vm.producto.id != 0) {

              vm.getSubproductsByProductsMenu();

            }
            vm.$notify({
              message: "Producto añadido " + vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });

            vm.productoSeleccionado = null;

            //vm.getProductosByPlato();
            vm.getProductosByPlato();
            vm.tarifaProductMenu = 0
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        });
    },
    anadirProductoAPlato() {

      if (this.compareVersions(this.versionTpv, "6.3.6.7") >= 0 && (this.productoSeleccionado.selPrice1 || this.productoSeleccionado.selPrice2 || this.productoSeleccionado.selPrice3 || this.productoSeleccionado.selPrice4)) {
        this.openModalMenuTarifaProduct()
      } else {
        this.anadirProductoAPlato2();
      }
    },

    guardarProductoMenuTarifa() {
      this.cerrarModalProductTarifaMenu();
      this.anadirProductoAPlato2()
    },

    guardarProductoMenuTarifaCerrado() {
      this.cerrarModalProductTarifaMenu();
      this.anadirProductoAPlato2()
    },

    handleSave() {
      // console.log('handleSave called');
      if (this.tieneProductCarta) {
        // console.log('Producto en carta, abriendo el modal');
        this.openModalGuardarOguardarReplicar(); // Abre el modal si el producto está en carta
      } else {
        // console.log('No hay producto en carta, guardando automáticamente');
        this.saveProducto(); // Guarda directamente si no está en carta
      }
    },

    guardarYreplicarProductoEnCarta() {
      // console.log('guardarYreplicarProductoEnCarta called');
      this.saveProducto();
      this.replicarProductoEnCarta();
    },

    compareVersions(v1, v2) {
      // Convertir siempre a string y controlar null/undefined
      const v1Str = v1 == null ? '0.0.0' : String(v1);
      const v2Str = v2 == null ? '0.0.0' : String(v2);

      const v1Parts = v1Str.split('.').map(n => parseInt(n) || 0);
      const v2Parts = v2Str.split('.').map(n => parseInt(n) || 0);

      for (let i = 0; i < Math.max(v1Parts.length, v2Parts.length); i++) {
        const v1Part = v1Parts[i] || 0;
        const v2Part = v2Parts[i] || 0;

        if (v1Part > v2Part) return 1;
        if (v1Part < v2Part) return -1;
      }

      return 0;
    },

    async insertarProductoEnCarta() {
      // console.log("insertarProductoEnCarta - Mostrar modal sin guardar");

      if (!this.checkCampos() || !this.checkPorcentajeContable()) {
        return;
      }

      if (!(await this.puedeGuardarConSupraCategoria())) {
        return;
      }

      // Preparar el contexto de guardado para usar después de que confirme en el modal
      this.pendingProductSaveContext = {
        nameCatego: "",
        config: {
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          params: {
            jwt: this.$store.getters.jwt,
          },
        },
        controller: this.idProducto ? "editProductById" : "saveProduct",
        params: {
          idBusiness: this.idBusiness,
          product: JSON.parse(JSON.stringify(this.producto)),
          menu: this.platos,
          jwt: this.$store.getters.jwt,
        },
      };

      // Obtener el nombre de la categoría
      for (let i = 0; i < this.listCategory.length; i++) {
        if (
          parseInt(this.listCategory[i].id) ===
          parseInt(this.producto.idCategory)
        ) {
          this.pendingProductSaveContext.nameCatego = this.listCategory[i].name;
          break;
        }
      }
      this.pendingProductSaveContext.config.params.nameCatego = this.pendingProductSaveContext.nameCatego;

      // Mostrar modal para seleccionar categoría (sin guardar aún)
      this.cartaProductoData = {
        product: this.producto,
        idTpv: this.idTpv,
      };
      this.obtenerCategoriesYMostrarModalSeleccion();
    },

    tieneBusinessCentral() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "general/getRestrictionsByUser",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            for (let i = 0; i < response.data.result.length; i++) {

              switch (response.data.result[i].idRestriction) {
                case "76":
                  vm.businessCentral = true;
                  break;
              }
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getCompanies() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt
        },
        headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
      };

      let vm = this;
      return this.axios.get(this.$store.getters.apiUrl + "general/getCompaniesByUser", config)
        .then(function (response) {

          if (!vm.idCompany) {
            vm.idCompany = response.data.result[0].id;

            vm.getCompanyConfigs();
          }

        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getCompanyConfigs() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          idCompany: this.idCompany
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      let vm = this;
      return this.axios
        .get(
          this.$store.getters.apiUrl + "general/getCompanyConfigs",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.companyConfigs = response.data.result;

            vm.companyConfigs.forEach(function (x) {
              if (x.idConfig == "134") {
                vm.restriccionBusinessCentral = true;
              }
            });


          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    // Mostrar modal de selección de categorias de la CARTA y opciones de insertar con seleccioando / omitir / cancelar
    obtenerCategoriesYMostrarModalSeleccion() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          idBusiness: this.idBusiness,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "delivery/getCategoriesCarta", config)
        .then(function (response) {
          if (response.data.response || response.data.result) {
            vm.listCategoriesCarta = (response.data.result || []).sort((a, b) => {
              return a.nombre.localeCompare(b.nombre);
            });
            vm.selectedCategoriaCartaId = null;
            vm.$modal.show("modal-select-categoria-carta");
          } else {
            // Sin categorias
            vm.crearProductoSinCategoria();
          }
        })
        .catch(function (error) {
          console.log(error);
          swal({
            title: vm.$t("atencion"),
            text: vm.$t("error_general"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });
        });
    },

    cerrarModalSelectCategoria() {
      this.$modal.hide("modal-select-categoria-carta");
      this.selectedCategoriaCartaId = null;
      this.listCategoriesCarta = [];
      this.cartaProductoData = null;
      this.pendingProductSaveContext = null;
    },

    crearProductoSinCategoria() {
      if (!this.cartaProductoData) {
        return;
      }
      this.realizarInsertarEnCarta(null);
    },

    crearProductoConCategoria() {
      if (!this.cartaProductoData || !this.selectedCategoriaCartaId) {
        return;
      }
      this.realizarInsertarEnCarta(this.selectedCategoriaCartaId);
    },

    realizarInsertarEnCarta(idCategoryCarta) {
      if (!this.pendingProductSaveContext) {
        swal({
          title: this.$t("atencion"),
          text: this.$t("error_general"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
        return;
      }

      let vm = this;
      this.inProgress = true;

      // Si es producto existente, editar subproductos y menú AHORA (cuando confirma) y esperar a que se resuelvan
      let preparePromises = [];
      if (this.idProducto) {
        preparePromises.push(this.editSubproduct());
        preparePromises.push(this.enableMenu());
      }

      // Esperar a que se completen editSubproduct y enableMenu, luego guardar el producto
      Promise.all(preparePromises).then(() => {
        vm.axios
          .post(
            vm.$store.getters.apiUrl + "products/" + vm.pendingProductSaveContext.controller,
            vm.pendingProductSaveContext.params,
            vm.pendingProductSaveContext.config
          )
          .then(function (response) {
            if (response.data.response) {
              // Producto guardado exitosamente
              const idProduct = response.data.result;
              vm.producto.id = idProduct;

              // Guardar modos si existen
              if (vm.listModos.length >= 1) {
                vm.saveModos();
              }

              // Guardar subproductos
              if (vm.subproducto.name !== "" && !vm.idProducto && !vm.isRetail) {
                vm.saveSubproducto(response.data.result);
              }

              if (!vm.idProducto && vm.isRetail) {
                vm.subproducto = {
                  idTag: 0,
                  idSupplier: 0,
                  idCasa: 0,
                  name: vm.producto.nombreProducto,
                  xname: "",
                  descripcion: vm.producto.descripcion,
                  codigoBarras: vm.producto.codigobarras,
                  tipo: "Uds.",
                  tipoIva: vm.producto.tipoIva,
                  descuentoCompra: 0,
                  precioCompra: vm.producto.price1,
                  precioCompraSinIva: vm.producto.price1 != 0 ? (vm.producto.price1 / (1 + (vm.producto.tipoIva / 100))) : 0,
                  escandallo: 1,
                  stockMinimo: 0.0,
                  stockMinimoPartes: 0.0,
                  stockOptimo: 0.0,
                  color: "amarillo",
                  guardarAlmacen: true,
                  baja: false,
                  idCuenta: "0",
                  noMostrarInformeSectores: 0,
                };
                vm.saveSubproducto(response.data.result);
              }

              // Mostrar notificación de producto guardado
              if (
                (!vm.sectores && !vm.$cookies.isKey("sectores")) ||
                vm.idSector == 0
              ) {
                let notify = vm.idProducto
                  ? vm.$t("actualizada")
                  : vm.$t("creada");

                vm.$notify({
                  message:
                    vm.$t("producto") +
                    " " +
                    notify +
                    " " +
                    vm.$t("correctamente"),
                  icon: "nc-icon nc-check-2",
                  timeout: 2000,
                  horizontalAlign: "right",
                  verticalAlign: "top",
                  type: "success",
                });
              }

              // Ahora insertar en carta
              var config = {
                headers: { Authorization: "Bearer " + vm.$store.getters.jwt },
                params: {
                  jwt: vm.$store.getters.jwt,
                },
              };

              var paramsCarta = {
                product: vm.producto,
                idTpv: vm.cartaProductoData.idTpv,
                jwt: vm.$store.getters.jwt,
              };

              if (idCategoryCarta !== null && idCategoryCarta !== undefined) {
                paramsCarta.idCategoryCarta = idCategoryCarta;
              }

              vm.axios
                .post(
                  vm.$store.getters.apiUrl + "products/insertarEnCarta",
                  paramsCarta,
                  config
                )
                .then(function (responseCarta) {
                  vm.inProgress = false;
                  vm.$modal.hide("modal-select-categoria-carta");
                  vm.selectedCategoriaCartaId = null;
                  vm.listCategoriesCarta = [];
                  vm.cartaProductoData = null;
                  vm.pendingProductSaveContext = null;

                  if (responseCarta.data.success) {
                    vm.$notify({
                      message: vm.$t("producto_insertado_carta_correctamente"),
                      icon: "nc-icon nc-check-2",
                      timeout: 2000,
                      horizontalAlign: "right",
                      verticalAlign: "top",
                      type: "success",
                    });

                    if (vm.checkReply) {
                      if (!vm.idProducto) {
                        vm.producto.xname = vm.producto.nombreProducto;
                      }

                      vm.axios
                        .get(
                          vm.$store.getters.apiUrl +
                          "categories/getCategoriesGeneralesByBusiness",
                          config
                        )
                        .then(function (response) {
                          if (response.data.response) {
                            vm.listBusinesses = response.data.result;
                            // DEBUG: volcar datos para entender por qué no toma los precios por negocio
                            // debug logs removed
                            if (typeof vm.populateBusinessPricesFromData === 'function') vm.populateBusinessPricesFromData();
                            if (typeof vm.markExistingBusinesses === 'function') vm.markExistingBusinesses();
                            vm.initializeBusinessPrices();
                            vm.abrirModalReplicar();
                          } else {
                            swal({
                              title: vm.$t("atencion"),
                              text: response.data.message,
                              confirmButtonClass: "btn btn-info btn-fill",
                              type: "error",
                            });
                          }
                        });
                    } else {
                      if (
                        (!vm.sectores && !vm.$cookies.isKey("sectores")) ||
                        vm.idSector == 0
                      ) {
                        if (vm.checkModalReply) {
                          vm.replicarProductoEnCarta();
                        } else {
                          if (vm.previousRoute === "diagnostico-carta") {
                            vm.$router.push({
                              name: "diagnostico-carta",
                              params: {
                                idBusiness: vm.idBusiness,
                                idCarta: vm.idCarta,
                              },
                            });
                          } else {
                            vm.$router.push({
                              name: "productos",
                              query: { filtro: vm.filtro },
                              params: {
                                idBusiness: vm.idBusiness,
                                idSubproducto: vm.idSubproducto,
                                pag: vm.pag,
                              },
                            });
                          }
                        }
                      } else {
                        vm.guardarSectores();
                      }
                    }
                  } else {
                    swal({
                      title: vm.$t("atencion"),
                      text: responseCarta.data.message || vm.$t("error_insertar_carta"),
                      confirmButtonClass: "btn btn-info btn-fill",
                      type: "error",
                    });
                    vm.inProgress = false;
                  }
                })
                .catch(function (error) {
                  console.log(error);
                  vm.inProgress = false;
                  swal({
                    title: vm.$t("atencion"),
                    text: vm.$t("error_insertar_carta"),
                    confirmButtonClass: "btn btn-info btn-fill",
                    type: "error",
                  });
                });
            } else {
              vm.inProgress = false;
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function (error) {
            console.log(error);
            vm.inProgress = false;
            swal({
              title: vm.$t("atencion"),
              text: vm.$t("error_general"),
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          });
      }); // Cierre del Promise.all
    }
  },



};

</script>

<style scoped>
/* Buscador de productos para platos de menu: un producto de Business Central
   puede aparecer 2 o 3 veces con el mismo nombre (base + CON + SUPLEMENTO),
   asi que se etiqueta cada uno y solo se deja elegir el producto en si. */
.opcion-plato {
  display: flex;
  align-items: center;
  gap: 8px;
}

.opcion-plato__nombre {
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
}

.opcion-plato__nombre--baja {
  color: #a0a4ab;
}

.badge-estado-producto {
  flex: 0 0 auto;
  padding: 1px 7px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
  line-height: 16px;
  border: 1px solid transparent;
}

.badge-estado-producto--activo {
  background-color: #f2f7f4;
  border-color: #d6e7dd;
  color: #4a7c62;
}

.badge-estado-producto--baja {
  background-color: #fbf1f1;
  border-color: #f0d7d7;
  color: #b34d4d;
}

.badge-tipo-producto {
  flex: 0 0 auto;
  padding: 1px 7px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.3px;
  line-height: 16px;
  background-color: #eef0f2;
  color: #6c757d;
}

.badge-tipo-producto--simple,
.badge-tipo-producto--tarifas,
.badge-tipo-producto--formatos {
  background-color: #e3f4ee;
  color: #1a9e78;
}

.badge-tipo-producto--con {
  background-color: #fdf0e0;
  color: #c77c19;
}

.badge-tipo-producto--suplemento {
  background-color: #f0e9fa;
  color: #7a52b3;
}

.card {
  padding: 15px;
}

.btnReplicar:disabled {
  background-color: #007bff;
  border-color: #447df7;
}

.btnNoReplicar:disabled {
  background-color: #dd4b39;
  border-color: #dd4b39;
}

.button-plus-variacion {
  background-color: red;
  color: white;
}

.colorWrap {
  width: 50px;
  height: 50px;
  border: 1px solid #888;
  border-radius: 3px;
  float: right;
  margin-left: 10px;
  cursor: pointer;
}

.wrapperTitleImpresion {
  background-color: rgb(22, 162, 170);
  color: white;
  font-weight: bold;
  padding: 5px 15px;
  margin-top: 10px;
}

.select-account {
  padding-right: 2px;
  width: 400px;
}

.updateAlert {
  background-color: rgba(255, 208, 0, 0.423);
  color: rgb(137, 113, 3);
  border-radius: 8%;
  font-size: 16px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  padding-block: 2%;
}

.updateAlert:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}

.extraAverageInfo {
  display: block;
  width: 100%;
  font-size: 16px;
  padding: 15px;
  position: relative;
  text-align: justify;
}

.precautionAlert {
  background-color: rgba(255, 208, 0, 0.8);
  color: rgb(137, 113, 3);
  border-radius: 12px;
  font-size: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  transition: box-shadow 0.3s ease, transform 0.3s ease;
  padding: 15px;
  margin: 15px 0;
  position: relative;
}

.precautionAlert:hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
  transform: translateY(-2px);
}

.precautionAlert .alertIcon {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
}

.updateAlert .alertText {
  margin-left: 40px;
}

.applyExtraAverage {
  font-size: 16px;
  display: flex;
  align-items: center;
  margin: 1% 0;
}

.applyExtraAverage input {
  margin-right: 8px;
  transform: translateY(2px);
}

.calculateIcon {
  border: none;
  border-radius: 10%;
  margin-left: 5px;
  background-color: #101256;
  color: #fff;
  transition: color 0.3s ease;
  align-items: center;
  transform: translateY(2px);
}

.calculateIcon:hover {
  background-color: #1E22AF;
  color: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/pages/Widgets/Productos/ProductoForm.vue